/*
 * Auto-generated by 'tinker/scripts/update-nz-schools-list.ts'
 * Do not edit manually
 */

import { IMohSchool } from '../../../../transaction/moh/moh';
import { MohSchoolException } from './moh-capitation-bands';

export const NZ_SCHOOLS: IMohSchool[] = [
  { schoolNumber: MohSchoolException.NotEnrolled, schoolName: 'Not Enrolled' },
  {
    schoolNumber: MohSchoolException.SchoolNotListed,
    schoolName: 'School Not Listed/No EQI',
  },
  { schoolNumber: 1, schoolName: `Te Kura o Te Kao`, eqiNumber: 533 },
  { schoolNumber: 2, schoolName: `Taipa Area School`, eqiNumber: 530 },
  { schoolNumber: 3, schoolName: `Kaitaia College`, eqiNumber: 522 },
  { schoolNumber: 4, schoolName: `Whangaroa College`, eqiNumber: 540 },
  { schoolNumber: 5, schoolName: `Kerikeri High School`, eqiNumber: 463 },
  { schoolNumber: 6, schoolName: `Broadwood Area School`, eqiNumber: 558 },
  { schoolNumber: 7, schoolName: `Okaihau College`, eqiNumber: 516 },
  { schoolNumber: 8, schoolName: `Bay of Islands College`, eqiNumber: 530 },
  { schoolNumber: 9, schoolName: `Northland College`, eqiNumber: 552 },
  { schoolNumber: 10, schoolName: `Te Kura Taumata o Panguru`, eqiNumber: 542 },
  { schoolNumber: 11, schoolName: `Opononi Area School`, eqiNumber: 537 },
  { schoolNumber: 12, schoolName: `Tauraroa Area School`, eqiNumber: 477 },
  { schoolNumber: 13, schoolName: `Te Kamo High School`, eqiNumber: 508 },
  { schoolNumber: 14, schoolName: `Tikipunga High School`, eqiNumber: 560 },
  {
    schoolNumber: 15,
    schoolName: `Whangārei Boys' High School`,
    eqiNumber: 474,
  },
  {
    schoolNumber: 16,
    schoolName: `Whangārei Girls’ High School`,
    eqiNumber: 471,
  },
  {
    schoolNumber: 17,
    schoolName: `Pompallier Catholic College`,
    eqiNumber: 424,
  },
  { schoolNumber: 18, schoolName: `Mangakahia Area School`, eqiNumber: 560 },
  { schoolNumber: 19, schoolName: `Dargaville High School`, eqiNumber: 515 },
  { schoolNumber: 20, schoolName: `Bream Bay College`, eqiNumber: 482 },
  { schoolNumber: 21, schoolName: `Otamatea High School`, eqiNumber: 480 },
  { schoolNumber: 22, schoolName: `Ruawai College`, eqiNumber: 526 },
  { schoolNumber: 23, schoolName: `Rodney College`, eqiNumber: 489 },
  { schoolNumber: 24, schoolName: `Mahurangi College`, eqiNumber: 441 },
  { schoolNumber: 25, schoolName: `Orewa College`, eqiNumber: 432 },
  { schoolNumber: 26, schoolName: `Kaipara College`, eqiNumber: 460 },
  { schoolNumber: 27, schoolName: `Long Bay College`, eqiNumber: 422 },
  { schoolNumber: 28, schoolName: `Rangitoto College`, eqiNumber: 397 },
  { schoolNumber: 30, schoolName: `Glenfield College`, eqiNumber: 466 },
  { schoolNumber: 31, schoolName: `Birkenhead College`, eqiNumber: 464 },
  { schoolNumber: 32, schoolName: `Northcote College`, eqiNumber: 428 },
  { schoolNumber: 35, schoolName: `Carmel College`, eqiNumber: 382 },
  { schoolNumber: 36, schoolName: `Takapuna Grammar School`, eqiNumber: 393 },
  { schoolNumber: 37, schoolName: `Westlake Boys High School`, eqiNumber: 399 },
  {
    schoolNumber: 38,
    schoolName: `Westlake Girls' High School`,
    eqiNumber: 403,
  },
  { schoolNumber: 39, schoolName: `Rosmini College`, eqiNumber: 387 },
  { schoolNumber: 40, schoolName: `Rutherford College`, eqiNumber: 459 },
  { schoolNumber: 41, schoolName: `Macleans College`, eqiNumber: 385 },
  { schoolNumber: 42, schoolName: `Green Bay High School`, eqiNumber: 430 },
  { schoolNumber: 43, schoolName: `Massey High School`, eqiNumber: 486 },
  { schoolNumber: 44, schoolName: `Waitakere College`, eqiNumber: 480 },
  { schoolNumber: 45, schoolName: `Henderson High School`, eqiNumber: 481 },
  { schoolNumber: 46, schoolName: `Liston College`, eqiNumber: 414 },
  {
    schoolNumber: 47,
    schoolName: `St Dominic's Catholic College (Henderson)`,
    eqiNumber: 423,
  },
  {
    schoolNumber: 48,
    schoolName: `Western Springs College-Ngā Puna o Waiōrea`,
    eqiNumber: 422,
  },
  { schoolNumber: 49, schoolName: `Selwyn College`, eqiNumber: 411 },
  {
    schoolNumber: 50,
    schoolName: `St Mary's College (Ponsonby)`,
    eqiNumber: 388,
  },
  {
    schoolNumber: 51,
    schoolName: `St Paul's College (Ponsonby)`,
    eqiNumber: 480,
  },
  {
    schoolNumber: 53,
    schoolName: `Auckland Girls' Grammar School`,
    eqiNumber: 485,
  },
  { schoolNumber: 54, schoolName: `Auckland Grammar School`, eqiNumber: 386 },
  { schoolNumber: 57, schoolName: `Tamaki College`, eqiNumber: 526 },
  { schoolNumber: 58, schoolName: `Tangaroa College`, eqiNumber: 521 },
  {
    schoolNumber: 59,
    schoolName: `Sacred Heart College (Auckland)`,
    eqiNumber: 394,
  },
  { schoolNumber: 61, schoolName: `Baradene College`, eqiNumber: 370 },
  {
    schoolNumber: 62,
    schoolName: `St Peter's College (Epsom)`,
    eqiNumber: 383,
  },
  { schoolNumber: 63, schoolName: `Marcellin College`, eqiNumber: 470 },
  {
    schoolNumber: 64,
    schoolName: `Epsom Girls Grammar School`,
    eqiNumber: 402,
  },
  { schoolNumber: 65, schoolName: `Glendowie College`, eqiNumber: 392 },
  { schoolNumber: 69, schoolName: `Mt Albert Grammar School`, eqiNumber: 415 },
  { schoolNumber: 70, schoolName: `Marist College`, eqiNumber: 398 },
  { schoolNumber: 74, schoolName: `Mt Roskill Grammar`, eqiNumber: 444 },
  { schoolNumber: 75, schoolName: `Lynfield College`, eqiNumber: 417 },
  { schoolNumber: 77, schoolName: `Bethlehem College`, eqiNumber: 409 },
  { schoolNumber: 78, schoolName: `Avondale College`, eqiNumber: 439 },
  { schoolNumber: 79, schoolName: `Edgewater College`, eqiNumber: 497 },
  { schoolNumber: 80, schoolName: `Pakuranga College`, eqiNumber: 431 },
  {
    schoolNumber: 82,
    schoolName: `Aidanfield Christian School`,
    eqiNumber: 377,
  },
  { schoolNumber: 83, schoolName: `Kelston Boys' High School`, eqiNumber: 505 },
  { schoolNumber: 84, schoolName: `Kelston Girls' College`, eqiNumber: 507 },
  { schoolNumber: 85, schoolName: `One Tree Hill College`, eqiNumber: 466 },
  { schoolNumber: 86, schoolName: `Onehunga High School`, eqiNumber: 478 },
  { schoolNumber: 87, schoolName: `Howick College`, eqiNumber: 432 },
  { schoolNumber: 88, schoolName: `Otahuhu College`, eqiNumber: 509 },
  { schoolNumber: 90, schoolName: `McAuley High School`, eqiNumber: 483 },
  { schoolNumber: 91, schoolName: `Mangere College`, eqiNumber: 521 },
  {
    schoolNumber: 93,
    schoolName: `Auckland Seventh-Day Adventist H S`,
    eqiNumber: 489,
  },
  { schoolNumber: 94, schoolName: `De La Salle College`, eqiNumber: 484 },
  { schoolNumber: 95, schoolName: `Papatoetoe High School`, eqiNumber: 472 },
  { schoolNumber: 96, schoolName: `Aorere College`, eqiNumber: 497 },
  {
    schoolNumber: 97,
    schoolName: `Sir Edmund Hillary Collegiate Senior School`,
    eqiNumber: 525,
  },
  { schoolNumber: 99, schoolName: `Manurewa High School`, eqiNumber: 508 },
  { schoolNumber: 100, schoolName: `James Cook High School`, eqiNumber: 529 },
  { schoolNumber: 101, schoolName: `Papakura High School`, eqiNumber: 531 },
  { schoolNumber: 102, schoolName: `Rosehill College`, eqiNumber: 473 },
  { schoolNumber: 103, schoolName: `Pukekohe High School`, eqiNumber: 465 },
  { schoolNumber: 104, schoolName: `Wesley College`, eqiNumber: 509 },
  { schoolNumber: 105, schoolName: `Waiuku College`, eqiNumber: 476 },
  { schoolNumber: 106, schoolName: `Tuakau College`, eqiNumber: 485 },
  { schoolNumber: 108, schoolName: `Onewhero Area School`, eqiNumber: 467 },
  { schoolNumber: 109, schoolName: `Coromandel Area School`, eqiNumber: 512 },
  { schoolNumber: 110, schoolName: `Mercury Bay Area School`, eqiNumber: 465 },
  { schoolNumber: 111, schoolName: `Thames High School`, eqiNumber: 489 },
  { schoolNumber: 112, schoolName: `Hauraki Plains College`, eqiNumber: 468 },
  { schoolNumber: 113, schoolName: `Paeroa College`, eqiNumber: 507 },
  { schoolNumber: 114, schoolName: `Waihi College`, eqiNumber: 485 },
  { schoolNumber: 115, schoolName: `Te Kauwhata College`, eqiNumber: 500 },
  { schoolNumber: 116, schoolName: `Te Aroha College`, eqiNumber: 492 },
  { schoolNumber: 117, schoolName: `Katikati College`, eqiNumber: 465 },
  { schoolNumber: 118, schoolName: `Mount Maunganui College`, eqiNumber: 452 },
  { schoolNumber: 119, schoolName: `Huntly College`, eqiNumber: 552 },
  { schoolNumber: 120, schoolName: `Ōtūmoetai College`, eqiNumber: 451 },
  { schoolNumber: 121, schoolName: `Tauranga Boys' College`, eqiNumber: 456 },
  { schoolNumber: 122, schoolName: `Tauranga Girls' College`, eqiNumber: 466 },
  { schoolNumber: 123, schoolName: `Te Puke High School`, eqiNumber: 492 },
  { schoolNumber: 124, schoolName: `Matamata College`, eqiNumber: 479 },
  { schoolNumber: 125, schoolName: `Raglan Area School`, eqiNumber: 453 },
  { schoolNumber: 126, schoolName: `Morrinsville College`, eqiNumber: 481 },
  { schoolNumber: 127, schoolName: `Ngaruawahia High School`, eqiNumber: 534 },
  { schoolNumber: 129, schoolName: `Fairfield College`, eqiNumber: 527 },
  {
    schoolNumber: 131,
    schoolName: `Hamilton Boys' High School`,
    eqiNumber: 429,
  },
  {
    schoolNumber: 132,
    schoolName: `Hamilton Girls' High School`,
    eqiNumber: 463,
  },
  {
    schoolNumber: 133,
    schoolName: `Raphael House Rudolf Steiner Area School`,
    eqiNumber: 400,
  },
  { schoolNumber: 134, schoolName: `Flaxmere College`, eqiNumber: 558 },
  { schoolNumber: 135, schoolName: `Fraser High School`, eqiNumber: 508 },
  {
    schoolNumber: 136,
    schoolName: `St John's College (Hillcrest)`,
    eqiNumber: 428,
  },
  { schoolNumber: 137, schoolName: `Melville High School` },
  { schoolNumber: 138, schoolName: `Hillcrest High School`, eqiNumber: 451 },
  {
    schoolNumber: 139,
    schoolName: `Sacred Heart Girls' College (Ham)`,
    eqiNumber: 439,
  },
  {
    schoolNumber: 140,
    schoolName: `Waikato Diocesan School For Girls`,
    eqiNumber: 391,
  },
  { schoolNumber: 142, schoolName: `Cambridge High School`, eqiNumber: 447 },
  { schoolNumber: 143, schoolName: `Trident High School`, eqiNumber: 496 },
  { schoolNumber: 144, schoolName: `Whakatane High School`, eqiNumber: 475 },
  {
    schoolNumber: 145,
    schoolName: `Rangitaiki College – Te Kura Tuarua o Rangitaiki`,
    eqiNumber: 530,
  },
  { schoolNumber: 146, schoolName: `Te Awamutu College`, eqiNumber: 481 },
  { schoolNumber: 148, schoolName: `Opotiki College`, eqiNumber: 541 },
  {
    schoolNumber: 151,
    schoolName: `Western Heights High School`,
    eqiNumber: 499,
  },
  {
    schoolNumber: 152,
    schoolName: `Rotorua Boys' High School`,
    eqiNumber: 504,
  },
  {
    schoolNumber: 153,
    schoolName: `Rotorua Girls' High School`,
    eqiNumber: 522,
  },
  {
    schoolNumber: 154,
    schoolName: `Rotorua Lakes High School`,
    eqiNumber: 473,
  },
  { schoolNumber: 157, schoolName: `Ōtorohanga College`, eqiNumber: 515 },
  { schoolNumber: 158, schoolName: `Tokoroa High School`, eqiNumber: 525 },
  { schoolNumber: 159, schoolName: `Forest View High School`, eqiNumber: 517 },
  { schoolNumber: 160, schoolName: `Te Kuiti High School`, eqiNumber: 522 },
  { schoolNumber: 161, schoolName: `Benneydale School`, eqiNumber: 559 },
  { schoolNumber: 162, schoolName: `Piopio College`, eqiNumber: 499 },
  { schoolNumber: 164, schoolName: `Reporoa College`, eqiNumber: 519 },
  { schoolNumber: 166, schoolName: `Tauhara College`, eqiNumber: 486 },
  { schoolNumber: 167, schoolName: `Taupo-nui-a-Tia College`, eqiNumber: 463 },
  { schoolNumber: 169, schoolName: `Taumarunui High School`, eqiNumber: 528 },
  { schoolNumber: 170, schoolName: `Waitara High School`, eqiNumber: 524 },
  {
    schoolNumber: 171,
    schoolName: `New Plymouth Boys' High School`,
    eqiNumber: 446,
  },
  {
    schoolNumber: 172,
    schoolName: `New Plymouth Girls' High School`,
    eqiNumber: 447,
  },
  { schoolNumber: 173, schoolName: `Spotswood College`, eqiNumber: 493 },
  {
    schoolNumber: 174,
    schoolName: `Sacred Heart Girls' College (N Plymouth)`,
    eqiNumber: 414,
  },
  {
    schoolNumber: 175,
    schoolName: `Francis Douglas Memorial College`,
    eqiNumber: 418,
  },
  { schoolNumber: 176, schoolName: `Ohura Valley Primary`, eqiNumber: 565 },
  { schoolNumber: 177, schoolName: `Inglewood High School`, eqiNumber: 478 },
  { schoolNumber: 179, schoolName: `Stratford High School`, eqiNumber: 500 },
  {
    schoolNumber: 180,
    schoolName: `Taranaki Diocesan School for Girls`,
    eqiNumber: 461,
  },
  { schoolNumber: 181, schoolName: `Opunake High School`, eqiNumber: 503 },
  { schoolNumber: 183, schoolName: `Ruapehu College`, eqiNumber: 502 },
  { schoolNumber: 185, schoolName: `Patea Area School`, eqiNumber: 541 },
  { schoolNumber: 187, schoolName: `Whanganui City College`, eqiNumber: 547 },
  { schoolNumber: 188, schoolName: `Whanganui Girls' College`, eqiNumber: 493 },
  { schoolNumber: 189, schoolName: `Whanganui High School`, eqiNumber: 482 },
  { schoolNumber: 190, schoolName: `Cullinane College`, eqiNumber: 497 },
  {
    schoolNumber: 191,
    schoolName: `Longburn Adventist College`,
    eqiNumber: 474,
  },
  {
    schoolNumber: 192,
    schoolName: `Whanganui Collegiate School`,
    eqiNumber: 417,
  },
  { schoolNumber: 195, schoolName: `Rangitīkei College`, eqiNumber: 515 },
  { schoolNumber: 196, schoolName: `Nga Tawa Diocesan School`, eqiNumber: 431 },
  { schoolNumber: 197, schoolName: `Feilding High School`, eqiNumber: 472 },
  { schoolNumber: 198, schoolName: `Awatapu College`, eqiNumber: 492 },
  { schoolNumber: 199, schoolName: `Hato Paora College`, eqiNumber: 516 },
  { schoolNumber: 200, schoolName: `Freyberg High School`, eqiNumber: 488 },
  { schoolNumber: 201, schoolName: `Queen Elizabeth College`, eqiNumber: 556 },
  {
    schoolNumber: 202,
    schoolName: `Palmerston North Boys' High School`,
    eqiNumber: 441,
  },
  {
    schoolNumber: 203,
    schoolName: `Palmerston North Girls' High School`,
    eqiNumber: 433,
  },
  {
    schoolNumber: 204,
    schoolName: `St Peter's College (Palmerston North)`,
    eqiNumber: 436,
  },
  { schoolNumber: 205, schoolName: `Manawatū College`, eqiNumber: 528 },
  { schoolNumber: 206, schoolName: `Ngata Memorial College`, eqiNumber: 560 },
  { schoolNumber: 208, schoolName: `Lytton High School`, eqiNumber: 526 },
  {
    schoolNumber: 209,
    schoolName: `Gisborne Boys' High School`,
    eqiNumber: 486,
  },
  {
    schoolNumber: 210,
    schoolName: `Gisborne Girls' High School`,
    eqiNumber: 488,
  },
  { schoolNumber: 211, schoolName: `Campion College`, eqiNumber: 437 },
  { schoolNumber: 212, schoolName: `Tolaga Bay Area School`, eqiNumber: 526 },
  { schoolNumber: 214, schoolName: `Wairoa College`, eqiNumber: 533 },
  { schoolNumber: 215, schoolName: `Taradale High School`, eqiNumber: 448 },
  { schoolNumber: 216, schoolName: `Napier Boys' High School`, eqiNumber: 453 },
  {
    schoolNumber: 217,
    schoolName: `Napier Girls' High School`,
    eqiNumber: 448,
  },
  { schoolNumber: 218, schoolName: `Tamatea High School`, eqiNumber: 532 },
  {
    schoolNumber: 219,
    schoolName: `Sacred Heart College (Napier)`,
    eqiNumber: 446,
  },
  { schoolNumber: 220, schoolName: `William Colenso College`, eqiNumber: 548 },
  { schoolNumber: 221, schoolName: `Te Wharekura o Ruatoki`, eqiNumber: 524 },
  {
    schoolNumber: 222,
    schoolName: `St Joseph's Maori Girls' College`,
    eqiNumber: 515,
  },
  {
    schoolNumber: 223,
    schoolName: `Havelock North High School`,
    eqiNumber: 434,
  },
  { schoolNumber: 224, schoolName: `Iona College`, eqiNumber: 396 },
  { schoolNumber: 225, schoolName: `Woodford House`, eqiNumber: 394 },
  {
    schoolNumber: 226,
    schoolName: `St John's College (Hastings)`,
    eqiNumber: 456,
  },
  {
    schoolNumber: 227,
    schoolName: `Hastings Boys' High School`,
    eqiNumber: 502,
  },
  {
    schoolNumber: 228,
    schoolName: `Hastings Girls’ High School – Ngā Rau Huia o Ākina`,
    eqiNumber: 514,
  },
  { schoolNumber: 229, schoolName: `Karamū High School`, eqiNumber: 484 },
  { schoolNumber: 230, schoolName: `Lindisfarne College`, eqiNumber: 398 },
  {
    schoolNumber: 231,
    schoolName: `Taikura Rudolf Steiner School`,
    eqiNumber: 437,
  },
  { schoolNumber: 232, schoolName: `Te Aute College`, eqiNumber: 541 },
  {
    schoolNumber: 233,
    schoolName: `Central Hawkes Bay College`,
    eqiNumber: 489,
  },
  { schoolNumber: 234, schoolName: `Dannevirke High School`, eqiNumber: 501 },
  { schoolNumber: 235, schoolName: `Tararua College`, eqiNumber: 510 },
  { schoolNumber: 236, schoolName: `Horowhenua College`, eqiNumber: 495 },
  { schoolNumber: 237, schoolName: `Waiopehu College`, eqiNumber: 513 },
  { schoolNumber: 238, schoolName: `Kaitaia Abundant Life School` },
  { schoolNumber: 240, schoolName: `Otaki College`, eqiNumber: 495 },
  { schoolNumber: 241, schoolName: `Wairarapa College`, eqiNumber: 479 },
  { schoolNumber: 242, schoolName: `Solway College`, eqiNumber: 431 },
  { schoolNumber: 243, schoolName: `Mākoura College`, eqiNumber: 537 },
  { schoolNumber: 244, schoolName: `Chanel College`, eqiNumber: 472 },
  { schoolNumber: 245, schoolName: `Rathkeale College`, eqiNumber: 415 },
  {
    schoolNumber: 246,
    schoolName: `St Matthew's Collegiate (Masterton)`,
    eqiNumber: 404,
  },
  { schoolNumber: 247, schoolName: `Kāpiti College`, eqiNumber: 430 },
  { schoolNumber: 248, schoolName: `Paraparaumu College`, eqiNumber: 442 },
  { schoolNumber: 249, schoolName: `Kuranui College`, eqiNumber: 468 },
  { schoolNumber: 250, schoolName: `Upper Hutt College`, eqiNumber: 466 },
  { schoolNumber: 251, schoolName: `Heretaunga College`, eqiNumber: 471 },
  {
    schoolNumber: 252,
    schoolName: `St Patrick's College (Silverstream)`,
    eqiNumber: 433,
  },
  { schoolNumber: 253, schoolName: `Aotea College`, eqiNumber: 441 },
  { schoolNumber: 254, schoolName: `Mana College`, eqiNumber: 509 },
  { schoolNumber: 255, schoolName: `Porirua College`, eqiNumber: 529 },
  { schoolNumber: 256, schoolName: `Bishop Viard College`, eqiNumber: 505 },
  { schoolNumber: 257, schoolName: `Tawa College`, eqiNumber: 440 },
  { schoolNumber: 258, schoolName: `Taita College`, eqiNumber: 520 },
  { schoolNumber: 259, schoolName: `Naenae College`, eqiNumber: 500 },
  { schoolNumber: 260, schoolName: `St Bernard's College`, eqiNumber: 444 },
  { schoolNumber: 261, schoolName: `Hutt Valley High School`, eqiNumber: 421 },
  {
    schoolNumber: 262,
    schoolName: `Sacred Heart College (Lower Hutt)`,
    eqiNumber: 444,
  },
  { schoolNumber: 265, schoolName: `St Oran's College`, eqiNumber: 380 },
  { schoolNumber: 266, schoolName: `Waipa Christian School`, eqiNumber: 421 },
  { schoolNumber: 268, schoolName: `Newlands College`, eqiNumber: 410 },
  { schoolNumber: 269, schoolName: `Onslow College`, eqiNumber: 398 },
  {
    schoolNumber: 272,
    schoolName: `Wellington Girls' College`,
    eqiNumber: 375,
  },
  {
    schoolNumber: 273,
    schoolName: `Wellington High School and Com Ed Centre`,
    eqiNumber: 401,
  },
  {
    schoolNumber: 274,
    schoolName: `Wellington East Girls' College`,
    eqiNumber: 416,
  },
  { schoolNumber: 275, schoolName: `Wellington College`, eqiNumber: 383 },
  {
    schoolNumber: 276,
    schoolName: `St Patrick's College (Kilbirnie)`,
    eqiNumber: 417,
  },
  { schoolNumber: 277, schoolName: `Rongotai College`, eqiNumber: 428 },
  { schoolNumber: 279, schoolName: `TKKM o Hoani Waititi`, eqiNumber: 493 },
  {
    schoolNumber: 282,
    schoolName: `Te Kura Amorangi o Whakawatea`,
    eqiNumber: 520,
  },
  {
    schoolNumber: 284,
    schoolName: `St Catherines College (Kilbirnie)`,
    eqiNumber: 435,
  },
  {
    schoolNumber: 286,
    schoolName: `St Mary's College (Wellington)`,
    eqiNumber: 429,
  },
  { schoolNumber: 287, schoolName: `Queen Charlotte College`, eqiNumber: 491 },
  {
    schoolNumber: 288,
    schoolName: `Marlborough Boys' College`,
    eqiNumber: 456,
  },
  {
    schoolNumber: 289,
    schoolName: `Marlborough Girls' College`,
    eqiNumber: 455,
  },
  { schoolNumber: 290, schoolName: `Collingwood Area School`, eqiNumber: 461 },
  { schoolNumber: 291, schoolName: `Rai Valley Area School`, eqiNumber: 490 },
  { schoolNumber: 292, schoolName: `Golden Bay High School`, eqiNumber: 450 },
  { schoolNumber: 293, schoolName: `Nayland College`, eqiNumber: 462 },
  { schoolNumber: 294, schoolName: `Nelson College`, eqiNumber: 441 },
  { schoolNumber: 295, schoolName: `Nelson College For Girls`, eqiNumber: 442 },
  { schoolNumber: 296, schoolName: `Waimea College`, eqiNumber: 447 },
  { schoolNumber: 297, schoolName: `Tapawera Area School`, eqiNumber: 496 },
  { schoolNumber: 298, schoolName: `Motueka High School`, eqiNumber: 464 },
  { schoolNumber: 299, schoolName: `Murchison Area School`, eqiNumber: 471 },
  { schoolNumber: 300, schoolName: `Karamea Area School`, eqiNumber: 464 },
  { schoolNumber: 301, schoolName: `Buller High School`, eqiNumber: 487 },
  { schoolNumber: 303, schoolName: `Greymouth High School`, eqiNumber: 489 },
  { schoolNumber: 304, schoolName: `John Paul II High School`, eqiNumber: 452 },
  { schoolNumber: 305, schoolName: `Westland High School`, eqiNumber: 475 },
  {
    schoolNumber: 306,
    schoolName: `South Westland Area School`,
    eqiNumber: 480,
  },
  { schoolNumber: 307, schoolName: `Kaikōura High School`, eqiNumber: 475 },
  { schoolNumber: 308, schoolName: `Amuri Area School`, eqiNumber: 444 },
  { schoolNumber: 309, schoolName: `Cheviot Area School`, eqiNumber: 463 },
  { schoolNumber: 310, schoolName: `Oxford Area School`, eqiNumber: 465 },
  { schoolNumber: 311, schoolName: `Hurunui College`, eqiNumber: 465 },
  { schoolNumber: 312, schoolName: `Rangiora High School`, eqiNumber: 454 },
  { schoolNumber: 314, schoolName: `Kaiapoi High School`, eqiNumber: 465 },
  { schoolNumber: 315, schoolName: `St Bede's College`, eqiNumber: 415 },
  { schoolNumber: 316, schoolName: `Papanui High School`, eqiNumber: 461 },
  {
    schoolNumber: 317,
    schoolName: `Christchurch Adventist School`,
    eqiNumber: 435,
  },
  { schoolNumber: 319, schoolName: `Burnside High School`, eqiNumber: 416 },
  { schoolNumber: 320, schoolName: `Mairehau High School`, eqiNumber: 510 },
  {
    schoolNumber: 321,
    schoolName: `Shirley Boys’ High School - Ngā Tama o Ōruapaeroa`,
    eqiNumber: 464,
  },
  {
    schoolNumber: 324,
    schoolName: `Avonside Girls' High School`,
    eqiNumber: 472,
  },
  { schoolNumber: 326, schoolName: `Villa Maria College`, eqiNumber: 411 },
  {
    schoolNumber: 327,
    schoolName: `Christchurch Boys' High School`,
    eqiNumber: 418,
  },
  {
    schoolNumber: 328,
    schoolName: `Christchurch Girls' High School -Te Kura o Hine Waiora`,
    eqiNumber: 419,
  },
  { schoolNumber: 329, schoolName: `Mangakino School`, eqiNumber: 550 },
  {
    schoolNumber: 331,
    schoolName: `St Thomas of Canterbury College`,
    eqiNumber: 430,
  },
  { schoolNumber: 334, schoolName: `Riccarton High School`, eqiNumber: 440 },
  { schoolNumber: 335, schoolName: `Middleton Grange School`, eqiNumber: 404 },
  {
    schoolNumber: 336,
    schoolName: `Te Puna Wai o Waipapa - Hagley College`,
    eqiNumber: 468,
  },
  { schoolNumber: 337, schoolName: `Te Aratai College`, eqiNumber: 507 },
  { schoolNumber: 338, schoolName: `Hornby High School`, eqiNumber: 489 },
  { schoolNumber: 339, schoolName: `Hillmorton High School`, eqiNumber: 467 },
  { schoolNumber: 340, schoolName: `Cashmere High School`, eqiNumber: 413 },
  {
    schoolNumber: 341,
    schoolName: `Hillview Christian School`,
    eqiNumber: 418,
  },
  { schoolNumber: 343, schoolName: `Marian College`, eqiNumber: 426 },
  {
    schoolNumber: 344,
    schoolName: `Westminster Christian School`,
    eqiNumber: 344,
  },
  { schoolNumber: 346, schoolName: `Darfield High School`, eqiNumber: 447 },
  { schoolNumber: 347, schoolName: `Lincoln High School`, eqiNumber: 423 },
  { schoolNumber: 348, schoolName: `Mount Hutt College`, eqiNumber: 438 },
  { schoolNumber: 349, schoolName: `Ellesmere College`, eqiNumber: 462 },
  { schoolNumber: 350, schoolName: `Akaroa Area School`, eqiNumber: 455 },
  { schoolNumber: 351, schoolName: `Ashburton College`, eqiNumber: 467 },
  { schoolNumber: 352, schoolName: `Geraldine High School`, eqiNumber: 453 },
  { schoolNumber: 353, schoolName: `Mackenzie College`, eqiNumber: 451 },
  { schoolNumber: 354, schoolName: `Opihi College`, eqiNumber: 504 },
  {
    schoolNumber: 357,
    schoolName: `Craighead Diocesan School`,
    eqiNumber: 409,
  },
  { schoolNumber: 358, schoolName: `Roncalli College`, eqiNumber: 446 },
  { schoolNumber: 359, schoolName: `Mountainview High School`, eqiNumber: 494 },
  { schoolNumber: 360, schoolName: `Timaru Boys' High School`, eqiNumber: 457 },
  {
    schoolNumber: 361,
    schoolName: `Timaru Girls' High School`,
    eqiNumber: 474,
  },
  { schoolNumber: 362, schoolName: `Waimate High School`, eqiNumber: 481 },
  { schoolNumber: 363, schoolName: `Waitaki Valley School`, eqiNumber: 440 },
  {
    schoolNumber: 365,
    schoolName: `Waitaki Boys' High School`,
    eqiNumber: 477,
  },
  {
    schoolNumber: 366,
    schoolName: `Waitaki Girls' High School`,
    eqiNumber: 478,
  },
  {
    schoolNumber: 369,
    schoolName: `St Kevins College (Oamaru)`,
    eqiNumber: 447,
  },
  { schoolNumber: 370, schoolName: `Maniototo Area School`, eqiNumber: 470 },
  { schoolNumber: 371, schoolName: `East Otago High School`, eqiNumber: 488 },
  { schoolNumber: 372, schoolName: `Dunstan High School`, eqiNumber: 445 },
  { schoolNumber: 373, schoolName: `Cromwell College`, eqiNumber: 445 },
  { schoolNumber: 374, schoolName: `Wakatipu High School`, eqiNumber: 416 },
  { schoolNumber: 375, schoolName: `Roxburgh Area School`, eqiNumber: 473 },
  { schoolNumber: 376, schoolName: `Logan Park High School`, eqiNumber: 430 },
  { schoolNumber: 377, schoolName: `Otago Boys' High School`, eqiNumber: 432 },
  { schoolNumber: 378, schoolName: `Otago Girls' High School`, eqiNumber: 439 },
  { schoolNumber: 380, schoolName: `St Hildas Collegiate`, eqiNumber: 394 },
  { schoolNumber: 381, schoolName: `Kaikorai Valley College`, eqiNumber: 502 },
  { schoolNumber: 382, schoolName: `Bayfield High School`, eqiNumber: 463 },
  {
    schoolNumber: 383,
    schoolName: `Kings High School (Dunedin)`,
    eqiNumber: 453,
  },
  { schoolNumber: 384, schoolName: `Queens High School`, eqiNumber: 463 },
  { schoolNumber: 386, schoolName: `Columba College`, eqiNumber: 391 },
  { schoolNumber: 387, schoolName: `John McGlashan College`, eqiNumber: 390 },
  { schoolNumber: 390, schoolName: `Lawrence Area School`, eqiNumber: 460 },
  { schoolNumber: 391, schoolName: `Blue Mountain College`, eqiNumber: 463 },
  { schoolNumber: 392, schoolName: `Tokomairiro High School`, eqiNumber: 500 },
  { schoolNumber: 393, schoolName: `South Otago High School`, eqiNumber: 475 },
  { schoolNumber: 394, schoolName: `The Catlins Area School`, eqiNumber: 470 },
  {
    schoolNumber: 395,
    schoolName: `Northern Southland College`,
    eqiNumber: 464,
  },
  { schoolNumber: 396, schoolName: `Gore High School` },
  {
    schoolNumber: 397,
    schoolName: `St Peter's College (Gore)`,
    eqiNumber: 442,
  },
  { schoolNumber: 398, schoolName: `Takitimu Primary School`, eqiNumber: 467 },
  {
    schoolNumber: 399,
    schoolName: `Central Southland College`,
    eqiNumber: 462,
  },
  { schoolNumber: 400, schoolName: `Fiordland College`, eqiNumber: 441 },
  { schoolNumber: 401, schoolName: `Menzies College`, eqiNumber: 477 },
  { schoolNumber: 402, schoolName: `Waiau Area School`, eqiNumber: 525 },
  {
    schoolNumber: 404,
    schoolName: `Southland Boys' High School`,
    eqiNumber: 464,
  },
  {
    schoolNumber: 405,
    schoolName: `Southland Girls' High School`,
    eqiNumber: 463,
  },
  { schoolNumber: 408, schoolName: `Verdon College`, eqiNumber: 464 },
  { schoolNumber: 409, schoolName: `Aparima College`, eqiNumber: 489 },
  { schoolNumber: 418, schoolName: `Rangiora New Life School`, eqiNumber: 434 },
  {
    schoolNumber: 419,
    schoolName: `Rudolf Steiner School (Chch)`,
    eqiNumber: 410,
  },
  { schoolNumber: 421, schoolName: `Richmond View School`, eqiNumber: 429 },
  { schoolNumber: 422, schoolName: `Faith City School`, eqiNumber: 441 },
  { schoolNumber: 424, schoolName: `Michael Park School`, eqiNumber: 388 },
  { schoolNumber: 428, schoolName: `Whangamata Area School`, eqiNumber: 460 },
  { schoolNumber: 429, schoolName: `Excellere College`, eqiNumber: 452 },
  { schoolNumber: 432, schoolName: `KingsWay School`, eqiNumber: 388 },
  { schoolNumber: 435, schoolName: `Hukarere Girls’ College`, eqiNumber: 542 },
  {
    schoolNumber: 439,
    schoolName: `Totara College of Accelerated Learning`,
    eqiNumber: 498,
  },
  {
    schoolNumber: 443,
    schoolName: `Hastings Christian School`,
    eqiNumber: 428,
  },
  {
    schoolNumber: 451,
    schoolName: `Hamilton Christian School`,
    eqiNumber: 413,
  },
  { schoolNumber: 452, schoolName: `Southern Cross Campus`, eqiNumber: 515 },
  { schoolNumber: 453, schoolName: `Kadimah School`, eqiNumber: 361 },
  { schoolNumber: 463, schoolName: `TKK Motuhake o Tawhiuau`, eqiNumber: 552 },
  { schoolNumber: 465, schoolName: `Mana Tamariki`, eqiNumber: 444 },
  { schoolNumber: 471, schoolName: `Zayed College for Girls`, eqiNumber: 433 },
  { schoolNumber: 476, schoolName: `Tongariro School`, eqiNumber: 546 },
  { schoolNumber: 478, schoolName: `Wainuiomata High School`, eqiNumber: 509 },
  { schoolNumber: 482, schoolName: `Aquinas College`, eqiNumber: 402 },
  { schoolNumber: 485, schoolName: `Taumata School`, eqiNumber: 415 },
  { schoolNumber: 488, schoolName: `Ngā Taiātea Wharekura`, eqiNumber: 504 },
  { schoolNumber: 491, schoolName: `Sancta Maria College`, eqiNumber: 390 },
  { schoolNumber: 494, schoolName: `Putāruru College`, eqiNumber: 518 },
  { schoolNumber: 495, schoolName: `Taieri College`, eqiNumber: 459 },
  { schoolNumber: 496, schoolName: `Reefton Area School`, eqiNumber: 504 },
  { schoolNumber: 497, schoolName: `Te Kura o Hirangi`, eqiNumber: 535 },
  { schoolNumber: 498, schoolName: `Te Aho o Te Kura Pounamu`, eqiNumber: 506 },
  { schoolNumber: 514, schoolName: `Kimi Ora School`, eqiNumber: 467 },
  { schoolNumber: 518, schoolName: `Kingslea School`, eqiNumber: 569 },
  {
    schoolNumber: 522,
    schoolName: `Halswell Residential College`,
    eqiNumber: 540,
  },
  {
    schoolNumber: 525,
    schoolName: `Salisbury School (Nelson)`,
    eqiNumber: 517,
  },
  { schoolNumber: 527, schoolName: `Twizel Area School`, eqiNumber: 452 },
  {
    schoolNumber: 528,
    schoolName: `Ponatahi Christian School`,
    eqiNumber: 431,
  },
  { schoolNumber: 530, schoolName: `Waiheke High School`, eqiNumber: 442 },
  {
    schoolNumber: 531,
    schoolName: `Catholic Cathedral College`,
    eqiNumber: 448,
  },
  { schoolNumber: 532, schoolName: `John Paul College`, eqiNumber: 415 },
  { schoolNumber: 533, schoolName: `Mt Aspiring College`, eqiNumber: 412 },
  { schoolNumber: 536, schoolName: `Trinity Catholic College`, eqiNumber: 431 },
  {
    schoolNumber: 539,
    schoolName: `Waikato Waldorf School ( Rudolf Steiner)`,
    eqiNumber: 424,
  },
  { schoolNumber: 544, schoolName: `Al-Madinah School`, eqiNumber: 413 },
  {
    schoolNumber: 545,
    schoolName: `Te Kura Toitu o Te Whaiti-nui-a-Toi`,
    eqiNumber: 540,
  },
  { schoolNumber: 548, schoolName: `Aurora College`, eqiNumber: 545 },
  { schoolNumber: 549, schoolName: `Taihape Area School`, eqiNumber: 514 },
  {
    schoolNumber: 550,
    schoolName: `Te Waha O Rerekohu Area School`,
    eqiNumber: 555,
  },
  { schoolNumber: 551, schoolName: `Coastal Taranaki School`, eqiNumber: 478 },
  { schoolNumber: 552, schoolName: `James Hargest College`, eqiNumber: 445 },
  {
    schoolNumber: 553,
    schoolName: `Mission Heights Junior College`,
    eqiNumber: 407,
  },
  {
    schoolNumber: 555,
    schoolName: `Tangaroa College Teen Parent Unit`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 557,
    schoolName: `Holy Family School (Wanaka)`,
    eqiNumber: 387,
  },
  { schoolNumber: 558, schoolName: `TKKM o Te Kura Kokiri`, eqiNumber: 551 },
  {
    schoolNumber: 559,
    schoolName: `Te Kura o Te Wainui-ā-Rua`,
    eqiNumber: 536,
  },
  {
    schoolNumber: 563,
    schoolName: `Albany Senior High School`,
    eqiNumber: 446,
  },
  { schoolNumber: 564, schoolName: `Ormiston Senior College`, eqiNumber: 443 },
  { schoolNumber: 565, schoolName: `Stonefields School`, eqiNumber: 361 },
  { schoolNumber: 566, schoolName: `Maraekakaho School`, eqiNumber: 402 },
  {
    schoolNumber: 567,
    schoolName: `Te Wharekura o Te Kaokaoroa o Patetere`,
    eqiNumber: 523,
  },
  {
    schoolNumber: 570,
    schoolName: `Mission Heights Primary School`,
    eqiNumber: 368,
  },
  { schoolNumber: 572, schoolName: `Te Matauru Primary`, eqiNumber: 445 },
  { schoolNumber: 577, schoolName: `Te Totara Primary School`, eqiNumber: 393 },
  {
    schoolNumber: 579,
    schoolName: `Knights Stream School- Mingimingi Hautoa`,
    eqiNumber: 385,
  },
  {
    schoolNumber: 584,
    schoolName: `West Rolleston Primary School`,
    eqiNumber: 415,
  },
  {
    schoolNumber: 585,
    schoolName: `Ararira Springs Primary- Te Puna o Ararira`,
    eqiNumber: 397,
  },
  { schoolNumber: 586, schoolName: `Shotover Primary School`, eqiNumber: 396 },
  { schoolNumber: 588, schoolName: `Hingaia Peninsula School`, eqiNumber: 380 },
  {
    schoolNumber: 589,
    schoolName: `Te Kura o Nga Ruahine Rangi`,
    eqiNumber: 531,
  },
  {
    schoolNumber: 593,
    schoolName: `Te Uho O Te Nikau Primary School`,
    eqiNumber: 393,
  },
  { schoolNumber: 594, schoolName: `Te Kura Rau Iti`, eqiNumber: 448 },
  { schoolNumber: 595, schoolName: `Kauri Flats School`, eqiNumber: 410 },
  { schoolNumber: 600, schoolName: `TKKM o Ngaringaomatariki`, eqiNumber: 524 },
  { schoolNumber: 601, schoolName: `Kumeroa School`, eqiNumber: 461 },
  { schoolNumber: 603, schoolName: `KingsGate School`, eqiNumber: 434 },
  { schoolNumber: 607, schoolName: `Big Rock Primary School`, eqiNumber: 433 },
  {
    schoolNumber: 608,
    schoolName: `Ashburton Christian School`,
    eqiNumber: 439,
  },
  {
    schoolNumber: 612,
    schoolName: `Henderson - Teen Parent Unit - He Wero o nga Wahine`,
    eqiNumber: 569,
  },
  { schoolNumber: 614, schoolName: `Amesbury School`, eqiNumber: 349 },
  {
    schoolNumber: 615,
    schoolName: `Rototuna Senior High School`,
    eqiNumber: 451,
  },
  {
    schoolNumber: 616,
    schoolName: `Murihiku Young Parents' Learning Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 618,
    schoolName: `Sancta Maria Catholic Primary School`,
    eqiNumber: 367,
  },
  { schoolNumber: 624, schoolName: `Te Karaka Area School`, eqiNumber: 545 },
  { schoolNumber: 625, schoolName: `Tamaoho School`, eqiNumber: 446 },
  { schoolNumber: 628, schoolName: `TKKM o Tuia te Matangi`, eqiNumber: 513 },
  {
    schoolNumber: 630,
    schoolName: `Te Kura Māori o Ngā Tapuwae`,
    eqiNumber: 499,
  },
  { schoolNumber: 631, schoolName: `Kia Aroha Campus`, eqiNumber: 539 },
  { schoolNumber: 632, schoolName: `Tai Wananga`, eqiNumber: 526 },
  { schoolNumber: 633, schoolName: `Kingsview School`, eqiNumber: 403 },
  {
    schoolNumber: 639,
    schoolName: `Pa Harakeke Teen Parent Unit`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 641,
    schoolName: `Te Wharekura o Nga Purapura o Te Aroha`,
    eqiNumber: 505,
  },
  { schoolNumber: 647, schoolName: `Bathgate Park School`, eqiNumber: 510 },
  { schoolNumber: 648, schoolName: `Carisbrook School`, eqiNumber: 520 },
  {
    schoolNumber: 650,
    schoolName: `Te Maioha o Parekarangi Education Programme`,
    eqiNumber: 569,
  },
  { schoolNumber: 651, schoolName: `Te Whata Tau o Putauaki`, eqiNumber: 541 },
  { schoolNumber: 654, schoolName: `Rolleston College`, eqiNumber: 449 },
  { schoolNumber: 655, schoolName: `Kawerau Putauaki School`, eqiNumber: 522 },
  { schoolNumber: 658, schoolName: `Murupara Area School`, eqiNumber: 560 },
  { schoolNumber: 660, schoolName: `Kahurangi School`, eqiNumber: 438 },
  { schoolNumber: 661, schoolName: `Tarawera High School`, eqiNumber: 545 },
  { schoolNumber: 670, schoolName: `Nelson Teen Parent Unit`, eqiNumber: 569 },
  { schoolNumber: 674, schoolName: `Levin Teen Parent Unit`, eqiNumber: 569 },
  {
    schoolNumber: 683,
    schoolName: `Ao Tawhiti Unlimited Discovery`,
    eqiNumber: 442,
  },
  { schoolNumber: 684, schoolName: `Te Waka Unua School`, eqiNumber: 509 },
  { schoolNumber: 685, schoolName: `Waitākiri Primary School`, eqiNumber: 452 },
  { schoolNumber: 686, schoolName: `Lyttelton Primary School`, eqiNumber: 424 },
  { schoolNumber: 688, schoolName: `Ormiston Primary School`, eqiNumber: 379 },
  { schoolNumber: 696, schoolName: `Rāwhiti School`, eqiNumber: 478 },
  { schoolNumber: 704, schoolName: `Haeata Community Campus`, eqiNumber: 545 },
  {
    schoolNumber: 705,
    schoolName: `Te Tipu Whenua o Pa Harakeke`,
    eqiNumber: 569,
  },
  { schoolNumber: 706, schoolName: `Te Pā o Rākaihautū`, eqiNumber: 517 },
  {
    schoolNumber: 708,
    schoolName: `Rototuna Junior High School`,
    eqiNumber: 428,
  },
  { schoolNumber: 709, schoolName: `Ormiston Junior College`, eqiNumber: 424 },
  {
    schoolNumber: 710,
    schoolName: `Rolleston Christian School`,
    eqiNumber: 392,
  },
  { schoolNumber: 712, schoolName: `Te Rōhutu Whio`, eqiNumber: 429 },
  {
    schoolNumber: 717,
    schoolName: `Whakatane Teen Parent Unit`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 719,
    schoolName: `Te Kura Kaupapa Maori o Te Orini ki Ngati Awa`,
    eqiNumber: 517,
  },
  {
    schoolNumber: 724,
    schoolName: `Te Manawa ō Pāpāmoa School`,
    eqiNumber: 443,
  },
  { schoolNumber: 725, schoolName: `Scott Point School`, eqiNumber: 362 },
  {
    schoolNumber: 729,
    schoolName: `Northland College Teen Parent Unit`,
    eqiNumber: 569,
  },
  { schoolNumber: 730, schoolName: `Porangahau School`, eqiNumber: 483 },
  {
    schoolNumber: 737,
    schoolName: `Te Kura Kaupapa Maori o Horouta Wananga`,
    eqiNumber: 519,
  },
  {
    schoolNumber: 738,
    schoolName: `St Francis of Assisi Catholic School`,
    eqiNumber: 408,
  },
  { schoolNumber: 739, schoolName: `Manukura`, eqiNumber: 494 },
  {
    schoolNumber: 742,
    schoolName: `Te Kura o Te Whānau-a-Apanui`,
    eqiNumber: 542,
  },
  {
    schoolNumber: 743,
    schoolName: `Holy Trinity Catholic Primary School`,
    eqiNumber: 395,
  },
  {
    schoolNumber: 746,
    schoolName: `Te Kura Whakatipu o Kawarau`,
    eqiNumber: 405,
  },
  { schoolNumber: 747, schoolName: `Te Kura O Take Kārara`, eqiNumber: 405 },
  { schoolNumber: 748, schoolName: `Ngākōroa School`, eqiNumber: 466 },
  { schoolNumber: 764, schoolName: `Ahutoetoe School`, eqiNumber: 384 },
  {
    schoolNumber: 767,
    schoolName: `Nukumea Primary School - Te Kura Tuatahi O Nukumea`,
    eqiNumber: 412,
  },
  { schoolNumber: 774, schoolName: `Matua Ngaru School`, eqiNumber: 399 },
  { schoolNumber: 780, schoolName: `Te Ao Mārama School`, eqiNumber: 390 },
  { schoolNumber: 781, schoolName: `Jireh Christian School`, eqiNumber: 387 },
  {
    schoolNumber: 840,
    schoolName: `Central Auckland Specialist School`,
    eqiNumber: 464,
  },
  {
    schoolNumber: 846,
    schoolName: `Suzanne Aubert Catholic School`,
    eqiNumber: 393,
  },
  { schoolNumber: 854, schoolName: `Vanguard Military School`, eqiNumber: 494 },
  {
    schoolNumber: 871,
    schoolName: `Te Rangihakahaka Centre for Science and Technology`,
    eqiNumber: 513,
  },
  { schoolNumber: 872, schoolName: `Te Kōpuku High`, eqiNumber: 525 },
  { schoolNumber: 873, schoolName: `Te Aratika Academy`, eqiNumber: 566 },
  {
    schoolNumber: 874,
    schoolName: `Pacific Advance Secondary School`,
    eqiNumber: 519,
  },
  {
    schoolNumber: 876,
    schoolName: `South Auckland Middle School`,
    eqiNumber: 488,
  },
  {
    schoolNumber: 877,
    schoolName: `Middle School West Auckland`,
    eqiNumber: 526,
  },
  {
    schoolNumber: 878,
    schoolName: `Te Wharekura o Ngāti Rongomai`,
    eqiNumber: 500,
  },
  { schoolNumber: 879, schoolName: `Rise UP Academy`, eqiNumber: 485 },
  { schoolNumber: 880, schoolName: `Waatea School`, eqiNumber: 564 },
  { schoolNumber: 881, schoolName: `Tūranga Tangata Rite`, eqiNumber: 569 },
  {
    schoolNumber: 903,
    schoolName: `Ko Taku Reo - Deaf Education New Zealand`,
    eqiNumber: 516,
  },
  {
    schoolNumber: 932,
    schoolName: `Te Kura ā Iwi o Pawarenga`,
    eqiNumber: 537,
  },
  { schoolNumber: 941, schoolName: `Iqra School`, eqiNumber: 409 },
  { schoolNumber: 946, schoolName: `Motueka Steiner School`, eqiNumber: 434 },
  {
    schoolNumber: 949,
    schoolName: `St Ignatius of Loyola Catholic College`,
    eqiNumber: 419,
  },
  { schoolNumber: 956, schoolName: `Harvest Christian School`, eqiNumber: 447 },
  { schoolNumber: 960, schoolName: `TKKM o Tūtūtarakihi`, eqiNumber: 540 },
  { schoolNumber: 961, schoolName: `Te Paepae o Aotea`, eqiNumber: 509 },
  { schoolNumber: 962, schoolName: `Te Rau Horopito`, eqiNumber: 434 },
  { schoolNumber: 1000, schoolName: `Ahipara School`, eqiNumber: 509 },
  { schoolNumber: 1001, schoolName: `Aranga School`, eqiNumber: 534 },
  { schoolNumber: 1002, schoolName: `Arapohue School`, eqiNumber: 502 },
  { schoolNumber: 1004, schoolName: `Awanui School`, eqiNumber: 544 },
  {
    schoolNumber: 1007,
    schoolName: `Blomfield Special School and Resource Ctre`,
    eqiNumber: 518,
  },
  { schoolNumber: 1008, schoolName: `Dargaville Intermediate`, eqiNumber: 514 },
  {
    schoolNumber: 1009,
    schoolName: `Dargaville Primary School`,
    eqiNumber: 492,
  },
  { schoolNumber: 1011, schoolName: `Glenbervie School`, eqiNumber: 437 },
  { schoolNumber: 1013, schoolName: `Herekino School`, eqiNumber: 532 },
  { schoolNumber: 1014, schoolName: `Hikurangi School`, eqiNumber: 526 },
  {
    schoolNumber: 1015,
    schoolName: `Hora Hora School (Te Mai)`,
    eqiNumber: 534,
  },
  { schoolNumber: 1016, schoolName: `Horeke School`, eqiNumber: 565 },
  {
    schoolNumber: 1017,
    schoolName: `Hukerenui School Years 1-8`,
    eqiNumber: 476,
  },
  { schoolNumber: 1018, schoolName: `Hurupaki School`, eqiNumber: 436 },
  { schoolNumber: 1019, schoolName: `Kaeo School`, eqiNumber: 526 },
  { schoolNumber: 1020, schoolName: `Kaihu Valley School`, eqiNumber: 563 },
  { schoolNumber: 1021, schoolName: `Kaikohe East School`, eqiNumber: 549 },
  { schoolNumber: 1022, schoolName: `Kaikohe Intermediate`, eqiNumber: 555 },
  { schoolNumber: 1023, schoolName: `Kaikohe West School`, eqiNumber: 557 },
  {
    schoolNumber: 1024,
    schoolName: `Kaingaroa School (Kaitaia)`,
    eqiNumber: 490,
  },
  { schoolNumber: 1025, schoolName: `Kaitaia Intermediate`, eqiNumber: 541 },
  { schoolNumber: 1026, schoolName: `Kaitaia School`, eqiNumber: 544 },
  { schoolNumber: 1027, schoolName: `Kaiwaka School`, eqiNumber: 482 },
  { schoolNumber: 1028, schoolName: `Totara Grove School`, eqiNumber: 530 },
  {
    schoolNumber: 1029,
    schoolName: `Te Kamo Intermediate School`,
    eqiNumber: 482,
  },
  { schoolNumber: 1030, schoolName: `Te Kamo School`, eqiNumber: 467 },
  { schoolNumber: 1031, schoolName: `Karetu School`, eqiNumber: 497 },
  { schoolNumber: 1032, schoolName: `Kaurihohore School`, eqiNumber: 439 },
  { schoolNumber: 1033, schoolName: `Kawakawa Primary School`, eqiNumber: 531 },
  { schoolNumber: 1034, schoolName: `Kerikeri Primary School`, eqiNumber: 462 },
  { schoolNumber: 1035, schoolName: `Kohukohu School`, eqiNumber: 543 },
  { schoolNumber: 1036, schoolName: `Kokopu School`, eqiNumber: 461 },
  { schoolNumber: 1037, schoolName: `Mangamuka School`, eqiNumber: 556 },
  { schoolNumber: 1038, schoolName: `Mangawhai Beach School`, eqiNumber: 430 },
  { schoolNumber: 1039, schoolName: `Mangonui School`, eqiNumber: 495 },
  { schoolNumber: 1042, schoolName: `Matakohe School`, eqiNumber: 515 },
  { schoolNumber: 1043, schoolName: `Matarau School`, eqiNumber: 440 },
  { schoolNumber: 1044, schoolName: `Matauri Bay School`, eqiNumber: 549 },
  { schoolNumber: 1046, schoolName: `Te Kura o Mātihetihe`, eqiNumber: 552 },
  { schoolNumber: 1047, schoolName: `Maungakaramea School`, eqiNumber: 438 },
  { schoolNumber: 1048, schoolName: `Maungatapere School`, eqiNumber: 430 },
  { schoolNumber: 1049, schoolName: `Maungaturoto School`, eqiNumber: 477 },
  { schoolNumber: 1050, schoolName: `Maunu School`, eqiNumber: 409 },
  { schoolNumber: 1052, schoolName: `Morningside School`, eqiNumber: 490 },
  { schoolNumber: 1053, schoolName: `Motatau School`, eqiNumber: 539 },
  { schoolNumber: 1055, schoolName: `Ngataki School`, eqiNumber: 551 },
  { schoolNumber: 1056, schoolName: `Ngunguru School`, eqiNumber: 427 },
  { schoolNumber: 1058, schoolName: `Ohaeawai School`, eqiNumber: 491 },
  { schoolNumber: 1059, schoolName: `Okaihau Primary School`, eqiNumber: 510 },
  { schoolNumber: 1060, schoolName: `Te Kura o Ōmanaia`, eqiNumber: 529 },
  { schoolNumber: 1061, schoolName: `One Tree Point School`, eqiNumber: 441 },
  { schoolNumber: 1062, schoolName: `Onerahi School`, eqiNumber: 489 },
  { schoolNumber: 1063, schoolName: `Opua School`, eqiNumber: 447 },
  { schoolNumber: 1065, schoolName: `Oromahoe School`, eqiNumber: 450 },
  { schoolNumber: 1066, schoolName: `Oruaiti School`, eqiNumber: 467 },
  { schoolNumber: 1068, schoolName: `Otaika Valley School`, eqiNumber: 470 },
  { schoolNumber: 1069, schoolName: `Te Kura O Otangarei`, eqiNumber: 569 },
  { schoolNumber: 1071, schoolName: `Oturu School`, eqiNumber: 569 },
  { schoolNumber: 1072, schoolName: `Paihia School`, eqiNumber: 497 },
  { schoolNumber: 1073, schoolName: `Pakaraka School`, eqiNumber: 521 },
  { schoolNumber: 1074, schoolName: `Pakiri School`, eqiNumber: 486 },
  { schoolNumber: 1075, schoolName: `Pakotai School`, eqiNumber: 562 },
  { schoolNumber: 1076, schoolName: `Pamapuria School`, eqiNumber: 546 },
  { schoolNumber: 1077, schoolName: `Paparoa School`, eqiNumber: 468 },
  { schoolNumber: 1078, schoolName: `Paparore School`, eqiNumber: 483 },
  { schoolNumber: 1080, schoolName: `Parua Bay School`, eqiNumber: 432 },
  { schoolNumber: 1081, schoolName: `Peria School`, eqiNumber: 498 },
  {
    schoolNumber: 1082,
    schoolName: `Pompallier Catholic School`,
    eqiNumber: 462,
  },
  { schoolNumber: 1083, schoolName: `Poroti School`, eqiNumber: 501 },
  {
    schoolNumber: 1084,
    schoolName: `Portland School Te Kura o Tikorangi`,
    eqiNumber: 515,
  },
  { schoolNumber: 1085, schoolName: `Pouto School`, eqiNumber: 521 },
  {
    schoolNumber: 1086,
    schoolName: `Pukenui School (Kaitaia)`,
    eqiNumber: 484,
  },
  { schoolNumber: 1087, schoolName: `Pukepoto School`, eqiNumber: 560 },
  { schoolNumber: 1089, schoolName: `Purua School`, eqiNumber: 513 },
  { schoolNumber: 1092, schoolName: `Raurimu Avenue School`, eqiNumber: 569 },
  { schoolNumber: 1093, schoolName: `Rawene School`, eqiNumber: 523 },
  { schoolNumber: 1094, schoolName: `Ruakākā School`, eqiNumber: 485 },
  { schoolNumber: 1095, schoolName: `Ruawai Primary School`, eqiNumber: 501 },
  {
    schoolNumber: 1096,
    schoolName: `Russell School (Bay Of Islands)`,
    eqiNumber: 465,
  },
  { schoolNumber: 1097, schoolName: `Selwyn Park School`, eqiNumber: 542 },
  {
    schoolNumber: 1098,
    schoolName: `St Joseph's Catholic School (Dargaville)`,
    eqiNumber: 484,
  },
  {
    schoolNumber: 1100,
    schoolName: `Te Kura o Hato Hohepa Te Kamura`,
    eqiNumber: 543,
  },
  { schoolNumber: 1104, schoolName: `Tangiteroria School`, eqiNumber: 485 },
  { schoolNumber: 1105, schoolName: `Tangowahine School`, eqiNumber: 513 },
  { schoolNumber: 1106, schoolName: `Tapora School`, eqiNumber: 441 },
  { schoolNumber: 1107, schoolName: `Tauhoa School`, eqiNumber: 497 },
  { schoolNumber: 1109, schoolName: `Te Hapua School`, eqiNumber: 550 },
  {
    schoolNumber: 1110,
    schoolName: `Te Horo School (Whangarei)`,
    eqiNumber: 562,
  },
  { schoolNumber: 1111, schoolName: `Te Kopuru School`, eqiNumber: 519 },
  {
    schoolNumber: 1112,
    schoolName: `Bay of Islands International Academy`,
    eqiNumber: 486,
  },
  {
    schoolNumber: 1113,
    schoolName: `Tikipunga Primary School`,
    eqiNumber: 548,
  },
  { schoolNumber: 1114, schoolName: `Tinopai School`, eqiNumber: 534 },
  { schoolNumber: 1115, schoolName: `Tomarata School`, eqiNumber: 468 },
  { schoolNumber: 1116, schoolName: `Totara North School`, eqiNumber: 487 },
  { schoolNumber: 1119, schoolName: `Umawera School`, eqiNumber: 502 },
  { schoolNumber: 1120, schoolName: `Waihārara School`, eqiNumber: 561 },
  { schoolNumber: 1122, schoolName: `Waima School`, eqiNumber: 552 },
  { schoolNumber: 1124, schoolName: `Waiotira School`, eqiNumber: 465 },
  { schoolNumber: 1125, schoolName: `Waipu School`, eqiNumber: 438 },
  { schoolNumber: 1126, schoolName: `Wellsford School`, eqiNumber: 484 },
  { schoolNumber: 1127, schoolName: `Whananaki School`, eqiNumber: 523 },
  { schoolNumber: 1128, schoolName: `Whangarei Heads School`, eqiNumber: 408 },
  { schoolNumber: 1129, schoolName: `Whangarei Intermediate`, eqiNumber: 506 },
  { schoolNumber: 1130, schoolName: `Whangarei School`, eqiNumber: 464 },
  { schoolNumber: 1131, schoolName: `Whau Valley School`, eqiNumber: 537 },
  { schoolNumber: 1138, schoolName: `Renew School`, eqiNumber: 461 },
  {
    schoolNumber: 1139,
    schoolName: `Lake Taupo Christian School`,
    eqiNumber: 464,
  },
  { schoolNumber: 1142, schoolName: `TKKM o Takapau`, eqiNumber: 549 },
  { schoolNumber: 1143, schoolName: `TKKM o Nga Mokopuna`, eqiNumber: 459 },
  { schoolNumber: 1147, schoolName: `Te Rangi Aniwaniwa`, eqiNumber: 519 },
  {
    schoolNumber: 1148,
    schoolName: `Nelson Christian Academy`,
    eqiNumber: 449,
  },
  {
    schoolNumber: 1149,
    schoolName: `Sonrise Christian School`,
    eqiNumber: 480,
  },
  {
    schoolNumber: 1151,
    schoolName: `TKKM o Te Puaha o Waikato`,
    eqiNumber: 540,
  },
  { schoolNumber: 1153, schoolName: `TKKM o Te Koutu`, eqiNumber: 485 },
  { schoolNumber: 1154, schoolName: `TKKM o Te Rawhiti Roa`, eqiNumber: 535 },
  { schoolNumber: 1156, schoolName: `Horizon School`, eqiNumber: 435 },
  { schoolNumber: 1164, schoolName: `Everglade School`, eqiNumber: 424 },
  { schoolNumber: 1165, schoolName: `TKKM o Ruamata`, eqiNumber: 494 },
  { schoolNumber: 1167, schoolName: `Wanaka Primary School`, eqiNumber: 393 },
  {
    schoolNumber: 1168,
    schoolName: `Emmanuel Christian School`,
    eqiNumber: 409,
  },
  { schoolNumber: 1169, schoolName: `Paeroa Christian School`, eqiNumber: 459 },
  { schoolNumber: 1170, schoolName: `Whakatane S D A School`, eqiNumber: 470 },
  {
    schoolNumber: 1172,
    schoolName: `Cornerstone Christian School`,
    eqiNumber: 417,
  },
  {
    schoolNumber: 1175,
    schoolName: `Kaikohe Christian School`,
    eqiNumber: 516,
  },
  { schoolNumber: 1177, schoolName: `Te Huruhi School`, eqiNumber: 423 },
  {
    schoolNumber: 1178,
    schoolName: `Tasman Bay Christian School`,
    eqiNumber: 456,
  },
  {
    schoolNumber: 1179,
    schoolName: `Maranatha Christian School`,
    eqiNumber: 403,
  },
  { schoolNumber: 1184, schoolName: `Hāwera Christian School`, eqiNumber: 470 },
  {
    schoolNumber: 1186,
    schoolName: `Matamata Christian School`,
    eqiNumber: 425,
  },
  { schoolNumber: 1187, schoolName: `Tauranga Waldorf School`, eqiNumber: 413 },
  { schoolNumber: 1189, schoolName: `Wā Ora Montessori`, eqiNumber: 396 },
  { schoolNumber: 1190, schoolName: `Elim Christian College`, eqiNumber: 379 },
  {
    schoolNumber: 1192,
    schoolName: `Dunedin Rudolf Steiner School`,
    eqiNumber: 418,
  },
  { schoolNumber: 1194, schoolName: `Red Beach School`, eqiNumber: 409 },
  { schoolNumber: 1195, schoolName: `Adventure School`, eqiNumber: 389 },
  { schoolNumber: 1200, schoolName: `Ahuroa School`, eqiNumber: 455 },
  { schoolNumber: 1201, schoolName: `Aka Aka School`, eqiNumber: 488 },
  { schoolNumber: 1202, schoolName: `Albany School`, eqiNumber: 378 },
  { schoolNumber: 1203, schoolName: `Alfriston School`, eqiNumber: 396 },
  { schoolNumber: 1204, schoolName: `Anchorage Park School`, eqiNumber: 442 },
  { schoolNumber: 1206, schoolName: `Arahoe School`, eqiNumber: 385 },
  { schoolNumber: 1207, schoolName: `Ararimu School`, eqiNumber: 400 },
  { schoolNumber: 1208, schoolName: `Ardmore School`, eqiNumber: 415 },
  { schoolNumber: 1209, schoolName: `Arohanui Special School`, eqiNumber: 479 },
  { schoolNumber: 1210, schoolName: `Northern Health School`, eqiNumber: 569 },
  {
    schoolNumber: 1211,
    schoolName: `Auckland Normal Intermediate`,
    eqiNumber: 370,
  },
  { schoolNumber: 1212, schoolName: `Avondale Intermediate`, eqiNumber: 474 },
  {
    schoolNumber: 1213,
    schoolName: `Avondale Primary School (Auckland)`,
    eqiNumber: 444,
  },
  { schoolNumber: 1214, schoolName: `Awhitu District School`, eqiNumber: 472 },
  {
    schoolNumber: 1215,
    schoolName: `Sir Douglas Bader Intermediate School`,
    eqiNumber: 514,
  },
  { schoolNumber: 1216, schoolName: `Bailey Road School`, eqiNumber: 488 },
  {
    schoolNumber: 1217,
    schoolName: `Sir Edmund Hillary Collegiate Middle School`,
    eqiNumber: 523,
  },
  {
    schoolNumber: 1218,
    schoolName: `Bairds Mainfreight Primary School`,
    eqiNumber: 511,
  },
  {
    schoolNumber: 1219,
    schoolName: `Balmoral School (Auckland)`,
    eqiNumber: 366,
  },
  { schoolNumber: 1220, schoolName: `Bayfield School`, eqiNumber: 356 },
  { schoolNumber: 1221, schoolName: `Bayswater School`, eqiNumber: 420 },
  { schoolNumber: 1222, schoolName: `Bayview School`, eqiNumber: 404 },
  { schoolNumber: 1223, schoolName: `Beach Haven School`, eqiNumber: 434 },
  { schoolNumber: 1224, schoolName: `Beachlands School`, eqiNumber: 395 },
  { schoolNumber: 1225, schoolName: `Belmont Intermediate`, eqiNumber: 374 },
  {
    schoolNumber: 1226,
    schoolName: `Belmont School (Auckland)`,
    eqiNumber: 365,
  },
  { schoolNumber: 1227, schoolName: `Birdwood School`, eqiNumber: 522 },
  { schoolNumber: 1228, schoolName: `Birkdale Intermediate`, eqiNumber: 455 },
  { schoolNumber: 1229, schoolName: `Birkdale North School`, eqiNumber: 427 },
  { schoolNumber: 1230, schoolName: `Birkdale Primary School`, eqiNumber: 473 },
  { schoolNumber: 1231, schoolName: `Birkenhead School`, eqiNumber: 366 },
  {
    schoolNumber: 1232,
    schoolName: `Blockhouse Bay Intermediate`,
    eqiNumber: 401,
  },
  { schoolNumber: 1233, schoolName: `Blockhouse Bay School`, eqiNumber: 370 },
  { schoolNumber: 1234, schoolName: `Bombay School`, eqiNumber: 407 },
  { schoolNumber: 1235, schoolName: `Botany Downs School`, eqiNumber: 392 },
  { schoolNumber: 1236, schoolName: `Brookby School`, eqiNumber: 417 },
  { schoolNumber: 1237, schoolName: `Browns Bay School`, eqiNumber: 369 },
  {
    schoolNumber: 1238,
    schoolName: `Bruce McLaren Intermediate`,
    eqiNumber: 488,
  },
  { schoolNumber: 1239, schoolName: `Buckland School`, eqiNumber: 433 },
  {
    schoolNumber: 1240,
    schoolName: `Bucklands Beach Intermediate`,
    eqiNumber: 367,
  },
  {
    schoolNumber: 1241,
    schoolName: `Bucklands Beach Primary School`,
    eqiNumber: 356,
  },
  { schoolNumber: 1242, schoolName: `Campbells Bay School`, eqiNumber: 344 },
  { schoolNumber: 1243, schoolName: `Chaucer School`, eqiNumber: 429 },
  { schoolNumber: 1244, schoolName: `Chelsea School`, eqiNumber: 352 },
  {
    schoolNumber: 1245,
    schoolName: `Christ the King Catholic School (Owairaka)`,
    eqiNumber: 449,
  },
  { schoolNumber: 1246, schoolName: `Churchill Park School`, eqiNumber: 363 },
  { schoolNumber: 1247, schoolName: `Clayton Park School`, eqiNumber: 509 },
  { schoolNumber: 1248, schoolName: `Clendon Park School`, eqiNumber: 525 },
  { schoolNumber: 1249, schoolName: `Clevedon School`, eqiNumber: 414 },
  {
    schoolNumber: 1251,
    schoolName: `Sir Edmund Hillary Collegiate Junior School`,
    eqiNumber: 517,
  },
  { schoolNumber: 1252, schoolName: `Coatesville School`, eqiNumber: 376 },
  { schoolNumber: 1253, schoolName: `Cockle Bay School`, eqiNumber: 364 },
  { schoolNumber: 1254, schoolName: `Colwill School Massey`, eqiNumber: 499 },
  { schoolNumber: 1255, schoolName: `Conifer Grove School`, eqiNumber: 431 },
  {
    schoolNumber: 1256,
    schoolName: `Cornwall Park District School`,
    eqiNumber: 350,
  },
  { schoolNumber: 1257, schoolName: `Cosgrove School`, eqiNumber: 519 },
  { schoolNumber: 1258, schoolName: `Dairy Flat School`, eqiNumber: 425 },
  { schoolNumber: 1259, schoolName: `Dawson School`, eqiNumber: 515 },
  {
    schoolNumber: 1260,
    schoolName: `Devonport Primary School`,
    eqiNumber: 372,
  },
  { schoolNumber: 1261, schoolName: `Dominion Road School`, eqiNumber: 454 },
  { schoolNumber: 1262, schoolName: `Don Buck School`, eqiNumber: 494 },
  { schoolNumber: 1263, schoolName: `Drury School`, eqiNumber: 446 },
  { schoolNumber: 1264, schoolName: `East Tamaki School`, eqiNumber: 513 },
  {
    schoolNumber: 1265,
    schoolName: `Edendale School (Auckland)`,
    eqiNumber: 376,
  },
  { schoolNumber: 1266, schoolName: `Edmonton School`, eqiNumber: 454 },
  { schoolNumber: 1267, schoolName: `Edmund Hillary School`, eqiNumber: 528 },
  { schoolNumber: 1268, schoolName: `Ellerslie School`, eqiNumber: 373 },
  { schoolNumber: 1269, schoolName: `Elm Park School`, eqiNumber: 407 },
  { schoolNumber: 1270, schoolName: `Epsom Normal School`, eqiNumber: 355 },
  { schoolNumber: 1271, schoolName: `Fairburn School`, eqiNumber: 482 },
  { schoolNumber: 1272, schoolName: `Farm Cove Intermediate`, eqiNumber: 409 },
  { schoolNumber: 1273, schoolName: `Favona School`, eqiNumber: 494 },
  {
    schoolNumber: 1274,
    schoolName: `Ferguson Intermediate (Otara)`,
    eqiNumber: 519,
  },
  { schoolNumber: 1275, schoolName: `Finlayson Park School`, eqiNumber: 519 },
  { schoolNumber: 1276, schoolName: `Flanshaw Road School`, eqiNumber: 446 },
  { schoolNumber: 1277, schoolName: `Flat Bush School`, eqiNumber: 520 },
  { schoolNumber: 1278, schoolName: `Forrest Hill School`, eqiNumber: 373 },
  { schoolNumber: 1279, schoolName: `Freemans Bay School`, eqiNumber: 408 },
  {
    schoolNumber: 1280,
    schoolName: `Freyberg Community School`,
    eqiNumber: 424,
  },
  { schoolNumber: 1281, schoolName: `Fruitvale Road School`, eqiNumber: 440 },
  {
    schoolNumber: 1282,
    schoolName: `Gladstone School (Auckland)`,
    eqiNumber: 378,
  },
  { schoolNumber: 1283, schoolName: `Glamorgan School`, eqiNumber: 388 },
  { schoolNumber: 1284, schoolName: `Glen Eden Intermediate`, eqiNumber: 420 },
  { schoolNumber: 1285, schoolName: `Glen Eden School`, eqiNumber: 469 },
  { schoolNumber: 1287, schoolName: `Glen Innes School`, eqiNumber: 522 },
  { schoolNumber: 1289, schoolName: `Glen Taylor School`, eqiNumber: 516 },
  { schoolNumber: 1290, schoolName: `Glenavon School`, eqiNumber: 494 },
  { schoolNumber: 1291, schoolName: `Glenbrae Primary School`, eqiNumber: 525 },
  { schoolNumber: 1292, schoolName: `Glenbrook School`, eqiNumber: 443 },
  { schoolNumber: 1293, schoolName: `Glendene School`, eqiNumber: 491 },
  { schoolNumber: 1294, schoolName: `Glendowie School`, eqiNumber: 364 },
  { schoolNumber: 1295, schoolName: `Glenfield Intermediate`, eqiNumber: 434 },
  {
    schoolNumber: 1296,
    schoolName: `Glenfield Primary School`,
    eqiNumber: 415,
  },
  {
    schoolNumber: 1297,
    schoolName: `Good Shepherd School (Balmoral)`,
    eqiNumber: 368,
  },
  {
    schoolNumber: 1298,
    schoolName: `Green Bay Primary School`,
    eqiNumber: 391,
  },
  { schoolNumber: 1299, schoolName: `Greenhithe School`, eqiNumber: 358 },
  {
    schoolNumber: 1300,
    schoolName: `Greenmeadows Intermediate`,
    eqiNumber: 490,
  },
  { schoolNumber: 1301, schoolName: `Grey Lynn School`, eqiNumber: 379 },
  { schoolNumber: 1302, schoolName: `Halsey Drive School`, eqiNumber: 355 },
  { schoolNumber: 1303, schoolName: `Harrisville School`, eqiNumber: 450 },
  { schoolNumber: 1304, schoolName: `Hauraki School`, eqiNumber: 353 },
  { schoolNumber: 1305, schoolName: `Hay Park School`, eqiNumber: 491 },
  { schoolNumber: 1306, schoolName: `Helensville School`, eqiNumber: 447 },
  { schoolNumber: 1307, schoolName: `Henderson Intermediate`, eqiNumber: 485 },
  { schoolNumber: 1308, schoolName: `Henderson North School`, eqiNumber: 477 },
  { schoolNumber: 1309, schoolName: `Henderson School`, eqiNumber: 485 },
  { schoolNumber: 1310, schoolName: `Henderson South School`, eqiNumber: 505 },
  { schoolNumber: 1311, schoolName: `Henderson Valley School`, eqiNumber: 437 },
  { schoolNumber: 1312, schoolName: `Hillpark School`, eqiNumber: 425 },
  { schoolNumber: 1313, schoolName: `Hillsborough School`, eqiNumber: 370 },
  { schoolNumber: 1314, schoolName: `Hobsonville School`, eqiNumber: 397 },
  {
    schoolNumber: 1315,
    schoolName: `Holy Cross School (Papatoetoe)`,
    eqiNumber: 445,
  },
  {
    schoolNumber: 1316,
    schoolName: `Holy Cross Catholic School (Henderson)`,
    eqiNumber: 413,
  },
  { schoolNumber: 1317, schoolName: `Homai School`, eqiNumber: 505 },
  { schoolNumber: 1318, schoolName: `Howick Intermediate`, eqiNumber: 429 },
  { schoolNumber: 1319, schoolName: `Howick Primary School`, eqiNumber: 422 },
  { schoolNumber: 1320, schoolName: `Huapai District School`, eqiNumber: 406 },
  { schoolNumber: 1321, schoolName: `Hunua School`, eqiNumber: 433 },
  { schoolNumber: 1322, schoolName: `Jean Batten School`, eqiNumber: 491 },
  { schoolNumber: 1323, schoolName: `Kaiaua School`, eqiNumber: 533 },
  { schoolNumber: 1324, schoolName: `Kaipara Flats School`, eqiNumber: 425 },
  { schoolNumber: 1325, schoolName: `Karaka School`, eqiNumber: 403 },
  { schoolNumber: 1326, schoolName: `Kaukapakapa School`, eqiNumber: 449 },
  { schoolNumber: 1327, schoolName: `Kauri Park School`, eqiNumber: 384 },
  { schoolNumber: 1328, schoolName: `Kaurilands School`, eqiNumber: 388 },
  { schoolNumber: 1329, schoolName: `Kedgley Intermediate`, eqiNumber: 486 },
  { schoolNumber: 1330, schoolName: `Kelston Intermediate`, eqiNumber: 504 },
  { schoolNumber: 1331, schoolName: `Kelston School`, eqiNumber: 479 },
  { schoolNumber: 1332, schoolName: `Kelvin Road School`, eqiNumber: 539 },
  { schoolNumber: 1333, schoolName: `Kingsford School`, eqiNumber: 500 },
  { schoolNumber: 1334, schoolName: `Kohimarama School`, eqiNumber: 361 },
  {
    schoolNumber: 1335,
    schoolName: `Konini School (Auckland)`,
    eqiNumber: 414,
  },
  { schoolNumber: 1336, schoolName: `Koru School`, eqiNumber: 504 },
  { schoolNumber: 1337, schoolName: `Kowhai Intermediate`, eqiNumber: 403 },
  { schoolNumber: 1338, schoolName: `Laingholm School`, eqiNumber: 403 },
  { schoolNumber: 1339, schoolName: `Leabank School`, eqiNumber: 519 },
  { schoolNumber: 1340, schoolName: `Leigh School`, eqiNumber: 426 },
  { schoolNumber: 1341, schoolName: `Lincoln Heights School`, eqiNumber: 490 },
  { schoolNumber: 1342, schoolName: `Long Bay School`, eqiNumber: 375 },
  { schoolNumber: 1343, schoolName: `Mairangi Bay School`, eqiNumber: 358 },
  { schoolNumber: 1344, schoolName: `Mangatangi School`, eqiNumber: 477 },
  { schoolNumber: 1345, schoolName: `Mangatawhiri School`, eqiNumber: 436 },
  { schoolNumber: 1346, schoolName: `Mangere Bridge School`, eqiNumber: 466 },
  { schoolNumber: 1347, schoolName: `Mangere Central School`, eqiNumber: 503 },
  { schoolNumber: 1348, schoolName: `Māngere East School`, eqiNumber: 505 },
  { schoolNumber: 1350, schoolName: `Manuka Primary School`, eqiNumber: 411 },
  {
    schoolNumber: 1351,
    schoolName: `Royal Oak Intermediate School`,
    eqiNumber: 458,
  },
  { schoolNumber: 1352, schoolName: `Manurewa East School`, eqiNumber: 529 },
  { schoolNumber: 1353, schoolName: `Manurewa Intermediate`, eqiNumber: 518 },
  { schoolNumber: 1354, schoolName: `Manurewa Central School`, eqiNumber: 442 },
  { schoolNumber: 1355, schoolName: `Manurewa South School`, eqiNumber: 525 },
  { schoolNumber: 1356, schoolName: `Manurewa West School`, eqiNumber: 495 },
  { schoolNumber: 1357, schoolName: `Maraetai Beach School`, eqiNumber: 398 },
  { schoolNumber: 1358, schoolName: `Maramarua School`, eqiNumber: 499 },
  {
    schoolNumber: 1359,
    schoolName: `Marist School (Mt Albert)`,
    eqiNumber: 354,
  },
  {
    schoolNumber: 1360,
    schoolName: `Marist Catholic School (Herne Bay)`,
    eqiNumber: 380,
  },
  { schoolNumber: 1361, schoolName: `Marlborough School`, eqiNumber: 379 },
  { schoolNumber: 1362, schoolName: `Marshall Laing School`, eqiNumber: 378 },
  { schoolNumber: 1363, schoolName: `Massey Primary School`, eqiNumber: 492 },
  { schoolNumber: 1364, schoolName: `Matakana School`, eqiNumber: 394 },
  { schoolNumber: 1365, schoolName: `Matipo Road School`, eqiNumber: 407 },
  { schoolNumber: 1366, schoolName: `Mauku School`, eqiNumber: 475 },
  { schoolNumber: 1367, schoolName: `Maungawhau School`, eqiNumber: 344 },
  { schoolNumber: 1368, schoolName: `May Road School`, eqiNumber: 496 },
  {
    schoolNumber: 1369,
    schoolName: `Mayfield School (Auckland)`,
    eqiNumber: 520,
  },
  { schoolNumber: 1370, schoolName: `Meadowbank School`, eqiNumber: 349 },
  { schoolNumber: 1371, schoolName: `Mellons Bay School`, eqiNumber: 354 },
  { schoolNumber: 1372, schoolName: `Te Paina School`, eqiNumber: 513 },
  { schoolNumber: 1373, schoolName: `Meremere School`, eqiNumber: 522 },
  {
    schoolNumber: 1375,
    schoolName: `Milford School (Auckland)`,
    eqiNumber: 356,
  },
  {
    schoolNumber: 1376,
    schoolName: `Monte Cecilia Catholic School`,
    eqiNumber: 414,
  },
  { schoolNumber: 1378, schoolName: `Mt Eden Normal School`, eqiNumber: 346 },
  { schoolNumber: 1379, schoolName: `Mt Richmond School`, eqiNumber: 494 },
  { schoolNumber: 1380, schoolName: `Mountain View School`, eqiNumber: 509 },
  { schoolNumber: 1381, schoolName: `Mt Albert School`, eqiNumber: 390 },
  {
    schoolNumber: 1382,
    schoolName: `Mt Carmel School (Meadowbank)`,
    eqiNumber: 354,
  },
  { schoolNumber: 1383, schoolName: `Mt Roskill Intermediate`, eqiNumber: 433 },
  {
    schoolNumber: 1384,
    schoolName: `Mt Roskill Primary School`,
    eqiNumber: 406,
  },
  { schoolNumber: 1385, schoolName: `Mulberry Grove School`, eqiNumber: 482 },
  {
    schoolNumber: 1386,
    schoolName: `Murrays Bay Intermediate`,
    eqiNumber: 372,
  },
  { schoolNumber: 1387, schoolName: `Murrays Bay School`, eqiNumber: 357 },
  { schoolNumber: 1388, schoolName: `Macleans Primary School`, eqiNumber: 391 },
  { schoolNumber: 1389, schoolName: `New Lynn School`, eqiNumber: 451 },
  { schoolNumber: 1390, schoolName: `New Windsor School`, eqiNumber: 421 },
  { schoolNumber: 1391, schoolName: `Newmarket School`, eqiNumber: 372 },
  { schoolNumber: 1392, schoolName: `Newton Central School`, eqiNumber: 391 },
  { schoolNumber: 1393, schoolName: `Nga Iwi School`, eqiNumber: 518 },
  { schoolNumber: 1394, schoolName: `Northcote Intermediate`, eqiNumber: 404 },
  {
    schoolNumber: 1395,
    schoolName: `Northcote School (Auckland)`,
    eqiNumber: 367,
  },
  { schoolNumber: 1396, schoolName: `Northcross Intermediate`, eqiNumber: 394 },
  { schoolNumber: 1397, schoolName: `Oaklynn Special School`, eqiNumber: 453 },
  { schoolNumber: 1398, schoolName: `Okiwi School`, eqiNumber: 475 },
  { schoolNumber: 1399, schoolName: `Onehunga Primary School`, eqiNumber: 410 },
  { schoolNumber: 1400, schoolName: `Onepoto School`, eqiNumber: 512 },
  { schoolNumber: 1401, schoolName: `Opaheke School`, eqiNumber: 460 },
  { schoolNumber: 1402, schoolName: `Orakei School`, eqiNumber: 449 },
  { schoolNumber: 1403, schoolName: `Oranga School`, eqiNumber: 437 },
  { schoolNumber: 1404, schoolName: `Oratia School`, eqiNumber: 410 },
  { schoolNumber: 1405, schoolName: `Orere School`, eqiNumber: 473 },
  { schoolNumber: 1406, schoolName: `Orewa Beach School`, eqiNumber: 425 },
  { schoolNumber: 1407, schoolName: `Orewa Primary School`, eqiNumber: 390 },
  { schoolNumber: 1408, schoolName: `Otahuhu Intermediate`, eqiNumber: 502 },
  { schoolNumber: 1409, schoolName: `Otahuhu School`, eqiNumber: 490 },
  { schoolNumber: 1410, schoolName: `Otaua School`, eqiNumber: 450 },
  {
    schoolNumber: 1411,
    schoolName: `Our Lady Sacred Heart School (Epsom)`,
    eqiNumber: 344,
  },
  {
    schoolNumber: 1412,
    schoolName: `Owairaka District School`,
    eqiNumber: 431,
  },
  { schoolNumber: 1413, schoolName: `Owairoa Primary School`, eqiNumber: 391 },
  { schoolNumber: 1414, schoolName: `Paerata School`, eqiNumber: 465 },
  {
    schoolNumber: 1416,
    schoolName: `Pakuranga Heights School`,
    eqiNumber: 449,
  },
  { schoolNumber: 1417, schoolName: `Pakuranga Intermediate`, eqiNumber: 486 },
  { schoolNumber: 1418, schoolName: `Panama Road School`, eqiNumber: 511 },
  { schoolNumber: 1419, schoolName: `Panmure Bridge School`, eqiNumber: 499 },
  { schoolNumber: 1420, schoolName: `Panmure District School`, eqiNumber: 473 },
  { schoolNumber: 1421, schoolName: `Papakura Central School`, eqiNumber: 437 },
  { schoolNumber: 1422, schoolName: `Papakura Intermediate`, eqiNumber: 542 },
  { schoolNumber: 1423, schoolName: `Papakura Normal School`, eqiNumber: 491 },
  { schoolNumber: 1424, schoolName: `Kereru Park Campus`, eqiNumber: 542 },
  { schoolNumber: 1425, schoolName: `Paparimu School`, eqiNumber: 454 },
  {
    schoolNumber: 1426,
    schoolName: `Papatoetoe Central School`,
    eqiNumber: 419,
  },
  { schoolNumber: 1427, schoolName: `Papatoetoe East School`, eqiNumber: 463 },
  { schoolNumber: 1428, schoolName: `Papatoetoe Intermediate`, eqiNumber: 477 },
  { schoolNumber: 1429, schoolName: `Papatoetoe North School`, eqiNumber: 470 },
  { schoolNumber: 1430, schoolName: `Papatoetoe South School`, eqiNumber: 480 },
  { schoolNumber: 1431, schoolName: `Papatoetoe West School`, eqiNumber: 468 },
  { schoolNumber: 1432, schoolName: `Parakai School`, eqiNumber: 481 },
  { schoolNumber: 1433, schoolName: `Ridgeview School`, eqiNumber: 470 },
  { schoolNumber: 1434, schoolName: `Mangapikopiko School`, eqiNumber: 528 },
  { schoolNumber: 1435, schoolName: `Parkside School`, eqiNumber: 493 },
  { schoolNumber: 1436, schoolName: `Parnell School`, eqiNumber: 382 },
  { schoolNumber: 1437, schoolName: `Pasadena Intermediate`, eqiNumber: 414 },
  {
    schoolNumber: 1438,
    schoolName: `Patumāhoe Primary School`,
    eqiNumber: 415,
  },
  { schoolNumber: 1439, schoolName: `Pigeon Mountain School`, eqiNumber: 353 },
  {
    schoolNumber: 1440,
    schoolName: `Point Chevalier School Rangi-mata-rau`,
    eqiNumber: 360,
  },
  { schoolNumber: 1441, schoolName: `Pt England School`, eqiNumber: 518 },
  { schoolNumber: 1442, schoolName: `Pokeno School`, eqiNumber: 429 },
  { schoolNumber: 1444, schoolName: `Pomaria Road School`, eqiNumber: 487 },
  { schoolNumber: 1445, schoolName: `Ponsonby Intermediate`, eqiNumber: 380 },
  { schoolNumber: 1446, schoolName: `Ponsonby Primary School`, eqiNumber: 364 },
  { schoolNumber: 1447, schoolName: `Prospect School`, eqiNumber: 495 },
  { schoolNumber: 1448, schoolName: `Puhinui School`, eqiNumber: 432 },
  { schoolNumber: 1449, schoolName: `Pukekawa School`, eqiNumber: 452 },
  { schoolNumber: 1450, schoolName: `Pukekohe East School`, eqiNumber: 404 },
  { schoolNumber: 1451, schoolName: `Pukekohe Hill School`, eqiNumber: 452 },
  { schoolNumber: 1452, schoolName: `Pukekohe Intermediate`, eqiNumber: 465 },
  { schoolNumber: 1453, schoolName: `Pukekohe North School`, eqiNumber: 558 },
  { schoolNumber: 1454, schoolName: `Pukeoware School`, eqiNumber: 446 },
  { schoolNumber: 1455, schoolName: `Puni School`, eqiNumber: 430 },
  { schoolNumber: 1456, schoolName: `Ramarama School`, eqiNumber: 412 },
  { schoolNumber: 1457, schoolName: `Rangeview Intermediate`, eqiNumber: 465 },
  { schoolNumber: 1458, schoolName: `Ranui School`, eqiNumber: 519 },
  { schoolNumber: 1459, schoolName: `Redhill School`, eqiNumber: 535 },
  { schoolNumber: 1460, schoolName: `Redoubt North School`, eqiNumber: 475 },
  { schoolNumber: 1461, schoolName: `Remuera Intermediate`, eqiNumber: 380 },
  { schoolNumber: 1462, schoolName: `Remuera School`, eqiNumber: 348 },
  { schoolNumber: 1463, schoolName: `Richmond Road School`, eqiNumber: 403 },
  { schoolNumber: 1464, schoolName: `Riverhead School`, eqiNumber: 389 },
  { schoolNumber: 1465, schoolName: `Riverhills School`, eqiNumber: 494 },
  { schoolNumber: 1466, schoolName: `Riverina School`, eqiNumber: 468 },
  { schoolNumber: 1467, schoolName: `Robertson Road School`, eqiNumber: 507 },
  { schoolNumber: 1468, schoolName: `Rongomai School`, eqiNumber: 526 },
  { schoolNumber: 1470, schoolName: `Roscommon School`, eqiNumber: 517 },
  {
    schoolNumber: 1471,
    schoolName: `Te Kura o Pātiki Rosebank School`,
    eqiNumber: 476,
  },
  { schoolNumber: 1472, schoolName: `Rosehill School`, eqiNumber: 507 },
  { schoolNumber: 1473, schoolName: `Rosehill Intermediate`, eqiNumber: 467 },
  { schoolNumber: 1474, schoolName: `Rowandale School`, eqiNumber: 520 },
  { schoolNumber: 1475, schoolName: `Royal Oak School`, eqiNumber: 381 },
  { schoolNumber: 1476, schoolName: `Royal Road School`, eqiNumber: 491 },
  { schoolNumber: 1477, schoolName: `Ruapotaka School`, eqiNumber: 526 },
  { schoolNumber: 1478, schoolName: `Rutherford School`, eqiNumber: 433 },
  { schoolNumber: 1479, schoolName: `Sandspit Road School`, eqiNumber: 459 },
  { schoolNumber: 1480, schoolName: `Shelly Park School`, eqiNumber: 375 },
  {
    schoolNumber: 1481,
    schoolName: `Sherwood School (Auckland)`,
    eqiNumber: 372,
  },
  { schoolNumber: 1482, schoolName: `Silverdale School`, eqiNumber: 382 },
  { schoolNumber: 1483, schoolName: `Sir Keith Park School`, eqiNumber: 500 },
  { schoolNumber: 1484, schoolName: `Sommerville School`, eqiNumber: 444 },
  {
    schoolNumber: 1486,
    schoolName: `St Anne's Catholic School (Manurewa)`,
    eqiNumber: 453,
  },
  {
    schoolNumber: 1487,
    schoolName: `St Dominic's Catholic School (Blockhouse Bay)`,
    eqiNumber: 356,
  },
  {
    schoolNumber: 1488,
    schoolName: `St Francis Catholic School (Pt Chevalier)`,
    eqiNumber: 367,
  },
  { schoolNumber: 1489, schoolName: `St Heliers School`, eqiNumber: 366 },
  {
    schoolNumber: 1490,
    schoolName: `St Ignatius Catholic School (St Heliers)`,
    eqiNumber: 354,
  },
  {
    schoolNumber: 1491,
    schoolName: `St John the Evangelist Catholic School`,
    eqiNumber: 487,
  },
  {
    schoolNumber: 1492,
    schoolName: `St John's School (Mairangi Bay)`,
    eqiNumber: 350,
  },
  {
    schoolNumber: 1493,
    schoolName: `St Joseph's School (Grey Lynn)`,
    eqiNumber: 447,
  },
  {
    schoolNumber: 1494,
    schoolName: `St Joseph's Catholic School (Onehunga)`,
    eqiNumber: 447,
  },
  {
    schoolNumber: 1495,
    schoolName: `St Joseph's School (Orakei)`,
    eqiNumber: 394,
  },
  {
    schoolNumber: 1496,
    schoolName: `St Joseph's School (Otahuhu)`,
    eqiNumber: 468,
  },
  {
    schoolNumber: 1497,
    schoolName: `St Joseph's School (Pukekohe)`,
    eqiNumber: 427,
  },
  {
    schoolNumber: 1498,
    schoolName: `St Joseph's Catholic School (Takapuna)`,
    eqiNumber: 346,
  },
  { schoolNumber: 1499, schoolName: `St Leonards Road School`, eqiNumber: 481 },
  {
    schoolNumber: 1500,
    schoolName: `St Leo's Catholic School (Devonport)`,
    eqiNumber: 380,
  },
  {
    schoolNumber: 1501,
    schoolName: `St Mark's School (Pakuranga)`,
    eqiNumber: 379,
  },
  {
    schoolNumber: 1502,
    schoolName: `St Mary's Catholic School (Papakura)`,
    eqiNumber: 425,
  },
  {
    schoolNumber: 1503,
    schoolName: `St Mary's Catholic School (Avondale)`,
    eqiNumber: 447,
  },
  {
    schoolNumber: 1504,
    schoolName: `St Mary's School (Ellerslie)`,
    eqiNumber: 367,
  },
  {
    schoolNumber: 1505,
    schoolName: `St Mary's School (Northcote)`,
    eqiNumber: 365,
  },
  {
    schoolNumber: 1506,
    schoolName: `St Michael's Catholic School (Remuera)`,
    eqiNumber: 344,
  },
  {
    schoolNumber: 1507,
    schoolName: `St Patrick's School (Panmure)`,
    eqiNumber: 445,
  },
  {
    schoolNumber: 1508,
    schoolName: `St Pius X Catholic School (Glen Innes)`,
    eqiNumber: 501,
  },
  {
    schoolNumber: 1509,
    schoolName: `St Therese School (Three Kings)`,
    eqiNumber: 470,
  },
  {
    schoolNumber: 1510,
    schoolName: `St Thomas School (Auckland)`,
    eqiNumber: 377,
  },
  { schoolNumber: 1511, schoolName: `Stanhope Road School`, eqiNumber: 415 },
  { schoolNumber: 1512, schoolName: `Stanley Bay School`, eqiNumber: 360 },
  { schoolNumber: 1513, schoolName: `Stanmore Bay School`, eqiNumber: 426 },
  {
    schoolNumber: 1514,
    schoolName: `Our Lady Star of the Sea School (Howick)`,
    eqiNumber: 355,
  },
  { schoolNumber: 1515, schoolName: `Sunnyhills School`, eqiNumber: 367 },
  { schoolNumber: 1516, schoolName: `Sunnybrae Normal School`, eqiNumber: 386 },
  { schoolNumber: 1518, schoolName: `Sunnynook School`, eqiNumber: 392 },
  { schoolNumber: 1519, schoolName: `Sunnyvale School`, eqiNumber: 477 },
  { schoolNumber: 1520, schoolName: `Sutton Park School`, eqiNumber: 494 },
  { schoolNumber: 1521, schoolName: `Swanson School`, eqiNumber: 462 },
  { schoolNumber: 1522, schoolName: `Sylvia Park School`, eqiNumber: 461 },
  { schoolNumber: 1523, schoolName: `Takanini School`, eqiNumber: 500 },
  {
    schoolNumber: 1524,
    schoolName: `Takapuna Normal Intermediate`,
    eqiNumber: 371,
  },
  { schoolNumber: 1525, schoolName: `Takapuna School`, eqiNumber: 375 },
  { schoolNumber: 1526, schoolName: `Tāmaki School`, eqiNumber: 522 },
  { schoolNumber: 1528, schoolName: `Target Road School`, eqiNumber: 412 },
  { schoolNumber: 1529, schoolName: `Taupaki School`, eqiNumber: 427 },
  { schoolNumber: 1530, schoolName: `Te Atatu Intermediate`, eqiNumber: 434 },
  {
    schoolNumber: 1531,
    schoolName: `Peninsula Primary School`,
    eqiNumber: 421,
  },
  { schoolNumber: 1532, schoolName: `Te Hihi School`, eqiNumber: 450 },
  { schoolNumber: 1533, schoolName: `Te Kohanga School`, eqiNumber: 542 },
  { schoolNumber: 1534, schoolName: `Te Papapa School`, eqiNumber: 510 },
  { schoolNumber: 1535, schoolName: `Three Kings School`, eqiNumber: 373 },
  { schoolNumber: 1536, schoolName: `Tirimoana School`, eqiNumber: 417 },
  { schoolNumber: 1537, schoolName: `Titirangi School`, eqiNumber: 366 },
  { schoolNumber: 1538, schoolName: `Torbay School`, eqiNumber: 391 },
  { schoolNumber: 1539, schoolName: `Tuakau School`, eqiNumber: 516 },
  { schoolNumber: 1540, schoolName: `Valley School`, eqiNumber: 426 },
  { schoolNumber: 1541, schoolName: `Vauxhall School`, eqiNumber: 366 },
  { schoolNumber: 1543, schoolName: `Verran Primary School`, eqiNumber: 401 },
  { schoolNumber: 1544, schoolName: `Victoria Avenue School`, eqiNumber: 344 },
  { schoolNumber: 1545, schoolName: `View Road School`, eqiNumber: 524 },
  { schoolNumber: 1546, schoolName: `Viscount School`, eqiNumber: 516 },
  { schoolNumber: 1547, schoolName: `Waiau Pa School`, eqiNumber: 428 },
  { schoolNumber: 1548, schoolName: `Waikowhai Intermediate`, eqiNumber: 442 },
  { schoolNumber: 1549, schoolName: `Waikowhai School`, eqiNumber: 433 },
  { schoolNumber: 1550, schoolName: `Waimauku School`, eqiNumber: 406 },
  { schoolNumber: 1552, schoolName: `Wainui School`, eqiNumber: 419 },
  { schoolNumber: 1553, schoolName: `Waioneke School`, eqiNumber: 448 },
  { schoolNumber: 1554, schoolName: `Waipipi School`, eqiNumber: 447 },
  { schoolNumber: 1555, schoolName: `Wairau Intermediate`, eqiNumber: 421 },
  {
    schoolNumber: 1556,
    schoolName: `Wairau Valley Special School`,
    eqiNumber: 434,
  },
  { schoolNumber: 1557, schoolName: `Waitakere School`, eqiNumber: 419 },
  { schoolNumber: 1558, schoolName: `Waitoki School`, eqiNumber: 422 },
  { schoolNumber: 1559, schoolName: `Waiuku Primary School`, eqiNumber: 453 },
  { schoolNumber: 1560, schoolName: `Wakaaranga School`, eqiNumber: 381 },
  { schoolNumber: 1561, schoolName: `Warkworth School`, eqiNumber: 433 },
  { schoolNumber: 1562, schoolName: `Waterlea Public School`, eqiNumber: 410 },
  { schoolNumber: 1563, schoolName: `Waterview School`, eqiNumber: 443 },
  { schoolNumber: 1564, schoolName: `Wesley Intermediate`, eqiNumber: 512 },
  { schoolNumber: 1565, schoolName: `Wesley Primary School`, eqiNumber: 506 },
  { schoolNumber: 1566, schoolName: `West Harbour School`, eqiNumber: 495 },
  {
    schoolNumber: 1567,
    schoolName: `Western Heights School (Auckland)`,
    eqiNumber: 395,
  },
  {
    schoolNumber: 1568,
    schoolName: `Westmere School (Auckland)`,
    eqiNumber: 378,
  },
  {
    schoolNumber: 1569,
    schoolName: `Waimahia Intermediate School`,
    eqiNumber: 525,
  },
  { schoolNumber: 1570, schoolName: `Weymouth School`, eqiNumber: 497 },
  {
    schoolNumber: 1571,
    schoolName: `Whangaparaoa School (Auckland)`,
    eqiNumber: 417,
  },
  { schoolNumber: 1572, schoolName: `Whenuapai School`, eqiNumber: 400 },
  { schoolNumber: 1573, schoolName: `Willow Park School`, eqiNumber: 365 },
  { schoolNumber: 1574, schoolName: `Wilson School`, eqiNumber: 440 },
  { schoolNumber: 1575, schoolName: `Windy Ridge School`, eqiNumber: 387 },
  { schoolNumber: 1576, schoolName: `Wiri Central School`, eqiNumber: 528 },
  { schoolNumber: 1577, schoolName: `Woodhill School`, eqiNumber: 477 },
  { schoolNumber: 1578, schoolName: `Woodlands Park School`, eqiNumber: 375 },
  { schoolNumber: 1579, schoolName: `Wymondley Road School`, eqiNumber: 523 },
  { schoolNumber: 1580, schoolName: `Yendarra School`, eqiNumber: 512 },
  { schoolNumber: 1581, schoolName: `Chapel Downs School`, eqiNumber: 479 },
  {
    schoolNumber: 1584,
    schoolName: `TKKM o Te Raki Paewhenua`,
    eqiNumber: 504,
  },
  {
    schoolNumber: 1588,
    schoolName: `St Francis Xavier Catholic School (Whangarei)`,
    eqiNumber: 404,
  },
  {
    schoolNumber: 1589,
    schoolName: `TKKM o Toku Mapihi Maurea`,
    eqiNumber: 463,
  },
  { schoolNumber: 1592, schoolName: `Marina View School`, eqiNumber: 386 },
  { schoolNumber: 1593, schoolName: `Kaitoke School (Claris)`, eqiNumber: 467 },
  { schoolNumber: 1594, schoolName: `Riverview School`, eqiNumber: 436 },
  {
    schoolNumber: 1607,
    schoolName: `Bishop Edward Gaines Catholic School`,
    eqiNumber: 480,
  },
  {
    schoolNumber: 1608,
    schoolName: `St Matthew's Primary School (Hastings)`,
    eqiNumber: 436,
  },
  { schoolNumber: 1611, schoolName: `Timaru Christian School`, eqiNumber: 446 },
  { schoolNumber: 1613, schoolName: `Te Rā School`, eqiNumber: 411 },
  {
    schoolNumber: 1616,
    schoolName: `TKKM o Ngati Kahungunu o Te Wairoa`,
    eqiNumber: 532,
  },
  { schoolNumber: 1617, schoolName: `TKKM o Ngati Rangi`, eqiNumber: 538 },
  { schoolNumber: 1618, schoolName: `TKKM o Te Whanau Tahi`, eqiNumber: 494 },
  { schoolNumber: 1619, schoolName: `Te Kura Ākonga o Manurewa` },
  { schoolNumber: 1625, schoolName: `Ascot Community School`, eqiNumber: 516 },
  {
    schoolNumber: 1627,
    schoolName: `St Paul's School (Richmond)`,
    eqiNumber: 404,
  },
  {
    schoolNumber: 1630,
    schoolName: `Central Regional Health School`,
    eqiNumber: 569,
  },
  { schoolNumber: 1631, schoolName: `Southern Health School`, eqiNumber: 569 },
  {
    schoolNumber: 1633,
    schoolName: `St Mary MacKillop Catholic School`,
    eqiNumber: 475,
  },
  { schoolNumber: 1634, schoolName: `Te Kura Māori o Porirua`, eqiNumber: 506 },
  {
    schoolNumber: 1636,
    schoolName: `St Thomas More Catholic School`,
    eqiNumber: 432,
  },
  {
    schoolNumber: 1643,
    schoolName: `St Paul's School (Massey)`,
    eqiNumber: 398,
  },
  { schoolNumber: 1645, schoolName: `Te Kura o Tōrere`, eqiNumber: 543 },
  {
    schoolNumber: 1646,
    schoolName: `Wainuiomata Intermediate`,
    eqiNumber: 502,
  },
  {
    schoolNumber: 1647,
    schoolName: `Konini Primary School (Wainuiomata)`,
    eqiNumber: 484,
  },
  { schoolNumber: 1648, schoolName: `Manaia View School`, eqiNumber: 565 },
  { schoolNumber: 1650, schoolName: `Drummond Primary School`, eqiNumber: 450 },
  { schoolNumber: 1651, schoolName: `TKKM o Wairarapa`, eqiNumber: 532 },
  {
    schoolNumber: 1657,
    schoolName: `Silverstream (South) Primary School`,
    eqiNumber: 477,
  },
  { schoolNumber: 1658, schoolName: `Putāruru Primary School`, eqiNumber: 539 },
  { schoolNumber: 1659, schoolName: `Lakeview School`, eqiNumber: 517 },
  {
    schoolNumber: 1660,
    schoolName: `Masterton Primary School`,
    eqiNumber: 502,
  },
  { schoolNumber: 1661, schoolName: `Douglas Park School`, eqiNumber: 479 },
  { schoolNumber: 1662, schoolName: `Huia Range School`, eqiNumber: 529 },
  {
    schoolNumber: 1663,
    schoolName: `Stella Maris Primary School`,
    eqiNumber: 380,
  },
  { schoolNumber: 1666, schoolName: `Te Kura o Waikare`, eqiNumber: 537 },
  {
    schoolNumber: 1667,
    schoolName: `He Puna Ruku Mātauranga o Whangaruru`,
    eqiNumber: 559,
  },
  { schoolNumber: 1668, schoolName: `Wairoa Primary School`, eqiNumber: 542 },
  { schoolNumber: 1669, schoolName: `Tiaho Primary School`, eqiNumber: 558 },
  {
    schoolNumber: 1670,
    schoolName: `Te Ara Whanui Kura Kaupapa Māori o ngā Kōhanga Reo o Te Awa Kairangi`,
    eqiNumber: 517,
  },
  { schoolNumber: 1672, schoolName: `TKKM o Nga Uri A Maui`, eqiNumber: 515 },
  {
    schoolNumber: 1673,
    schoolName: `TKKM o Te Waiu o Ngati Porou`,
    eqiNumber: 516,
  },
  {
    schoolNumber: 1674,
    schoolName: `TKKM o Te Wananga Whare Tapere o Takitimu`,
    eqiNumber: 518,
  },
  { schoolNumber: 1675, schoolName: `Ruakituri School`, eqiNumber: 494 },
  { schoolNumber: 1676, schoolName: `Te Mahia School`, eqiNumber: 501 },
  { schoolNumber: 1677, schoolName: `Mohaka School`, eqiNumber: 544 },
  { schoolNumber: 1678, schoolName: `Te Kura o Waikaremoana`, eqiNumber: 511 },
  { schoolNumber: 1679, schoolName: `Rahotu School`, eqiNumber: 503 },
  { schoolNumber: 1680, schoolName: `Aberdeen School`, eqiNumber: 451 },
  { schoolNumber: 1681, schoolName: `Allandale School`, eqiNumber: 517 },
  { schoolNumber: 1682, schoolName: `Amisfield School`, eqiNumber: 508 },
  {
    schoolNumber: 1683,
    schoolName: `Aorangi School (Rotorua)`,
    eqiNumber: 554,
  },
  { schoolNumber: 1684, schoolName: `Apanui School`, eqiNumber: 447 },
  { schoolNumber: 1686, schoolName: `Arataki School`, eqiNumber: 465 },
  { schoolNumber: 1687, schoolName: `Āria School`, eqiNumber: 461 },
  { schoolNumber: 1688, schoolName: `Arohena School`, eqiNumber: 479 },
  { schoolNumber: 1689, schoolName: `Ashbrook School`, eqiNumber: 563 },
  { schoolNumber: 1691, schoolName: `Awakeri School`, eqiNumber: 447 },
  { schoolNumber: 1693, schoolName: `Bankwood School`, eqiNumber: 526 },
  {
    schoolNumber: 1694,
    schoolName: `Bellevue School (Tauranga)`,
    eqiNumber: 445,
  },
  {
    schoolNumber: 1695,
    schoolName: `Berkley Normal Middle School`,
    eqiNumber: 420,
  },
  {
    schoolNumber: 1696,
    schoolName: `TKKM o Bernard Fergusson`,
    eqiNumber: 510,
  },
  { schoolNumber: 1697, schoolName: `Bethlehem School`, eqiNumber: 423 },
  { schoolNumber: 1698, schoolName: `Broadlands School`, eqiNumber: 462 },
  { schoolNumber: 1699, schoolName: `Te Kura o Manunui`, eqiNumber: 508 },
  { schoolNumber: 1700, schoolName: `Cambridge East School`, eqiNumber: 419 },
  { schoolNumber: 1701, schoolName: `Cambridge Middle School`, eqiNumber: 431 },
  { schoolNumber: 1702, schoolName: `Cambridge School`, eqiNumber: 403 },
  {
    schoolNumber: 1704,
    schoolName: `Cargill Open Plan School`,
    eqiNumber: 544,
  },
  { schoolNumber: 1705, schoolName: `Centennial Park School`, eqiNumber: 540 },
  { schoolNumber: 1706, schoolName: `Colville School`, eqiNumber: 478 },
  { schoolNumber: 1707, schoolName: `Coroglen School`, eqiNumber: 490 },
  { schoolNumber: 1708, schoolName: `David Henry School`, eqiNumber: 527 },
  { schoolNumber: 1709, schoolName: `David Street School`, eqiNumber: 453 },
  { schoolNumber: 1710, schoolName: `Deanwell School`, eqiNumber: 511 },
  { schoolNumber: 1711, schoolName: `Edgecumbe School`, eqiNumber: 494 },
  {
    schoolNumber: 1713,
    schoolName: `Elstow-Waihou Combined School`,
    eqiNumber: 449,
  },
  { schoolNumber: 1715, schoolName: `Fairfield Intermediate`, eqiNumber: 475 },
  {
    schoolNumber: 1716,
    schoolName: `Fairfield Primary School`,
    eqiNumber: 541,
  },
  { schoolNumber: 1717, schoolName: `Fairhaven School`, eqiNumber: 454 },
  {
    schoolNumber: 1718,
    schoolName: `Te Wharekura o Kirikiriroa`,
    eqiNumber: 518,
  },
  { schoolNumber: 1719, schoolName: `Firth School`, eqiNumber: 511 },
  { schoolNumber: 1720, schoolName: `Forest Lake School`, eqiNumber: 492 },
  { schoolNumber: 1721, schoolName: `Frankton School`, eqiNumber: 496 },
  { schoolNumber: 1722, schoolName: `Galatea School`, eqiNumber: 493 },
  { schoolNumber: 1723, schoolName: `Glen Massey School`, eqiNumber: 459 },
  { schoolNumber: 1724, schoolName: `Glenholme School`, eqiNumber: 496 },
  {
    schoolNumber: 1725,
    schoolName: `Glenview School (Hamilton)`,
    eqiNumber: 469,
  },
  {
    schoolNumber: 1726,
    schoolName: `Goldfields School (Paeroa)`,
    eqiNumber: 518,
  },
  { schoolNumber: 1727, schoolName: `Goodwood School`, eqiNumber: 388 },
  { schoolNumber: 1728, schoolName: `Gordonton School`, eqiNumber: 420 },
  {
    schoolNumber: 1729,
    schoolName: `Greenpark School (Tauranga)`,
    eqiNumber: 443,
  },
  {
    schoolNumber: 1730,
    schoolName: `Greerton Village School - Te Kura o Maarawaewae`,
    eqiNumber: 507,
  },
  { schoolNumber: 1731, schoolName: `Hamilton East School`, eqiNumber: 454 },
  { schoolNumber: 1732, schoolName: `Hamilton North School`, eqiNumber: 499 },
  { schoolNumber: 1733, schoolName: `Hamilton West School`, eqiNumber: 433 },
  { schoolNumber: 1735, schoolName: `Hautapu School`, eqiNumber: 420 },
  { schoolNumber: 1736, schoolName: `Hauturu School`, eqiNumber: 529 },
  { schoolNumber: 1737, schoolName: `Hikuai School`, eqiNumber: 446 },
  { schoolNumber: 1738, schoolName: `Hikutaia School`, eqiNumber: 481 },
  { schoolNumber: 1739, schoolName: `Hillcrest Normal School`, eqiNumber: 397 },
  { schoolNumber: 1740, schoolName: `Hilltop School`, eqiNumber: 421 },
  { schoolNumber: 1741, schoolName: `Hinuera School`, eqiNumber: 435 },
  {
    schoolNumber: 1744,
    schoolName: `Horahora School (Cambridge)`,
    eqiNumber: 441,
  },
  { schoolNumber: 1745, schoolName: `Horohoro School`, eqiNumber: 545 },
  { schoolNumber: 1746, schoolName: `Horotiu School`, eqiNumber: 464 },
  { schoolNumber: 1747, schoolName: `Horsham Downs School`, eqiNumber: 397 },
  { schoolNumber: 1748, schoolName: `TKKM o Huiarau`, eqiNumber: 536 },
  { schoolNumber: 1749, schoolName: `Hukanui School`, eqiNumber: 395 },
  {
    schoolNumber: 1750,
    schoolName: `St Patrick's Catholic School (Taupo)`,
    eqiNumber: 418,
  },
  { schoolNumber: 1751, schoolName: `Huntly School (Waikato)`, eqiNumber: 546 },
  { schoolNumber: 1752, schoolName: `Huntly West School`, eqiNumber: 560 },
  { schoolNumber: 1753, schoolName: `Insoll Avenue School`, eqiNumber: 537 },
  { schoolNumber: 1754, schoolName: `Rangitaiki School`, eqiNumber: 458 },
  { schoolNumber: 1755, schoolName: `James Street School`, eqiNumber: 507 },
  { schoolNumber: 1756, schoolName: `Kaharoa School`, eqiNumber: 445 },
  { schoolNumber: 1757, schoolName: `Kaihere School`, eqiNumber: 470 },
  { schoolNumber: 1758, schoolName: `Kaimai School`, eqiNumber: 482 },
  { schoolNumber: 1759, schoolName: `Kaingaroa Forest School`, eqiNumber: 560 },
  { schoolNumber: 1760, schoolName: `Kaipaki School`, eqiNumber: 417 },
  { schoolNumber: 1761, schoolName: `Kaitao Intermediate`, eqiNumber: 540 },
  { schoolNumber: 1762, schoolName: `Tauranga Special School`, eqiNumber: 499 },
  { schoolNumber: 1763, schoolName: `Karangahake School`, eqiNumber: 480 },
  { schoolNumber: 1764, schoolName: `Karapiro School`, eqiNumber: 499 },
  { schoolNumber: 1765, schoolName: `Katikati Primary School`, eqiNumber: 471 },
  { schoolNumber: 1766, schoolName: `Kawaha Point School`, eqiNumber: 498 },
  { schoolNumber: 1770, schoolName: `Kawerau South School`, eqiNumber: 536 },
  { schoolNumber: 1771, schoolName: `Kawhia School`, eqiNumber: 556 },
  {
    schoolNumber: 1772,
    schoolName: `Rotorua Specialist School - Te Kura Pūkenga o Rotorua`,
    eqiNumber: 523,
  },
  { schoolNumber: 1773, schoolName: `TKKM o Harataunga`, eqiNumber: 521 },
  { schoolNumber: 1775, schoolName: `Kerepehi School`, eqiNumber: 514 },
  { schoolNumber: 1776, schoolName: `Kihikihi School`, eqiNumber: 524 },
  { schoolNumber: 1777, schoolName: `Kimihia School`, eqiNumber: 510 },
  { schoolNumber: 1778, schoolName: `Kinohaku School`, eqiNumber: 526 },
  { schoolNumber: 1779, schoolName: `Kio Kio School`, eqiNumber: 464 },
  { schoolNumber: 1780, schoolName: `Kiwitahi School`, eqiNumber: 439 },
  { schoolNumber: 1781, schoolName: `Knighton Normal School`, eqiNumber: 476 },
  { schoolNumber: 1782, schoolName: `Kopuarahi School`, eqiNumber: 524 },
  { schoolNumber: 1783, schoolName: `Korakonui School`, eqiNumber: 461 },
  { schoolNumber: 1784, schoolName: `Koromatua School`, eqiNumber: 473 },
  { schoolNumber: 1785, schoolName: `Kuratau School`, eqiNumber: 475 },
  { schoolNumber: 1786, schoolName: `Kutarere School`, eqiNumber: 536 },
  {
    schoolNumber: 1787,
    schoolName: `Lake Rerewhakaaitu School`,
    eqiNumber: 479,
  },
  { schoolNumber: 1788, schoolName: `Lake Rotoma School`, eqiNumber: 541 },
  { schoolNumber: 1789, schoolName: `Leamington School`, eqiNumber: 444 },
  { schoolNumber: 1790, schoolName: `Lichfield School`, eqiNumber: 457 },
  { schoolNumber: 1791, schoolName: `Lynmore Primary School`, eqiNumber: 411 },
  { schoolNumber: 1792, schoolName: `Maeroa Intermediate`, eqiNumber: 495 },
  { schoolNumber: 1793, schoolName: `Maihiihi School`, eqiNumber: 465 },
  { schoolNumber: 1794, schoolName: `Maketu School`, eqiNumber: 538 },
  { schoolNumber: 1796, schoolName: `Malfroy School`, eqiNumber: 529 },
  { schoolNumber: 1797, schoolName: `Mamaku School`, eqiNumber: 514 },
  { schoolNumber: 1798, schoolName: `Te Wharekura o Manaia`, eqiNumber: 521 },
  { schoolNumber: 1800, schoolName: `Manawaru School`, eqiNumber: 447 },
  {
    schoolNumber: 1806,
    schoolName: `Te Kura Mana Māori o Maraenui`,
    eqiNumber: 523,
  },
  { schoolNumber: 1808, schoolName: `Marotiri School`, eqiNumber: 453 },
  {
    schoolNumber: 1809,
    schoolName: `Te Kura Mana Maori O Matahi`,
    eqiNumber: 562,
  },
  {
    schoolNumber: 1811,
    schoolName: `Te Kura o Te Moutere O Matakana`,
    eqiNumber: 499,
  },
  { schoolNumber: 1812, schoolName: `Matamata Intermediate`, eqiNumber: 472 },
  { schoolNumber: 1813, schoolName: `Matamata Primary School`, eqiNumber: 443 },
  { schoolNumber: 1814, schoolName: `Matangi School`, eqiNumber: 398 },
  { schoolNumber: 1815, schoolName: `Te Kura o Matapihi`, eqiNumber: 503 },
  { schoolNumber: 1818, schoolName: `Matata School`, eqiNumber: 514 },
  { schoolNumber: 1819, schoolName: `Matatoki School`, eqiNumber: 459 },
  { schoolNumber: 1820, schoolName: `Matua School`, eqiNumber: 401 },
  { schoolNumber: 1821, schoolName: `Maungatapu School`, eqiNumber: 468 },
  { schoolNumber: 1823, schoolName: `Melville Intermediate` },
  { schoolNumber: 1824, schoolName: `Melville Primary School`, eqiNumber: 537 },
  { schoolNumber: 1825, schoolName: `Merivale School`, eqiNumber: 548 },
  { schoolNumber: 1826, schoolName: `Mihi School`, eqiNumber: 539 },
  { schoolNumber: 1827, schoolName: `Miller Avenue School`, eqiNumber: 530 },
  { schoolNumber: 1829, schoolName: `Moanataiari School`, eqiNumber: 465 },
  { schoolNumber: 1832, schoolName: `Mokoia Intermediate`, eqiNumber: 473 },
  {
    schoolNumber: 1833,
    schoolName: `Morrinsville Intermediate`,
    eqiNumber: 478,
  },
  { schoolNumber: 1834, schoolName: `Morrinsville School`, eqiNumber: 502 },
  { schoolNumber: 1835, schoolName: `Motumaoho School`, eqiNumber: 488 },
  { schoolNumber: 1836, schoolName: `Mountview School`, eqiNumber: 516 },
  {
    schoolNumber: 1837,
    schoolName: `Mt Maunganui Intermediate`,
    eqiNumber: 444,
  },
  {
    schoolNumber: 1838,
    schoolName: `Mount Maunganui Primary School`,
    eqiNumber: 399,
  },
  { schoolNumber: 1841, schoolName: `Nawton School`, eqiNumber: 535 },
  { schoolNumber: 1842, schoolName: `Netherton School`, eqiNumber: 465 },
  { schoolNumber: 1843, schoolName: `Newstead Model School`, eqiNumber: 418 },
  { schoolNumber: 1844, schoolName: `Ngahinapouri School`, eqiNumber: 415 },
  { schoolNumber: 1845, schoolName: `Ngakonui Valley School`, eqiNumber: 490 },
  { schoolNumber: 1846, schoolName: `Ngakuru School`, eqiNumber: 461 },
  { schoolNumber: 1847, schoolName: `Te Kura o Ngāpuke`, eqiNumber: 562 },
  { schoolNumber: 1849, schoolName: `Ngaruawahia School`, eqiNumber: 553 },
  { schoolNumber: 1850, schoolName: `Ngatea School`, eqiNumber: 452 },
  { schoolNumber: 1851, schoolName: `Te Kura o Ngaati Hauaa`, eqiNumber: 524 },
  { schoolNumber: 1852, schoolName: `Ngongotaha School`, eqiNumber: 486 },
  { schoolNumber: 1853, schoolName: `Ngutunui School`, eqiNumber: 465 },
  { schoolNumber: 1854, schoolName: `Nukuhou North School`, eqiNumber: 532 },
  { schoolNumber: 1855, schoolName: `Ohaupo School`, eqiNumber: 421 },
  { schoolNumber: 1856, schoolName: `Ohinewai School`, eqiNumber: 484 },
  { schoolNumber: 1857, schoolName: `Ōhope Beach School`, eqiNumber: 419 },
  { schoolNumber: 1858, schoolName: `Kuranui Primary School`, eqiNumber: 472 },
  { schoolNumber: 1860, schoolName: `Omanu School`, eqiNumber: 403 },
  { schoolNumber: 1861, schoolName: `Te Kura o Ōmarumutu`, eqiNumber: 519 },
  { schoolNumber: 1862, schoolName: `Ōmokoroa Point School`, eqiNumber: 432 },
  { schoolNumber: 1863, schoolName: `Omokoroa School`, eqiNumber: 423 },
  {
    schoolNumber: 1865,
    schoolName: `Te Wharekura o Maniapoto`,
    eqiNumber: 527,
  },
  { schoolNumber: 1866, schoolName: `Opotiki School`, eqiNumber: 555 },
  { schoolNumber: 1867, schoolName: `Ōpoutere School`, eqiNumber: 459 },
  { schoolNumber: 1869, schoolName: `Orini Combined School`, eqiNumber: 460 },
  { schoolNumber: 1870, schoolName: `Oropi School`, eqiNumber: 434 },
  { schoolNumber: 1871, schoolName: `Otakiri School`, eqiNumber: 466 },
  { schoolNumber: 1872, schoolName: `Otamarakau School`, eqiNumber: 466 },
  { schoolNumber: 1873, schoolName: `TKKM o Otepou`, eqiNumber: 546 },
  { schoolNumber: 1874, schoolName: `Ōtewā School`, eqiNumber: 483 },
  { schoolNumber: 1875, schoolName: `Otonga Road School`, eqiNumber: 415 },
  { schoolNumber: 1876, schoolName: `Ōtorohanga School`, eqiNumber: 538 },
  { schoolNumber: 1877, schoolName: `Otorohanga South School`, eqiNumber: 481 },
  { schoolNumber: 1878, schoolName: `Ōtūmoetai Intermediate`, eqiNumber: 440 },
  {
    schoolNumber: 1879,
    schoolName: `Ōtūmoetai Primary School`,
    eqiNumber: 433,
  },
  {
    schoolNumber: 1880,
    schoolName: `St Mary's Catholic School (Otorohanga)`,
    eqiNumber: 488,
  },
  { schoolNumber: 1881, schoolName: `Owhata School`, eqiNumber: 536 },
  { schoolNumber: 1882, schoolName: `Paengaroa School`, eqiNumber: 468 },
  { schoolNumber: 1883, schoolName: `Paeroa Central School`, eqiNumber: 545 },
  { schoolNumber: 1884, schoolName: `Pahoia School`, eqiNumber: 428 },
  { schoolNumber: 1885, schoolName: `Pāpāmoa Primary School`, eqiNumber: 432 },
  { schoolNumber: 1886, schoolName: `Pārāwai School`, eqiNumber: 468 },
  { schoolNumber: 1888, schoolName: `Te Kura o Te Paroa`, eqiNumber: 520 },
  { schoolNumber: 1889, schoolName: `Paterangi School`, eqiNumber: 467 },
  { schoolNumber: 1891, schoolName: `Patricia Avenue School`, eqiNumber: 500 },
  { schoolNumber: 1892, schoolName: `Peachgrove Intermediate`, eqiNumber: 485 },
  { schoolNumber: 1893, schoolName: `Pekapekarau School`, eqiNumber: 493 },
  { schoolNumber: 1894, schoolName: `Pillans Point School`, eqiNumber: 405 },
  { schoolNumber: 1895, schoolName: `Piopio Primary School`, eqiNumber: 460 },
  { schoolNumber: 1896, schoolName: `Piripiri School`, eqiNumber: 490 },
  { schoolNumber: 1897, schoolName: `Pirongia School`, eqiNumber: 432 },
  { schoolNumber: 1898, schoolName: `Pokuru School`, eqiNumber: 461 },
  { schoolNumber: 1899, schoolName: `Pongakawa School`, eqiNumber: 448 },
  { schoolNumber: 1902, schoolName: `Puahue School`, eqiNumber: 425 },
  { schoolNumber: 1903, schoolName: `Pukeatua School`, eqiNumber: 464 },
  { schoolNumber: 1904, schoolName: `Pukehina School`, eqiNumber: 555 },
  {
    schoolNumber: 1906,
    schoolName: `Pukenui School (Te Kuiti)`,
    eqiNumber: 540,
  },
  { schoolNumber: 1907, schoolName: `Puketaha School`, eqiNumber: 421 },
  { schoolNumber: 1908, schoolName: `Pukete School`, eqiNumber: 459 },
  { schoolNumber: 1911, schoolName: `Puriri School`, eqiNumber: 475 },
  { schoolNumber: 1912, schoolName: `Te Puru School`, eqiNumber: 456 },
  { schoolNumber: 1916, schoolName: `Pyes Pa Road School`, eqiNumber: 443 },
  {
    schoolNumber: 1917,
    schoolName: `Te Wharekura o Rākaumangamanga`,
    eqiNumber: 516,
  },
  { schoolNumber: 1919, schoolName: `Te Kura o Rangiriri`, eqiNumber: 539 },
  { schoolNumber: 1920, schoolName: `Rangitoto School`, eqiNumber: 426 },
  { schoolNumber: 1921, schoolName: `Rangiuru School`, eqiNumber: 493 },
  { schoolNumber: 1923, schoolName: `Reporoa School`, eqiNumber: 487 },
  { schoolNumber: 1924, schoolName: `Rhode Street School`, eqiNumber: 537 },
  { schoolNumber: 1927, schoolName: `Roto-O-Rangi School`, eqiNumber: 468 },
  { schoolNumber: 1929, schoolName: `TKKM o Rotoiti`, eqiNumber: 541 },
  { schoolNumber: 1930, schoolName: `Rotokauri School`, eqiNumber: 423 },
  { schoolNumber: 1931, schoolName: `Rotokawa School`, eqiNumber: 498 },
  { schoolNumber: 1933, schoolName: `Rotorua Intermediate`, eqiNumber: 505 },
  { schoolNumber: 1934, schoolName: `Rotorua School`, eqiNumber: 522 },
  { schoolNumber: 1937, schoolName: `Ruawaro Combined School`, eqiNumber: 479 },
  { schoolNumber: 1938, schoolName: `Rukuhia School`, eqiNumber: 426 },
  { schoolNumber: 1939, schoolName: `Selwyn School`, eqiNumber: 544 },
  {
    schoolNumber: 1940,
    schoolName: `Silverdale Normal School`,
    eqiNumber: 464,
  },
  { schoolNumber: 1941, schoolName: `Springdale School`, eqiNumber: 490 },
  {
    schoolNumber: 1942,
    schoolName: `St Andrews Middle School`,
    eqiNumber: 541,
  },
  {
    schoolNumber: 1943,
    schoolName: `St Anthony's Catholic School (Huntly)`,
    eqiNumber: 457,
  },
  {
    schoolNumber: 1944,
    schoolName: `St Columba's Catholic School (Frankton)`,
    eqiNumber: 425,
  },
  {
    schoolNumber: 1945,
    schoolName: `St Francis School (Thames)`,
    eqiNumber: 409,
  },
  {
    schoolNumber: 1946,
    schoolName: `St Joseph's Catholic School (Fairfield)`,
    eqiNumber: 399,
  },
  {
    schoolNumber: 1947,
    schoolName: `St Joseph's Catholic School (Matamata)`,
    eqiNumber: 447,
  },
  {
    schoolNumber: 1948,
    schoolName: `St Joseph's Catholic School (Matata)`,
    eqiNumber: 546,
  },
  {
    schoolNumber: 1949,
    schoolName: `St Joseph's Catholic School (Morrinsville)`,
    eqiNumber: 420,
  },
  {
    schoolNumber: 1950,
    schoolName: `St Joseph's Catholic School (Opotiki)`,
    eqiNumber: 467,
  },
  {
    schoolNumber: 1951,
    schoolName: `St Joseph's Catholic School (Paeroa)`,
    eqiNumber: 444,
  },
  {
    schoolNumber: 1952,
    schoolName: `St Joseph's Catholic School (Te Aroha)`,
    eqiNumber: 446,
  },
  {
    schoolNumber: 1953,
    schoolName: `St Joseph's Catholic School (Te Kuiti)`,
    eqiNumber: 449,
  },
  {
    schoolNumber: 1954,
    schoolName: `St Joseph's Catholic School (Waihi)`,
    eqiNumber: 447,
  },
  {
    schoolNumber: 1955,
    schoolName: `St Joseph's Catholic School (Whakatane)`,
    eqiNumber: 430,
  },
  {
    schoolNumber: 1957,
    schoolName: `St Mary's Catholic School (Putāruru)`,
    eqiNumber: 455,
  },
  {
    schoolNumber: 1958,
    schoolName: `St Mary's Catholic School (Rotorua)`,
    eqiNumber: 387,
  },
  {
    schoolNumber: 1959,
    schoolName: `St Mary's Catholic School (Tauranga)`,
    eqiNumber: 385,
  },
  {
    schoolNumber: 1960,
    schoolName: `St Michael's Catholic School (Rotorua)`,
    eqiNumber: 444,
  },
  {
    schoolNumber: 1961,
    schoolName: `St Patrick's Catholic School (Taumarunui)`,
    eqiNumber: 465,
  },
  {
    schoolNumber: 1962,
    schoolName: `St Patrick's Catholic School (Te Awamutu)`,
    eqiNumber: 427,
  },
  {
    schoolNumber: 1963,
    schoolName: `St Paul's Catholic School (Ngaruawahia)`,
    eqiNumber: 456,
  },
  {
    schoolNumber: 1964,
    schoolName: `St Peter Chanel Catholic School (Te Rapa)`,
    eqiNumber: 407,
  },
  {
    schoolNumber: 1965,
    schoolName: `St Peter's Catholic School (Cambridge)`,
    eqiNumber: 399,
  },
  {
    schoolNumber: 1966,
    schoolName: `St Pius X Catholic School (Melville)`,
    eqiNumber: 378,
  },
  { schoolNumber: 1967, schoolName: `Stanley Avenue School`, eqiNumber: 477 },
  { schoolNumber: 1968, schoolName: `Strathmore School`, eqiNumber: 530 },
  { schoolNumber: 1970, schoolName: `Sunset Primary School`, eqiNumber: 551 },
  { schoolNumber: 1971, schoolName: `Te Kura o Tahaaroa`, eqiNumber: 510 },
  { schoolNumber: 1972, schoolName: `Tahuna School`, eqiNumber: 459 },
  {
    schoolNumber: 1974,
    schoolName: `Tainui Full Primary School`,
    eqiNumber: 526,
  },
  { schoolNumber: 1975, schoolName: `Tairua School`, eqiNumber: 440 },
  {
    schoolNumber: 1976,
    schoolName: `Tamahere Model Country School`,
    eqiNumber: 372,
  },
  { schoolNumber: 1978, schoolName: `Taneatua School`, eqiNumber: 552 },
  { schoolNumber: 1980, schoolName: `Tapu School`, eqiNumber: 521 },
  { schoolNumber: 1982, schoolName: `Tarrangower School`, eqiNumber: 549 },
  { schoolNumber: 1983, schoolName: `Tatuanui School`, eqiNumber: 426 },
  { schoolNumber: 1984, schoolName: `Tauhara School`, eqiNumber: 522 },
  { schoolNumber: 1985, schoolName: `Tauhei Combined School`, eqiNumber: 456 },
  {
    schoolNumber: 1986,
    schoolName: `Taumarunui Primary School`,
    eqiNumber: 554,
  },
  { schoolNumber: 1987, schoolName: `Taupiri School`, eqiNumber: 502 },
  { schoolNumber: 1988, schoolName: `Taupo Intermediate`, eqiNumber: 472 },
  { schoolNumber: 1989, schoolName: `Taupo School`, eqiNumber: 450 },
  { schoolNumber: 1990, schoolName: `Tauranga Intermediate`, eqiNumber: 475 },
  { schoolNumber: 1991, schoolName: `Tauranga Primary School`, eqiNumber: 423 },
  { schoolNumber: 1992, schoolName: `Gate Pa School`, eqiNumber: 507 },
  { schoolNumber: 1994, schoolName: `Tauriko School`, eqiNumber: 440 },
  { schoolNumber: 1995, schoolName: `Tauwhare School`, eqiNumber: 423 },
  { schoolNumber: 1996, schoolName: `Tāwera Bilingual School`, eqiNumber: 547 },
  { schoolNumber: 1998, schoolName: `Te Akau School`, eqiNumber: 466 },
  { schoolNumber: 1999, schoolName: `Te Aroha Primary School`, eqiNumber: 496 },
  { schoolNumber: 2001, schoolName: `Te Awamutu Intermediate`, eqiNumber: 479 },
  {
    schoolNumber: 2002,
    schoolName: `Te Awamutu Primary School`,
    eqiNumber: 461,
  },
  {
    schoolNumber: 2005,
    schoolName: `Te Kauwhata Primary School`,
    eqiNumber: 475,
  },
  { schoolNumber: 2007, schoolName: `Te Kowhai School`, eqiNumber: 414 },
  { schoolNumber: 2008, schoolName: `Te Kuiti Primary School`, eqiNumber: 489 },
  { schoolNumber: 2009, schoolName: `Te Mahoe School`, eqiNumber: 556 },
  { schoolNumber: 2010, schoolName: `Te Mata School (Raglan)`, eqiNumber: 413 },
  { schoolNumber: 2011, schoolName: `TKKM o Te Matai`, eqiNumber: 532 },
  { schoolNumber: 2012, schoolName: `Te Miro School`, eqiNumber: 406 },
  { schoolNumber: 2013, schoolName: `Te Pahu School`, eqiNumber: 438 },
  { schoolNumber: 2014, schoolName: `Te Poi School`, eqiNumber: 486 },
  { schoolNumber: 2015, schoolName: `Te Puke Intermediate`, eqiNumber: 473 },
  { schoolNumber: 2016, schoolName: `Te Puke Primary School`, eqiNumber: 469 },
  { schoolNumber: 2017, schoolName: `Te Puna School`, eqiNumber: 466 },
  { schoolNumber: 2019, schoolName: `Te Ranga School`, eqiNumber: 447 },
  { schoolNumber: 2020, schoolName: `Te Rapa School`, eqiNumber: 443 },
  { schoolNumber: 2021, schoolName: `Te Rerenga School`, eqiNumber: 428 },
  { schoolNumber: 2023, schoolName: `Te Kura O Te Teko`, eqiNumber: 532 },
  { schoolNumber: 2024, schoolName: `Te Uku School`, eqiNumber: 428 },
  { schoolNumber: 2025, schoolName: `Te Waotu School`, eqiNumber: 448 },
  { schoolNumber: 2027, schoolName: `Thames South School`, eqiNumber: 541 },
  { schoolNumber: 2028, schoolName: `Thornton School`, eqiNumber: 451 },
  { schoolNumber: 2031, schoolName: `Tirau Primary School`, eqiNumber: 477 },
  { schoolNumber: 2032, schoolName: `Tirohanga School`, eqiNumber: 506 },
  { schoolNumber: 2033, schoolName: `Tirohia School`, eqiNumber: 542 },
  { schoolNumber: 2035, schoolName: `Tokoroa Central School`, eqiNumber: 538 },
  { schoolNumber: 2037, schoolName: `Tokoroa Intermediate`, eqiNumber: 519 },
  { schoolNumber: 2038, schoolName: `Tokoroa North School`, eqiNumber: 494 },
  { schoolNumber: 2040, schoolName: `Turaki School`, eqiNumber: 512 },
  { schoolNumber: 2043, schoolName: `Turua Primary School`, eqiNumber: 470 },
  { schoolNumber: 2044, schoolName: `Upper Atiamuri School`, eqiNumber: 468 },
  { schoolNumber: 2045, schoolName: `Vardon School`, eqiNumber: 474 },
  { schoolNumber: 2046, schoolName: `Waerenga School`, eqiNumber: 451 },
  { schoolNumber: 2047, schoolName: `Te Kura o Waharoa`, eqiNumber: 563 },
  { schoolNumber: 2048, schoolName: `Waihi Beach School`, eqiNumber: 442 },
  { schoolNumber: 2049, schoolName: `Waihi East School`, eqiNumber: 470 },
  { schoolNumber: 2050, schoolName: `Waihi Central School`, eqiNumber: 534 },
  { schoolNumber: 2052, schoolName: `Waikaretu School`, eqiNumber: 452 },
  { schoolNumber: 2054, schoolName: `Waikino School`, eqiNumber: 462 },
  { schoolNumber: 2055, schoolName: `Waikite Valley School`, eqiNumber: 445 },
  { schoolNumber: 2057, schoolName: `Waimana School`, eqiNumber: 542 },
  { schoolNumber: 2058, schoolName: `Waimata School`, eqiNumber: 489 },
  { schoolNumber: 2060, schoolName: `Waingaro School`, eqiNumber: 492 },
  { schoolNumber: 2061, schoolName: `Te Kura o Waioweka`, eqiNumber: 533 },
  {
    schoolNumber: 2062,
    schoolName: `Te Kura Māori ā Rohe o Waiohau`,
    eqiNumber: 534,
  },
  { schoolNumber: 2063, schoolName: `Waiotahe Valley School`, eqiNumber: 505 },
  { schoolNumber: 2064, schoolName: `Waipa School`, eqiNumber: 527 },
  { schoolNumber: 2065, schoolName: `Waipahihi School`, eqiNumber: 451 },
  { schoolNumber: 2066, schoolName: `Wairakei School`, eqiNumber: 440 },
  { schoolNumber: 2068, schoolName: `Te Kura o Waitahanui`, eqiNumber: 527 },
  { schoolNumber: 2069, schoolName: `Waitakaruru School`, eqiNumber: 493 },
  { schoolNumber: 2071, schoolName: `Waitetuna School`, eqiNumber: 423 },
  { schoolNumber: 2073, schoolName: `Waitomo Caves School`, eqiNumber: 526 },
  { schoolNumber: 2074, schoolName: `Walton School`, eqiNumber: 456 },
  { schoolNumber: 2075, schoolName: `Wairere School`, eqiNumber: 477 },
  { schoolNumber: 2076, schoolName: `Welcome Bay School`, eqiNumber: 469 },
  { schoolNumber: 2077, schoolName: `Westbrook School`, eqiNumber: 475 },
  {
    schoolNumber: 2078,
    schoolName: `Western Heights Primary School (Rotorua)`,
    eqiNumber: 536,
  },
  { schoolNumber: 2079, schoolName: `Whakamarama School`, eqiNumber: 423 },
  { schoolNumber: 2080, schoolName: `Whakamaru School`, eqiNumber: 494 },
  { schoolNumber: 2081, schoolName: `Whakarewarewa School`, eqiNumber: 557 },
  { schoolNumber: 2082, schoolName: `Whakatane Intermediate`, eqiNumber: 486 },
  { schoolNumber: 2083, schoolName: `Whangamarino School`, eqiNumber: 531 },
  {
    schoolNumber: 2084,
    schoolName: `Te Kura Mana Māori o Whangaparaoa`,
    eqiNumber: 519,
  },
  { schoolNumber: 2086, schoolName: `Wharepapa South School`, eqiNumber: 496 },
  { schoolNumber: 2087, schoolName: `Whatawhata School`, eqiNumber: 446 },
  { schoolNumber: 2088, schoolName: `Whenuakite School`, eqiNumber: 428 },
  { schoolNumber: 2090, schoolName: `Whitikahu School`, eqiNumber: 458 },
  { schoolNumber: 2091, schoolName: `Whitiora School`, eqiNumber: 531 },
  {
    schoolNumber: 2092,
    schoolName: `Woodlands School (Opotiki)`,
    eqiNumber: 516,
  },
  { schoolNumber: 2093, schoolName: `Woodstock School`, eqiNumber: 443 },
  {
    schoolNumber: 2094,
    schoolName: `Marian Catholic School (Hamilton)`,
    eqiNumber: 393,
  },
  { schoolNumber: 2095, schoolName: `Kaponga School`, eqiNumber: 505 },
  { schoolNumber: 2096, schoolName: `Crawshaw School`, eqiNumber: 536 },
  {
    schoolNumber: 2097,
    schoolName: `Manaia School (Taranaki)`,
    eqiNumber: 553,
  },
  { schoolNumber: 2098, schoolName: `Matapu School`, eqiNumber: 467 },
  { schoolNumber: 2099, schoolName: `Trentham School`, eqiNumber: 464 },
  { schoolNumber: 2100, schoolName: `Koraunui School`, eqiNumber: 495 },
  { schoolNumber: 2101, schoolName: `Tautoro School`, eqiNumber: 550 },
  { schoolNumber: 2102, schoolName: `Maromaku School`, eqiNumber: 485 },
  { schoolNumber: 2103, schoolName: `Moerewa School`, eqiNumber: 552 },
  { schoolNumber: 2104, schoolName: `TKKM o Taumarere`, eqiNumber: 523 },
  {
    schoolNumber: 2105,
    schoolName: `Awahono School - Grey Valley`,
    eqiNumber: 463,
  },
  { schoolNumber: 2106, schoolName: `Paparoa Range School`, eqiNumber: 516 },
  {
    schoolNumber: 2107,
    schoolName: `Geraldine Primary School`,
    eqiNumber: 439,
  },
  { schoolNumber: 2108, schoolName: `Winchester Rural School`, eqiNumber: 457 },
  { schoolNumber: 2109, schoolName: `Temuka Primary School`, eqiNumber: 476 },
  {
    schoolNumber: 2110,
    schoolName: `Oceanview Heights School`,
    eqiNumber: 523,
  },
  { schoolNumber: 2111, schoolName: `Grantlea Downs School`, eqiNumber: 498 },
  { schoolNumber: 2112, schoolName: `Barton Rural School`, eqiNumber: 419 },
  { schoolNumber: 2113, schoolName: `Bluestone School`, eqiNumber: 474 },
  { schoolNumber: 2114, schoolName: `Beaconsfield School`, eqiNumber: 438 },
  { schoolNumber: 2115, schoolName: `Timaru South School`, eqiNumber: 511 },
  { schoolNumber: 2116, schoolName: `New River Primary`, eqiNumber: 522 },
  {
    schoolNumber: 2117,
    schoolName: `Fernworth Primary School`,
    eqiNumber: 535,
  },
  { schoolNumber: 2118, schoolName: `Newfield Park School`, eqiNumber: 506 },
  { schoolNumber: 2119, schoolName: `Donovan Primary School`, eqiNumber: 464 },
  { schoolNumber: 2120, schoolName: `Bluff School`, eqiNumber: 511 },
  { schoolNumber: 2123, schoolName: `Lake Brunner School`, eqiNumber: 482 },
  { schoolNumber: 2150, schoolName: `Ahititi School`, eqiNumber: 521 },
  { schoolNumber: 2152, schoolName: `Auroa School`, eqiNumber: 473 },
  { schoolNumber: 2153, schoolName: `Avon School`, eqiNumber: 549 },
  { schoolNumber: 2157, schoolName: `Bell Block School`, eqiNumber: 441 },
  {
    schoolNumber: 2160,
    schoolName: `Central School Te Kura Waenga O Ngāmotu`,
    eqiNumber: 417,
  },
  { schoolNumber: 2161, schoolName: `Devon Intermediate`, eqiNumber: 494 },
  { schoolNumber: 2164, schoolName: `Egmont Village School`, eqiNumber: 432 },
  { schoolNumber: 2165, schoolName: `Eltham School`, eqiNumber: 521 },
  { schoolNumber: 2167, schoolName: `Fitzroy School`, eqiNumber: 422 },
  { schoolNumber: 2168, schoolName: `Frankley School`, eqiNumber: 422 },
  { schoolNumber: 2171, schoolName: `Hāwera Primary School`, eqiNumber: 521 },
  { schoolNumber: 2172, schoolName: `Highlands Intermediate`, eqiNumber: 444 },
  { schoolNumber: 2173, schoolName: `Huiakama School`, eqiNumber: 498 },
  { schoolNumber: 2175, schoolName: `Huirangi School`, eqiNumber: 476 },
  {
    schoolNumber: 2177,
    schoolName: `Inglewood Primary School`,
    eqiNumber: 477,
  },
  { schoolNumber: 2178, schoolName: `Kaimata School`, eqiNumber: 444 },
  { schoolNumber: 2182, schoolName: `Lepperton School`, eqiNumber: 423 },
  { schoolNumber: 2185, schoolName: `Makahu School`, eqiNumber: 472 },
  { schoolNumber: 2189, schoolName: `Mangorei School`, eqiNumber: 412 },
  { schoolNumber: 2190, schoolName: `Manukorihi Intermediate`, eqiNumber: 512 },
  { schoolNumber: 2191, schoolName: `Marco School`, eqiNumber: 458 },
  {
    schoolNumber: 2192,
    schoolName: `Marfell Community School`,
    eqiNumber: 542,
  },
  { schoolNumber: 2195, schoolName: `Matiere School`, eqiNumber: 485 },
  { schoolNumber: 2197, schoolName: `Merrilands School`, eqiNumber: 479 },
  { schoolNumber: 2198, schoolName: `Midhirst School`, eqiNumber: 477 },
  { schoolNumber: 2199, schoolName: `Mimi School`, eqiNumber: 473 },
  { schoolNumber: 2200, schoolName: `Mokau School`, eqiNumber: 505 },
  { schoolNumber: 2201, schoolName: `Mokoia School`, eqiNumber: 478 },
  { schoolNumber: 2203, schoolName: `Moturoa School`, eqiNumber: 458 },
  { schoolNumber: 2205, schoolName: `Ngaere School`, eqiNumber: 471 },
  { schoolNumber: 2206, schoolName: `Norfolk School`, eqiNumber: 434 },
  { schoolNumber: 2207, schoolName: `Normanby School`, eqiNumber: 503 },
  { schoolNumber: 2208, schoolName: `Oakura School`, eqiNumber: 390 },
  { schoolNumber: 2214, schoolName: `Ōmata School`, eqiNumber: 410 },
  { schoolNumber: 2215, schoolName: `Ongarue School`, eqiNumber: 475 },
  { schoolNumber: 2216, schoolName: `Opunake School`, eqiNumber: 499 },
  { schoolNumber: 2220, schoolName: `Pembroke School`, eqiNumber: 480 },
  {
    schoolNumber: 2223,
    schoolName: `Puketapu School (New Plymouth)`,
    eqiNumber: 480,
  },
  { schoolNumber: 2226, schoolName: `Ramanui School`, eqiNumber: 556 },
  { schoolNumber: 2227, schoolName: `Ratapiko School`, eqiNumber: 463 },
  { schoolNumber: 2228, schoolName: `Rawhitiroa School`, eqiNumber: 475 },
  {
    schoolNumber: 2232,
    schoolName: `Spotswood Primary School`,
    eqiNumber: 507,
  },
  {
    schoolNumber: 2233,
    schoolName: `St John Bosco School (New Plymouth)`,
    eqiNumber: 385,
  },
  {
    schoolNumber: 2235,
    schoolName: `St Joseph's School (Hawera)`,
    eqiNumber: 439,
  },
  {
    schoolNumber: 2236,
    schoolName: `St Joseph's School (New Plymouth)`,
    eqiNumber: 384,
  },
  {
    schoolNumber: 2237,
    schoolName: `St Joseph's School (Opunake)`,
    eqiNumber: 441,
  },
  {
    schoolNumber: 2238,
    schoolName: `St Joseph's School (Stratford)`,
    eqiNumber: 444,
  },
  {
    schoolNumber: 2239,
    schoolName: `St Joseph's School (Waitara)`,
    eqiNumber: 510,
  },
  {
    schoolNumber: 2240,
    schoolName: `St Patrick's School (Kaponga)`,
    eqiNumber: 437,
  },
  {
    schoolNumber: 2241,
    schoolName: `St Patrick's School (Inglewood)`,
    eqiNumber: 436,
  },
  {
    schoolNumber: 2242,
    schoolName: `St Pius X School (New Plymouth)`,
    eqiNumber: 391,
  },
  {
    schoolNumber: 2244,
    schoolName: `Stratford Primary School`,
    eqiNumber: 488,
  },
  { schoolNumber: 2248, schoolName: `Tawhiti School`, eqiNumber: 473 },
  { schoolNumber: 2251, schoolName: `Tikorangi School`, eqiNumber: 464 },
  { schoolNumber: 2253, schoolName: `Tokirima School`, eqiNumber: 456 },
  { schoolNumber: 2254, schoolName: `Toko School`, eqiNumber: 461 },
  { schoolNumber: 2255, schoolName: `Turuturu School`, eqiNumber: 466 },
  { schoolNumber: 2256, schoolName: `Urenui School`, eqiNumber: 447 },
  { schoolNumber: 2257, schoolName: `Uruti School`, eqiNumber: 472 },
  { schoolNumber: 2258, schoolName: `Vogeltown School`, eqiNumber: 447 },
  { schoolNumber: 2260, schoolName: `Waitara Central School`, eqiNumber: 535 },
  { schoolNumber: 2261, schoolName: `Waitara East School`, eqiNumber: 532 },
  { schoolNumber: 2262, schoolName: `Waitoriki School`, eqiNumber: 458 },
  { schoolNumber: 2264, schoolName: `Welbourn School`, eqiNumber: 425 },
  {
    schoolNumber: 2265,
    schoolName: `West End Te Kura O Morere`,
    eqiNumber: 462,
  },
  { schoolNumber: 2266, schoolName: `Westown School`, eqiNumber: 533 },
  { schoolNumber: 2267, schoolName: `Whareorino School`, eqiNumber: 525 },
  { schoolNumber: 2268, schoolName: `Woodleigh School`, eqiNumber: 437 },
  { schoolNumber: 2330, schoolName: `Aberfeldy School`, eqiNumber: 568 },
  { schoolNumber: 2332, schoolName: `Aokautere School`, eqiNumber: 393 },
  { schoolNumber: 2333, schoolName: `Apiti School`, eqiNumber: 488 },
  { schoolNumber: 2334, schoolName: `Arahunga School`, eqiNumber: 527 },
  {
    schoolNumber: 2336,
    schoolName: `Aranui School (Wanganui)`,
    eqiNumber: 536,
  },
  { schoolNumber: 2337, schoolName: `Ashhurst School`, eqiNumber: 459 },
  { schoolNumber: 2338, schoolName: `Awahou School`, eqiNumber: 461 },
  {
    schoolNumber: 2339,
    schoolName: `Awapuni School (P North)`,
    eqiNumber: 531,
  },
  { schoolNumber: 2341, schoolName: `Bainesse School`, eqiNumber: 485 },
  { schoolNumber: 2342, schoolName: `Brunswick School`, eqiNumber: 474 },
  { schoolNumber: 2343, schoolName: `Bulls School`, eqiNumber: 481 },
  { schoolNumber: 2344, schoolName: `Bunnythorpe School`, eqiNumber: 525 },
  { schoolNumber: 2345, schoolName: `Carlton School`, eqiNumber: 507 },
  { schoolNumber: 2346, schoolName: `Castlecliff School`, eqiNumber: 535 },
  { schoolNumber: 2348, schoolName: `Churton School`, eqiNumber: 516 },
  { schoolNumber: 2349, schoolName: `Clifton School (Bulls)`, eqiNumber: 487 },
  { schoolNumber: 2350, schoolName: `Cloverlea School`, eqiNumber: 494 },
  { schoolNumber: 2351, schoolName: `TKKM o Otepoti`, eqiNumber: 527 },
  { schoolNumber: 2352, schoolName: `Coley Street School`, eqiNumber: 516 },
  {
    schoolNumber: 2353,
    schoolName: `College Street Normal School`,
    eqiNumber: 409,
  },
  { schoolNumber: 2354, schoolName: `Colyton School`, eqiNumber: 433 },
  { schoolNumber: 2355, schoolName: `Durie Hill School`, eqiNumber: 463 },
  { schoolNumber: 2356, schoolName: `Feilding Intermediate`, eqiNumber: 478 },
  { schoolNumber: 2357, schoolName: `Fordell School`, eqiNumber: 455 },
  { schoolNumber: 2358, schoolName: `Foxton Beach School`, eqiNumber: 507 },
  { schoolNumber: 2359, schoolName: `Foxton School`, eqiNumber: 547 },
  { schoolNumber: 2360, schoolName: `Glen Oroua School`, eqiNumber: 415 },
  { schoolNumber: 2361, schoolName: `Gonville School`, eqiNumber: 513 },
  { schoolNumber: 2362, schoolName: `Halcombe Primary School`, eqiNumber: 427 },
  { schoolNumber: 2363, schoolName: `Te Kura o Wairau`, eqiNumber: 541 },
  { schoolNumber: 2364, schoolName: `Hiwinui School`, eqiNumber: 415 },
  { schoolNumber: 2365, schoolName: `Hokowhitu School`, eqiNumber: 426 },
  {
    schoolNumber: 2366,
    schoolName: `Hunterville Consolidated School`,
    eqiNumber: 446,
  },
  { schoolNumber: 2368, schoolName: `James Cook School`, eqiNumber: 499 },
  { schoolNumber: 2369, schoolName: `Kai Iwi School`, eqiNumber: 483 },
  { schoolNumber: 2370, schoolName: `Kairanga School`, eqiNumber: 449 },
  { schoolNumber: 2371, schoolName: `Kaitieke School`, eqiNumber: 459 },
  {
    schoolNumber: 2372,
    schoolName: `Kaitoke School (Wanganui)`,
    eqiNumber: 453,
  },
  { schoolNumber: 2374, schoolName: `Kakaramea School`, eqiNumber: 457 },
  { schoolNumber: 2375, schoolName: `Kakatahi School`, eqiNumber: 526 },
  { schoolNumber: 2377, schoolName: `TKKM o Tupoho`, eqiNumber: 549 },
  { schoolNumber: 2378, schoolName: `Keith Street School`, eqiNumber: 528 },
  { schoolNumber: 2379, schoolName: `Kimbolton School`, eqiNumber: 453 },
  { schoolNumber: 2382, schoolName: `Kiwitea School`, eqiNumber: 455 },
  { schoolNumber: 2383, schoolName: `TKKM o Ngati Ruanui`, eqiNumber: 531 },
  { schoolNumber: 2384, schoolName: `Te Kura o Kokohuia`, eqiNumber: 532 },
  { schoolNumber: 2385, schoolName: `Kopane School`, eqiNumber: 447 },
  { schoolNumber: 2386, schoolName: `Linton Camp School`, eqiNumber: 482 },
  { schoolNumber: 2387, schoolName: `Linton Country School` },
  { schoolNumber: 2388, schoolName: `Longburn School`, eqiNumber: 489 },
  { schoolNumber: 2389, schoolName: `Lytton Street School`, eqiNumber: 478 },
  {
    schoolNumber: 2390,
    schoolName: `Manchester Street School`,
    eqiNumber: 449,
  },
  {
    schoolNumber: 2391,
    schoolName: `Mangamahu Primary School`,
    eqiNumber: 553,
  },
  { schoolNumber: 2392, schoolName: `Mangaweka School`, eqiNumber: 458 },
  { schoolNumber: 2393, schoolName: `Manunui School`, eqiNumber: 508 },
  {
    schoolNumber: 2395,
    schoolName: `St Marcellin School (Wanganui)`,
    eqiNumber: 504,
  },
  { schoolNumber: 2396, schoolName: `Marton Junction School`, eqiNumber: 529 },
  { schoolNumber: 2397, schoolName: `Marton School`, eqiNumber: 491 },
  { schoolNumber: 2398, schoolName: `Mataroa School`, eqiNumber: 467 },
  { schoolNumber: 2400, schoolName: `Milson School`, eqiNumber: 486 },
  { schoolNumber: 2401, schoolName: `Moawhango School`, eqiNumber: 489 },
  {
    schoolNumber: 2402,
    schoolName: `Monrad - Te Kura Waenga o Tirohanga`,
    eqiNumber: 517,
  },
  { schoolNumber: 2403, schoolName: `Mosston School`, eqiNumber: 444 },
  { schoolNumber: 2404, schoolName: `Mount Biggs School`, eqiNumber: 415 },
  { schoolNumber: 2405, schoolName: `National Park School`, eqiNumber: 424 },
  { schoolNumber: 2406, schoolName: `Newbury School`, eqiNumber: 445 },
  { schoolNumber: 2407, schoolName: `Ngamatapouri School`, eqiNumber: 477 },
  { schoolNumber: 2409, schoolName: `North Street School`, eqiNumber: 506 },
  { schoolNumber: 2410, schoolName: `Ohakune School`, eqiNumber: 472 },
  { schoolNumber: 2412, schoolName: `Okoia School`, eqiNumber: 537 },
  { schoolNumber: 2413, schoolName: `Orautoha School`, eqiNumber: 524 },
  { schoolNumber: 2414, schoolName: `Oroua Downs School`, eqiNumber: 473 },
  {
    schoolNumber: 2416,
    schoolName: `Our Lady of Lourdes School (P North)`,
    eqiNumber: 422,
  },
  { schoolNumber: 2417, schoolName: `Ōwhango School`, eqiNumber: 471 },
  { schoolNumber: 2418, schoolName: `Central Normal School`, eqiNumber: 491 },
  {
    schoolNumber: 2419,
    schoolName: `Palmerston North Intermediate`,
    eqiNumber: 426,
  },
  { schoolNumber: 2420, schoolName: `Papanui Junction School`, eqiNumber: 453 },
  {
    schoolNumber: 2424,
    schoolName: `Parkland School (P North)`,
    eqiNumber: 443,
  },
  { schoolNumber: 2428, schoolName: `Pukeokahu School`, eqiNumber: 500 },
  { schoolNumber: 2429, schoolName: `Raetihi Primary School`, eqiNumber: 516 },
  {
    schoolNumber: 2436,
    schoolName: `Whare Kura Morehu ō Ratana`,
    eqiNumber: 534,
  },
  {
    schoolNumber: 2437,
    schoolName: `Riverdale School (P North)`,
    eqiNumber: 426,
  },
  { schoolNumber: 2438, schoolName: `Rongotea School`, eqiNumber: 470 },
  { schoolNumber: 2439, schoolName: `Roslyn School`, eqiNumber: 518 },
  { schoolNumber: 2440, schoolName: `Ross Intermediate`, eqiNumber: 473 },
  { schoolNumber: 2441, schoolName: `Russell Street School`, eqiNumber: 429 },
  {
    schoolNumber: 2442,
    schoolName: `Te Kura Waenga O Rutherford | Rutherford Intermediate School`,
    eqiNumber: 539,
  },
  { schoolNumber: 2443, schoolName: `Sanson School`, eqiNumber: 470 },
  {
    schoolNumber: 2445,
    schoolName: `TKKM o Ngati Kahungunu Ki Heretaunga`,
    eqiNumber: 552,
  },
  { schoolNumber: 2446, schoolName: `South Makirikiri School`, eqiNumber: 444 },
  {
    schoolNumber: 2447,
    schoolName: `St Anne's School (Wanganui)`,
    eqiNumber: 459,
  },
  {
    schoolNumber: 2449,
    schoolName: `St James’ Catholic School Te Kura Katorika o Hato Heemi`,
    eqiNumber: 410,
  },
  { schoolNumber: 2450, schoolName: `St Johns Hill School`, eqiNumber: 416 },
  {
    schoolNumber: 2451,
    schoolName: `St Joseph's School (Feilding)`,
    eqiNumber: 435,
  },
  {
    schoolNumber: 2452,
    schoolName: `St Joseph's School (Patea)`,
    eqiNumber: 544,
  },
  {
    schoolNumber: 2453,
    schoolName: `St Joseph's School (Taihape)`,
    eqiNumber: 435,
  },
  {
    schoolNumber: 2454,
    schoolName: `St Mary's School (Wanganui)`,
    eqiNumber: 469,
  },
  {
    schoolNumber: 2455,
    schoolName: `St Mary's School (Foxton)`,
    eqiNumber: 509,
  },
  {
    schoolNumber: 2456,
    schoolName: `St Matthew's School (Marton)`,
    eqiNumber: 484,
  },
  {
    schoolNumber: 2457,
    schoolName: `St Mary's School (P North)`,
    eqiNumber: 389,
  },
  { schoolNumber: 2460, schoolName: `Takaro School`, eqiNumber: 534 },
  { schoolNumber: 2461, schoolName: `Tangimoana School`, eqiNumber: 535 },
  { schoolNumber: 2462, schoolName: `Taonui School`, eqiNumber: 462 },
  { schoolNumber: 2463, schoolName: `Taoroa School`, eqiNumber: 518 },
  { schoolNumber: 2465, schoolName: `Tawhero School`, eqiNumber: 547 },
  { schoolNumber: 2466, schoolName: `Terrace End School`, eqiNumber: 505 },
  { schoolNumber: 2467, schoolName: `Turitea School`, eqiNumber: 403 },
  { schoolNumber: 2468, schoolName: `Turakina School`, eqiNumber: 508 },
  { schoolNumber: 2469, schoolName: `Upokongaro School`, eqiNumber: 524 },
  { schoolNumber: 2472, schoolName: `Waiouru School`, eqiNumber: 484 },
  { schoolNumber: 2474, schoolName: `Waitotara School`, eqiNumber: 496 },
  { schoolNumber: 2475, schoolName: `Waituna West School`, eqiNumber: 439 },
  { schoolNumber: 2476, schoolName: `Whanganui East School`, eqiNumber: 547 },
  { schoolNumber: 2477, schoolName: `Whanganui Intermediate`, eqiNumber: 505 },
  { schoolNumber: 2478, schoolName: `Waverley Primary School`, eqiNumber: 487 },
  {
    schoolNumber: 2479,
    schoolName: `West End School (P North)`,
    eqiNumber: 458,
  },
  {
    schoolNumber: 2480,
    schoolName: `Westmere School (Wanganui)`,
    eqiNumber: 427,
  },
  { schoolNumber: 2481, schoolName: `Whakarongo School`, eqiNumber: 424 },
  { schoolNumber: 2482, schoolName: `Whangaehu School`, eqiNumber: 530 },
  { schoolNumber: 2483, schoolName: `Whenuakura School`, eqiNumber: 455 },
  {
    schoolNumber: 2484,
    schoolName: `Winchester School (P North)`,
    eqiNumber: 420,
  },
  { schoolNumber: 2542, schoolName: `Argyll East School`, eqiNumber: 450 },
  { schoolNumber: 2543, schoolName: `Arthur Miller School`, eqiNumber: 425 },
  {
    schoolNumber: 2544,
    schoolName: `Awapuni School (Gisborne)`,
    eqiNumber: 499,
  },
  { schoolNumber: 2546, schoolName: `Bledisloe School`, eqiNumber: 474 },
  { schoolNumber: 2547, schoolName: `Bridge Pa School`, eqiNumber: 523 },
  { schoolNumber: 2548, schoolName: `Camberley School`, eqiNumber: 556 },
  { schoolNumber: 2549, schoolName: `Clive School`, eqiNumber: 450 },
  { schoolNumber: 2550, schoolName: `Cobham School` },
  { schoolNumber: 2553, schoolName: `Dannevirke South School`, eqiNumber: 504 },
  { schoolNumber: 2554, schoolName: `Ebbett Park School`, eqiNumber: 533 },
  { schoolNumber: 2555, schoolName: `Elgin School`, eqiNumber: 562 },
  { schoolNumber: 2556, schoolName: `Elsthorpe School`, eqiNumber: 446 },
  { schoolNumber: 2557, schoolName: `Eskdale School`, eqiNumber: 423 },
  {
    schoolNumber: 2558,
    schoolName: `Fairhaven School (Napier)`,
    eqiNumber: 514,
  },
  { schoolNumber: 2560, schoolName: `Flaxmere Primary School`, eqiNumber: 539 },
  {
    schoolNumber: 2561,
    schoolName: `Flemington School (Waipukurau)`,
    eqiNumber: 432,
  },
  { schoolNumber: 2562, schoolName: `Frasertown School`, eqiNumber: 479 },
  { schoolNumber: 2563, schoolName: `Frimley School`, eqiNumber: 473 },
  { schoolNumber: 2564, schoolName: `Gisborne Central School`, eqiNumber: 430 },
  { schoolNumber: 2566, schoolName: `Gisborne Intermediate`, eqiNumber: 486 },
  { schoolNumber: 2567, schoolName: `Greenmeadows School`, eqiNumber: 436 },
  { schoolNumber: 2569, schoolName: `Hastings Central School`, eqiNumber: 522 },
  { schoolNumber: 2570, schoolName: `Hastings Intermediate`, eqiNumber: 509 },
  { schoolNumber: 2571, schoolName: `Haumoana School`, eqiNumber: 421 },
  {
    schoolNumber: 2572,
    schoolName: `Havelock North Intermediate`,
    eqiNumber: 432,
  },
  {
    schoolNumber: 2573,
    schoolName: `Havelock North Primary School`,
    eqiNumber: 399,
  },
  { schoolNumber: 2574, schoolName: `Henry Hill School`, eqiNumber: 539 },
  { schoolNumber: 2575, schoolName: `Heretaunga Intermediate`, eqiNumber: 492 },
  { schoolNumber: 2578, schoolName: `Hiruharama School`, eqiNumber: 543 },
  { schoolNumber: 2581, schoolName: `Ilminster Intermediate`, eqiNumber: 508 },
  { schoolNumber: 2582, schoolName: `Irongate School`, eqiNumber: 533 },
  { schoolNumber: 2584, schoolName: `Kaiti School`, eqiNumber: 535 },
  { schoolNumber: 2585, schoolName: `Kereru School`, eqiNumber: 444 },
  { schoolNumber: 2587, schoolName: `Kotemaori School`, eqiNumber: 535 },
  { schoolNumber: 2588, schoolName: `Kōwhai School`, eqiNumber: 517 },
  { schoolNumber: 2590, schoolName: `Lucknow School`, eqiNumber: 451 },
  { schoolNumber: 2592, schoolName: `Mahora School`, eqiNumber: 470 },
  { schoolNumber: 2593, schoolName: `Makaraka School`, eqiNumber: 444 },
  { schoolNumber: 2594, schoolName: `Makarika School`, eqiNumber: 542 },
  { schoolNumber: 2595, schoolName: `Makauri School`, eqiNumber: 438 },
  { schoolNumber: 2597, schoolName: `Mangapapa School`, eqiNumber: 478 },
  { schoolNumber: 2599, schoolName: `Mangateretere School`, eqiNumber: 555 },
  { schoolNumber: 2600, schoolName: `TKKM o Mangatuna`, eqiNumber: 517 },
  { schoolNumber: 2602, schoolName: `Manutuke School`, eqiNumber: 522 },
  {
    schoolNumber: 2604,
    schoolName: `Maraenui Bilingual School (Napier)`,
    eqiNumber: 562,
  },
  { schoolNumber: 2606, schoolName: `Marewa School`, eqiNumber: 542 },
  { schoolNumber: 2609, schoolName: `Te Kura o Mata`, eqiNumber: 489 },
  { schoolNumber: 2611, schoolName: `Matawai School`, eqiNumber: 476 },
  { schoolNumber: 2612, schoolName: `Mayfair School`, eqiNumber: 527 },
  { schoolNumber: 2613, schoolName: `Meeanee School`, eqiNumber: 493 },
  { schoolNumber: 2616, schoolName: `Motu School`, eqiNumber: 488 },
  { schoolNumber: 2617, schoolName: `Muriwai School`, eqiNumber: 521 },
  { schoolNumber: 2618, schoolName: `Napier Central School`, eqiNumber: 403 },
  { schoolNumber: 2619, schoolName: `Napier Intermediate`, eqiNumber: 497 },
  { schoolNumber: 2620, schoolName: `Nelson Park School`, eqiNumber: 458 },
  { schoolNumber: 2621, schoolName: `Ngatapa School`, eqiNumber: 456 },
  {
    schoolNumber: 2622,
    schoolName: `Norsewood and Districts School`,
    eqiNumber: 514,
  },
  { schoolNumber: 2624, schoolName: `Nuhaka School`, eqiNumber: 508 },
  { schoolNumber: 2625, schoolName: `Ohuka School`, eqiNumber: 523 },
  { schoolNumber: 2626, schoolName: `Omahu School`, eqiNumber: 569 },
  { schoolNumber: 2627, schoolName: `Omakere School`, eqiNumber: 437 },
  { schoolNumber: 2628, schoolName: `Onekawa School`, eqiNumber: 487 },
  { schoolNumber: 2629, schoolName: `Ongaonga School`, eqiNumber: 453 },
  { schoolNumber: 2631, schoolName: `Ormond School`, eqiNumber: 460 },
  { schoolNumber: 2634, schoolName: `Otane School`, eqiNumber: 487 },
  { schoolNumber: 2637, schoolName: `Te Kura o Pakipaki`, eqiNumber: 545 },
  { schoolNumber: 2638, schoolName: `Pakowhai School`, eqiNumber: 452 },
  { schoolNumber: 2640, schoolName: `Papatawa School` },
  { schoolNumber: 2641, schoolName: `Parkvale School`, eqiNumber: 462 },
  { schoolNumber: 2642, schoolName: `Patoka School`, eqiNumber: 469 },
  { schoolNumber: 2643, schoolName: `Patutahi School`, eqiNumber: 526 },
  { schoolNumber: 2644, schoolName: `Te Whai Hiringa`, eqiNumber: 533 },
  { schoolNumber: 2647, schoolName: `Porritt School`, eqiNumber: 493 },
  { schoolNumber: 2648, schoolName: `Port Ahuriri School`, eqiNumber: 425 },
  { schoolNumber: 2649, schoolName: `Potaka School`, eqiNumber: 523 },
  { schoolNumber: 2650, schoolName: `Poukawa School`, eqiNumber: 476 },
  { schoolNumber: 2651, schoolName: `Pukehamoamoa School`, eqiNumber: 437 },
  { schoolNumber: 2652, schoolName: `Pukehou School`, eqiNumber: 452 },
  {
    schoolNumber: 2654,
    schoolName: `Puketapu School (Hawkes Bay)`,
    eqiNumber: 421,
  },
  { schoolNumber: 2657, schoolName: `Putere School`, eqiNumber: 484 },
  { schoolNumber: 2658, schoolName: `Putorino School`, eqiNumber: 492 },
  {
    schoolNumber: 2659,
    schoolName: `TKKM o Tapere-Nui-A-Whatonga`,
    eqiNumber: 532,
  },
  { schoolNumber: 2662, schoolName: `Raureka School`, eqiNumber: 499 },
  {
    schoolNumber: 2663,
    schoolName: `Reignier Catholic School`,
    eqiNumber: 404,
  },
  { schoolNumber: 2664, schoolName: `Rere School`, eqiNumber: 442 },
  {
    schoolNumber: 2665,
    schoolName: `Richmond School (Napier)`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2667,
    schoolName: `Riverdale School (Gisborne)`,
    eqiNumber: 552,
  },
  { schoolNumber: 2669, schoolName: `Ruahine School`, eqiNumber: 451 },
  {
    schoolNumber: 2672,
    schoolName: `Sherenden and Districts School`,
    eqiNumber: 441,
  },
  {
    schoolNumber: 2673,
    schoolName: `Sherwood School (Hawkes Bay)`,
    eqiNumber: 460,
  },
  {
    schoolNumber: 2676,
    schoolName: `St Joseph's School (Dannevirke)`,
    eqiNumber: 473,
  },
  {
    schoolNumber: 2677,
    schoolName: `St Joseph's School (Hastings)`,
    eqiNumber: 418,
  },
  {
    schoolNumber: 2678,
    schoolName: `St Joseph’s School (Central Hawke's Bay)`,
    eqiNumber: 436,
  },
  {
    schoolNumber: 2679,
    schoolName: `St Joseph's School (Wairoa)`,
    eqiNumber: 502,
  },
  {
    schoolNumber: 2680,
    schoolName: `St Mary's Catholic School (Gisborne)`,
    eqiNumber: 423,
  },
  {
    schoolNumber: 2681,
    schoolName: `St Mary's Catholic School (Hastings)`,
    eqiNumber: 421,
  },
  { schoolNumber: 2684, schoolName: `Takapau School`, eqiNumber: 496 },
  { schoolNumber: 2685, schoolName: `Tamatea Intermediate`, eqiNumber: 498 },
  { schoolNumber: 2686, schoolName: `Tamatea School`, eqiNumber: 535 },
  { schoolNumber: 2687, schoolName: `Taradale Intermediate`, eqiNumber: 440 },
  { schoolNumber: 2688, schoolName: `Taradale School`, eqiNumber: 407 },
  { schoolNumber: 2691, schoolName: `Te Awa School`, eqiNumber: 536 },
  { schoolNumber: 2692, schoolName: `Te Hapara School`, eqiNumber: 524 },
  {
    schoolNumber: 2697,
    schoolName: `Te Mata School (Havelock North)`,
    eqiNumber: 394,
  },
  { schoolNumber: 2698, schoolName: `Te Pohue School`, eqiNumber: 473 },
  {
    schoolNumber: 2701,
    schoolName: `Te Wharau School (Gisborne)`,
    eqiNumber: 514,
  },
  {
    schoolNumber: 2702,
    schoolName: `The Terrace School (Waipukurau)`,
    eqiNumber: 536,
  },
  { schoolNumber: 2703, schoolName: `Tikitiki School`, eqiNumber: 538 },
  { schoolNumber: 2704, schoolName: `Tikokino School`, eqiNumber: 438 },
  { schoolNumber: 2705, schoolName: `Tiniroto School`, eqiNumber: 470 },
  { schoolNumber: 2706, schoolName: `Hatea-A-Rangi`, eqiNumber: 544 },
  { schoolNumber: 2710, schoolName: `Tutira School`, eqiNumber: 505 },
  { schoolNumber: 2711, schoolName: `Twyford School`, eqiNumber: 445 },
  { schoolNumber: 2712, schoolName: `Waerenga-O-Kuri School`, eqiNumber: 443 },
  { schoolNumber: 2715, schoolName: `Waikirikiri School`, eqiNumber: 559 },
  { schoolNumber: 2718, schoolName: `Waimarama School`, eqiNumber: 504 },
  { schoolNumber: 2721, schoolName: `Wainui Beach School`, eqiNumber: 401 },
  { schoolNumber: 2723, schoolName: `Waipawa School`, eqiNumber: 482 },
  { schoolNumber: 2725, schoolName: `Waipukurau School`, eqiNumber: 467 },
  { schoolNumber: 2732, schoolName: `Weber School`, eqiNumber: 447 },
  { schoolNumber: 2733, schoolName: `Westshore School`, eqiNumber: 500 },
  { schoolNumber: 2736, schoolName: `Whangara School`, eqiNumber: 479 },
  {
    schoolNumber: 2739,
    schoolName: `Te Kura Kaupapa Maori o Whatatutu`,
    eqiNumber: 538,
  },
  { schoolNumber: 2742, schoolName: `Woodville School`, eqiNumber: 507 },
  {
    schoolNumber: 2745,
    schoolName: `St Patrick's School (Napier)`,
    eqiNumber: 435,
  },
  { schoolNumber: 2746, schoolName: `Te Kura o Kimi Ora`, eqiNumber: 532 },
  {
    schoolNumber: 2747,
    schoolName: `Hawke's Bay School for Teenage Parents`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2748,
    schoolName: `Karanga Mai Young Parents College`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2749,
    schoolName: `Te Whare Whai Hua Teenage Parent Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2750,
    schoolName: `Puawānanga Wairarapa Young Parents`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2751,
    schoolName: `Te Whakatipuranga (Otumoetai TPU)`,
    eqiNumber: 569,
  },
  { schoolNumber: 2752, schoolName: `He Huarahi Tamariki`, eqiNumber: 569 },
  { schoolNumber: 2753, schoolName: `Te Āhuru Mōwai`, eqiNumber: 569 },
  {
    schoolNumber: 2754,
    schoolName: `Stratford High School Teen Parent Unit`,
    eqiNumber: 569,
  },
  { schoolNumber: 2755, schoolName: `Titiro Whakamua`, eqiNumber: 569 },
  {
    schoolNumber: 2756,
    schoolName: `Whakatipuria Teen Parent Unit`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2757,
    schoolName: `He Mataariki School for Teen Parents`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2758,
    schoolName: `Kawerau Teen Parent Unit`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2759,
    schoolName: `He Puaawai Teen Parent Unit`,
    eqiNumber: 569,
  },
  { schoolNumber: 2760, schoolName: `Eden Campus`, eqiNumber: 569 },
  {
    schoolNumber: 2761,
    schoolName: `Kimihia Parents' College`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 2762,
    schoolName: `Clendon Teen Parent Unit`,
    eqiNumber: 569,
  },
  { schoolNumber: 2801, schoolName: `Alfredton School`, eqiNumber: 434 },
  { schoolNumber: 2802, schoolName: `Arakura School`, eqiNumber: 500 },
  { schoolNumber: 2803, schoolName: `Avalon School`, eqiNumber: 487 },
  { schoolNumber: 2805, schoolName: `Ballance School`, eqiNumber: 504 },
  {
    schoolNumber: 2806,
    schoolName: `Bellevue School (Newlands)`,
    eqiNumber: 392,
  },
  {
    schoolNumber: 2807,
    schoolName: `Belmont School (Lower Hutt)`,
    eqiNumber: 398,
  },
  { schoolNumber: 2808, schoolName: `Berhampore School`, eqiNumber: 392 },
  { schoolNumber: 2810, schoolName: `Birchville School`, eqiNumber: 461 },
  { schoolNumber: 2811, schoolName: `Blenheim School`, eqiNumber: 501 },
  { schoolNumber: 2812, schoolName: `Bohally Intermediate`, eqiNumber: 459 },
  { schoolNumber: 2813, schoolName: `Boulcott School`, eqiNumber: 394 },
  { schoolNumber: 2814, schoolName: `Brandon Intermediate`, eqiNumber: 523 },
  {
    schoolNumber: 2816,
    schoolName: `Brooklyn School (Wellington)`,
    eqiNumber: 362,
  },
  { schoolNumber: 2818, schoolName: `Cannons Creek School`, eqiNumber: 521 },
  { schoolNumber: 2819, schoolName: `Cardinal McKeefry School (Wilton)` },
  { schoolNumber: 2820, schoolName: `Carterton School`, eqiNumber: 471 },
  { schoolNumber: 2821, schoolName: `Cashmere Avenue School`, eqiNumber: 344 },
  {
    schoolNumber: 2823,
    schoolName: `Crofton Downs Primary School`,
    eqiNumber: 357,
  },
  { schoolNumber: 2824, schoolName: `Churton Park School`, eqiNumber: 361 },
  {
    schoolNumber: 2826,
    schoolName: `Clifton Terrace Model School`,
    eqiNumber: 372,
  },
  { schoolNumber: 2827, schoolName: `Clyde Quay School`, eqiNumber: 369 },
  { schoolNumber: 2828, schoolName: `Corinna School`, eqiNumber: 522 },
  { schoolNumber: 2831, schoolName: `Dalefield School`, eqiNumber: 463 },
  { schoolNumber: 2832, schoolName: `Discovery School`, eqiNumber: 393 },
  { schoolNumber: 2833, schoolName: `Dyer Street School`, eqiNumber: 460 },
  { schoolNumber: 2834, schoolName: `Eastern Hutt School`, eqiNumber: 373 },
  { schoolNumber: 2835, schoolName: `Eketāhuna School`, eqiNumber: 487 },
  { schoolNumber: 2836, schoolName: `Epuni School`, eqiNumber: 470 },
  { schoolNumber: 2837, schoolName: `Evans Bay Intermediate`, eqiNumber: 403 },
  {
    schoolNumber: 2838,
    schoolName: `Fairfield School (Levin)`,
    eqiNumber: 474,
  },
  { schoolNumber: 2839, schoolName: `Fairhall School`, eqiNumber: 391 },
  {
    schoolNumber: 2840,
    schoolName: `Featherston School Te Kura o Paetūmokai`,
    eqiNumber: 497,
  },
  {
    schoolNumber: 2841,
    schoolName: `Fergusson Intermediate (Trentham)`,
    eqiNumber: 442,
  },
  { schoolNumber: 2842, schoolName: `Fernlea School`, eqiNumber: 481 },
  { schoolNumber: 2843, schoolName: `Fernridge School`, eqiNumber: 448 },
  { schoolNumber: 2844, schoolName: `Fraser Crescent School`, eqiNumber: 463 },
  {
    schoolNumber: 2845,
    schoolName: `Gladstone School (Masterton)`,
    eqiNumber: 417,
  },
  {
    schoolNumber: 2846,
    schoolName: `Pukeatua Primary School (Wainuiomata)`,
    eqiNumber: 525,
  },
  {
    schoolNumber: 2847,
    schoolName: `Glenview School (Porirua East)`,
    eqiNumber: 511,
  },
  { schoolNumber: 2848, schoolName: `Gracefield School`, eqiNumber: 437 },
  { schoolNumber: 2849, schoolName: `Greenacres School`, eqiNumber: 384 },
  { schoolNumber: 2850, schoolName: `Greytown School`, eqiNumber: 414 },
  { schoolNumber: 2851, schoolName: `Grovetown School`, eqiNumber: 440 },
  { schoolNumber: 2852, schoolName: `Hampton Hill School`, eqiNumber: 428 },
  { schoolNumber: 2854, schoolName: `Hataitai School`, eqiNumber: 365 },
  { schoolNumber: 2855, schoolName: `Havelock School`, eqiNumber: 462 },
  {
    schoolNumber: 2859,
    schoolName: `Holy Family School (Porirua)`,
    eqiNumber: 487,
  },
  { schoolNumber: 2861, schoolName: `Houghton Valley School`, eqiNumber: 366 },
  { schoolNumber: 2862, schoolName: `Hutt Central School`, eqiNumber: 396 },
  { schoolNumber: 2863, schoolName: `Hutt Intermediate`, eqiNumber: 412 },
  { schoolNumber: 2865, schoolName: `Island Bay School`, eqiNumber: 371 },
  { schoolNumber: 2866, schoolName: `Johnsonville School`, eqiNumber: 391 },
  { schoolNumber: 2867, schoolName: `West Park School`, eqiNumber: 392 },
  { schoolNumber: 2868, schoolName: `Kahutara School`, eqiNumber: 456 },
  { schoolNumber: 2871, schoolName: `Kapakapanui School`, eqiNumber: 434 },
  {
    schoolNumber: 2872,
    schoolName: `Mahinawa Specialist School and Resource Centre`,
    eqiNumber: 510,
  },
  { schoolNumber: 2873, schoolName: `Kapiti School`, eqiNumber: 477 },
  { schoolNumber: 2874, schoolName: `Karori Normal School`, eqiNumber: 354 },
  {
    schoolNumber: 2875,
    schoolName: `Karori West Normal School`,
    eqiNumber: 381,
  },
  { schoolNumber: 2876, schoolName: `Kelburn Normal School`, eqiNumber: 353 },
  { schoolNumber: 2877, schoolName: `Kelson School`, eqiNumber: 386 },
  { schoolNumber: 2878, schoolName: `Kenakena School`, eqiNumber: 438 },
  { schoolNumber: 2879, schoolName: `Khandallah School`, eqiNumber: 372 },
  { schoolNumber: 2880, schoolName: `Kilbirnie School`, eqiNumber: 377 },
  { schoolNumber: 2882, schoolName: `Koputaroa School`, eqiNumber: 452 },
  { schoolNumber: 2883, schoolName: `Korokoro School`, eqiNumber: 375 },
  { schoolNumber: 2886, schoolName: `Levin East School`, eqiNumber: 526 },
  { schoolNumber: 2887, schoolName: `Levin Intermediate`, eqiNumber: 517 },
  { schoolNumber: 2888, schoolName: `Levin North School`, eqiNumber: 506 },
  { schoolNumber: 2889, schoolName: `Levin School`, eqiNumber: 508 },
  { schoolNumber: 2890, schoolName: `Linden School`, eqiNumber: 500 },
  { schoolNumber: 2891, schoolName: `Linkwater School`, eqiNumber: 412 },
  { schoolNumber: 2892, schoolName: `Lyall Bay School`, eqiNumber: 402 },
  { schoolNumber: 2893, schoolName: `Maidstone Intermediate`, eqiNumber: 470 },
  { schoolNumber: 2894, schoolName: `Makara Model School`, eqiNumber: 395 },
  { schoolNumber: 2895, schoolName: `Makuri School`, eqiNumber: 440 },
  { schoolNumber: 2896, schoolName: `Manakau School`, eqiNumber: 452 },
  { schoolNumber: 2899, schoolName: `Mangaroa School`, eqiNumber: 416 },
  { schoolNumber: 2900, schoolName: `Mangatainoka School`, eqiNumber: 509 },
  { schoolNumber: 2902, schoolName: `Te Kura o Hau Karetu`, eqiNumber: 527 },
  { schoolNumber: 2903, schoolName: `Maraeroa School`, eqiNumber: 515 },
  {
    schoolNumber: 2904,
    schoolName: `Holy Cross School (Miramar)`,
    eqiNumber: 418,
  },
  { schoolNumber: 2906, schoolName: `Martinborough School`, eqiNumber: 433 },
  { schoolNumber: 2909, schoolName: `Masterton Intermediate`, eqiNumber: 483 },
  { schoolNumber: 2911, schoolName: `Mauriceville School`, eqiNumber: 505 },
  {
    schoolNumber: 2912,
    schoolName: `Mayfield School (Blenheim)`,
    eqiNumber: 517,
  },
  { schoolNumber: 2915, schoolName: `Miramar Central School`, eqiNumber: 415 },
  { schoolNumber: 2916, schoolName: `Miramar North School`, eqiNumber: 380 },
  {
    schoolNumber: 2918,
    schoolName: `Mt Cook School (Wellington)`,
    eqiNumber: 414,
  },
  { schoolNumber: 2920, schoolName: `Muritai School`, eqiNumber: 375 },
  { schoolNumber: 2921, schoolName: `Naenae Intermediate`, eqiNumber: 483 },
  { schoolNumber: 2922, schoolName: `Naenae School`, eqiNumber: 529 },
  { schoolNumber: 2923, schoolName: `Natone Park School`, eqiNumber: 525 },
  { schoolNumber: 2924, schoolName: `Newlands Intermediate`, eqiNumber: 398 },
  { schoolNumber: 2925, schoolName: `Newlands School`, eqiNumber: 386 },
  { schoolNumber: 2926, schoolName: `Newtown School`, eqiNumber: 417 },
  { schoolNumber: 2927, schoolName: `Ngaio School`, eqiNumber: 353 },
  { schoolNumber: 2928, schoolName: `Ngati Toa School`, eqiNumber: 495 },
  { schoolNumber: 2930, schoolName: `Normandale School`, eqiNumber: 370 },
  { schoolNumber: 2931, schoolName: `Northland School`, eqiNumber: 360 },
  { schoolNumber: 2933, schoolName: `Ohau School`, eqiNumber: 467 },
  { schoolNumber: 2936, schoolName: `Ōpaki School`, eqiNumber: 422 },
  { schoolNumber: 2937, schoolName: `Opiki School`, eqiNumber: 435 },
  { schoolNumber: 2939, schoolName: `Otaki School`, eqiNumber: 528 },
  {
    schoolNumber: 2941,
    schoolName: `Our Lady of the Rosary School (Waiwhetu)`,
    eqiNumber: 428,
  },
  { schoolNumber: 2942, schoolName: `Owhiro Bay School`, eqiNumber: 398 },
  { schoolNumber: 2943, schoolName: `Oxford Crescent School`, eqiNumber: 447 },
  { schoolNumber: 2944, schoolName: `Paekākāriki School`, eqiNumber: 411 },
  { schoolNumber: 2945, schoolName: `Pahiatua School`, eqiNumber: 478 },
  { schoolNumber: 2946, schoolName: `Papakowhai School`, eqiNumber: 387 },
  { schoolNumber: 2947, schoolName: `Paparangi School`, eqiNumber: 381 },
  {
    schoolNumber: 2948,
    schoolName: `Paraparaumu Beach School`,
    eqiNumber: 443,
  },
  { schoolNumber: 2949, schoolName: `Paraparaumu School`, eqiNumber: 463 },
  { schoolNumber: 2950, schoolName: `Paremata School`, eqiNumber: 408 },
  { schoolNumber: 2953, schoolName: `Pauatahanui School`, eqiNumber: 395 },
  { schoolNumber: 2955, schoolName: `Petone Central School`, eqiNumber: 447 },
  { schoolNumber: 2956, schoolName: `Picton School`, eqiNumber: 493 },
  { schoolNumber: 2957, schoolName: `Pinehaven School`, eqiNumber: 398 },
  { schoolNumber: 2958, schoolName: `Pirinoa School`, eqiNumber: 493 },
  { schoolNumber: 2959, schoolName: `Plateau School`, eqiNumber: 421 },
  { schoolNumber: 2960, schoolName: `Plimmerton School`, eqiNumber: 396 },
  { schoolNumber: 2961, schoolName: `Pomare School`, eqiNumber: 515 },
  { schoolNumber: 2962, schoolName: `Pongaroa School`, eqiNumber: 485 },
  { schoolNumber: 2963, schoolName: `Porirua East School`, eqiNumber: 500 },
  { schoolNumber: 2964, schoolName: `Porirua School`, eqiNumber: 509 },
  { schoolNumber: 2965, schoolName: `Poroutawhao School`, eqiNumber: 476 },
  { schoolNumber: 2966, schoolName: `Postgate School`, eqiNumber: 461 },
  { schoolNumber: 2967, schoolName: `Pukerua Bay School`, eqiNumber: 412 },
  { schoolNumber: 2968, schoolName: `Maungaraki School`, eqiNumber: 379 },
  { schoolNumber: 2969, schoolName: `Randwick School`, eqiNumber: 504 },
  { schoolNumber: 2970, schoolName: `Rangikura School`, eqiNumber: 503 },
  { schoolNumber: 2971, schoolName: `Rapaura School`, eqiNumber: 418 },
  {
    schoolNumber: 2972,
    schoolName: `Raroa Normal Intermediate`,
    eqiNumber: 379,
  },
  { schoolNumber: 2973, schoolName: `Rata Street School`, eqiNumber: 507 },
  { schoolNumber: 2974, schoolName: `Raumati Beach School`, eqiNumber: 423 },
  { schoolNumber: 2975, schoolName: `Raumati South School`, eqiNumber: 411 },
  { schoolNumber: 2976, schoolName: `Redwood School (Tawa)`, eqiNumber: 377 },
  { schoolNumber: 2977, schoolName: `Redwoodtown School`, eqiNumber: 493 },
  { schoolNumber: 2978, schoolName: `Renwick School`, eqiNumber: 449 },
  { schoolNumber: 2979, schoolName: `Rewa Rewa School`, eqiNumber: 392 },
  {
    schoolNumber: 2980,
    schoolName: `Te Kura o Tawatawa - Ridgway School`,
    eqiNumber: 380,
  },
  { schoolNumber: 2981, schoolName: `Riverlands School`, eqiNumber: 467 },
  { schoolNumber: 2982, schoolName: `Roseneath School`, eqiNumber: 378 },
  {
    schoolNumber: 2983,
    schoolName: `Russell School (Porirua East)`,
    eqiNumber: 509,
  },
  {
    schoolNumber: 2984,
    schoolName: `Sacred Heart School (Petone)`,
    eqiNumber: 415,
  },
  {
    schoolNumber: 2985,
    schoolName: `Sacred Heart Cathedral School`,
    eqiNumber: 375,
  },
  { schoolNumber: 2986, schoolName: `San Antonio School (Eastbourne)` },
  { schoolNumber: 2987, schoolName: `Seatoun School`, eqiNumber: 356 },
  { schoolNumber: 2988, schoolName: `Seddon School`, eqiNumber: 440 },
  { schoolNumber: 2989, schoolName: `Shannon School`, eqiNumber: 517 },
  { schoolNumber: 2990, schoolName: `Silverstream School`, eqiNumber: 393 },
  { schoolNumber: 2991, schoolName: `Solway School`, eqiNumber: 463 },
  { schoolNumber: 2992, schoolName: `South End School`, eqiNumber: 450 },
  {
    schoolNumber: 2993,
    schoolName: `South Featherston School`,
    eqiNumber: 457,
  },
  {
    schoolNumber: 2994,
    schoolName: `South Wellington Intermediate`,
    eqiNumber: 400,
  },
  { schoolNumber: 2995, schoolName: `Spring Creek School`, eqiNumber: 498 },
  { schoolNumber: 2996, schoolName: `Springlands School`, eqiNumber: 435 },
  {
    schoolNumber: 2997,
    schoolName: `St Annes School (Newtown)`,
    eqiNumber: 435,
  },
  {
    schoolNumber: 2998,
    schoolName: `St Anthony's School (Pahiatua)`,
    eqiNumber: 441,
  },
  {
    schoolNumber: 2999,
    schoolName: `St Anthony's School (Seatoun)`,
    eqiNumber: 391,
  },
  {
    schoolNumber: 3000,
    schoolName: `St Benedict's School (Khandallah)`,
    eqiNumber: 350,
  },
  {
    schoolNumber: 3001,
    schoolName: `St Bernadette's School (Naenae)`,
    eqiNumber: 488,
  },
  { schoolNumber: 3002, schoolName: `St Bernard's School (Brooklyn)` },
  {
    schoolNumber: 3004,
    schoolName: `St Brendan's School (Heretaunga)`,
    eqiNumber: 391,
  },
  {
    schoolNumber: 3005,
    schoolName: `St Brigids School (Johnsonville)`,
    eqiNumber: 372,
  },
  {
    schoolNumber: 3006,
    schoolName: `St Francis De Sales School (Is Bay)`,
    eqiNumber: 395,
  },
  {
    schoolNumber: 3007,
    schoolName: `St Francis Xavier School (Tawa)`,
    eqiNumber: 402,
  },
  {
    schoolNumber: 3008,
    schoolName: `St Joseph's School (Levin)`,
    eqiNumber: 462,
  },
  {
    schoolNumber: 3011,
    schoolName: `St Joseph's School (Upper Hutt)`,
    eqiNumber: 411,
  },
  {
    schoolNumber: 3012,
    schoolName: `St Mary's School (Blenheim)`,
    eqiNumber: 440,
  },
  {
    schoolNumber: 3013,
    schoolName: `St Mary's School (Carterton)`,
    eqiNumber: 433,
  },
  {
    schoolNumber: 3015,
    schoolName: `St Michael's School (Taita)`,
    eqiNumber: 476,
  },
  {
    schoolNumber: 3016,
    schoolName: `St Patrick's School (Masterton)`,
    eqiNumber: 439,
  },
  {
    schoolNumber: 3017,
    schoolName: `Our Lady of Kapiti School`,
    eqiNumber: 402,
  },
  {
    schoolNumber: 3018,
    schoolName: `St Claudine Thevenet School`,
    eqiNumber: 447,
  },
  {
    schoolNumber: 3019,
    schoolName: `St Patrick's School (Kilbirnie)`,
    eqiNumber: 433,
  },
  {
    schoolNumber: 3020,
    schoolName: `St Peter Chanel School (Otaki)`,
    eqiNumber: 562,
  },
  {
    schoolNumber: 3021,
    schoolName: `Sts Peter and Paul School (L Hutt)`,
    eqiNumber: 380,
  },
  {
    schoolNumber: 3022,
    schoolName: `St Pius X School (Titahi Bay)`,
    eqiNumber: 477,
  },
  {
    schoolNumber: 3023,
    schoolName: `St Teresa's School (Featherston)`,
    eqiNumber: 453,
  },
  {
    schoolNumber: 3024,
    schoolName: `St Teresa's School (Karori)`,
    eqiNumber: 390,
  },
  {
    schoolNumber: 3025,
    schoolName: `St Theresa's School (Plimmerton)`,
    eqiNumber: 368,
  },
  { schoolNumber: 3029, schoolName: `Tairangi School`, eqiNumber: 512 },
  { schoolNumber: 3030, schoolName: `Taita Central School`, eqiNumber: 504 },
  { schoolNumber: 3031, schoolName: `Avalon Intermediate`, eqiNumber: 509 },
  { schoolNumber: 3032, schoolName: `Taitoko School`, eqiNumber: 541 },
  { schoolNumber: 3034, schoolName: `Tawa Intermediate`, eqiNumber: 426 },
  { schoolNumber: 3035, schoolName: `Tawa School`, eqiNumber: 426 },
  { schoolNumber: 3036, schoolName: `Tawhai School`, eqiNumber: 438 },
  { schoolNumber: 3037, schoolName: `Te Aro School`, eqiNumber: 398 },
  { schoolNumber: 3038, schoolName: `Te Horo School (Otaki)`, eqiNumber: 425 },
  { schoolNumber: 3040, schoolName: `Thorndon School`, eqiNumber: 362 },
  { schoolNumber: 3041, schoolName: `Tinui School`, eqiNumber: 466 },
  { schoolNumber: 3043, schoolName: `Titahi Bay Intermediate`, eqiNumber: 504 },
  { schoolNumber: 3044, schoolName: `Titahi Bay North School`, eqiNumber: 516 },
  { schoolNumber: 3045, schoolName: `Titahi Bay School`, eqiNumber: 459 },
  { schoolNumber: 3046, schoolName: `Tokomaru School`, eqiNumber: 490 },
  { schoolNumber: 3048, schoolName: `Totara Park School`, eqiNumber: 441 },
  { schoolNumber: 3050, schoolName: `Tua Marina School`, eqiNumber: 432 },
  { schoolNumber: 3051, schoolName: `Tui Glen School`, eqiNumber: 524 },
  { schoolNumber: 3053, schoolName: `Upper Hutt School`, eqiNumber: 436 },
  { schoolNumber: 3055, schoolName: `Wadestown School`, eqiNumber: 349 },
  { schoolNumber: 3056, schoolName: `Waikanae School`, eqiNumber: 437 },
  { schoolNumber: 3057, schoolName: `Waikawa Bay School`, eqiNumber: 460 },
  {
    schoolNumber: 3059,
    schoolName: `Wainuiomata Primary School`,
    eqiNumber: 484,
  },
  { schoolNumber: 3060, schoolName: `Wainuioru School`, eqiNumber: 413 },
  {
    schoolNumber: 3062,
    schoolName: `Wairau Valley School (Blenheim)`,
    eqiNumber: 461,
  },
  { schoolNumber: 3064, schoolName: `Waitaria Bay School`, eqiNumber: 449 },
  { schoolNumber: 3065, schoolName: `Waitohu School`, eqiNumber: 486 },
  { schoolNumber: 3067, schoolName: `Ward School`, eqiNumber: 437 },
  { schoolNumber: 3068, schoolName: `Waterloo School`, eqiNumber: 391 },
  { schoolNumber: 3070, schoolName: `Whareama School`, eqiNumber: 451 },
  { schoolNumber: 3071, schoolName: `Whitney Street School`, eqiNumber: 474 },
  { schoolNumber: 3072, schoolName: `Wilford School`, eqiNumber: 428 },
  { schoolNumber: 3073, schoolName: `Ōtari School`, eqiNumber: 393 },
  { schoolNumber: 3074, schoolName: `Windley School`, eqiNumber: 529 },
  { schoolNumber: 3075, schoolName: `Witherlea School`, eqiNumber: 415 },
  { schoolNumber: 3077, schoolName: `Worser Bay School`, eqiNumber: 351 },
  { schoolNumber: 3100, schoolName: `TKKM o Te Hiringa`, eqiNumber: 525 },
  {
    schoolNumber: 3101,
    schoolName: `Te Kura ā Iwi o Whakatupuranga Rua Mano`,
    eqiNumber: 504,
  },
  { schoolNumber: 3102, schoolName: `TKKM o Waiuku`, eqiNumber: 472 },
  { schoolNumber: 3103, schoolName: `TKKM o Hurungaterangi`, eqiNumber: 550 },
  { schoolNumber: 3104, schoolName: `TKKM o Te Kotuku`, eqiNumber: 509 },
  { schoolNumber: 3106, schoolName: `TKKM o Whangaroa`, eqiNumber: 540 },
  { schoolNumber: 3107, schoolName: `TKKM o Te Ara Hou`, eqiNumber: 525 },
  { schoolNumber: 3113, schoolName: `Te Wharekura o Manurewa`, eqiNumber: 547 },
  { schoolNumber: 3114, schoolName: `TKKM o Pukemiro`, eqiNumber: 537 },
  {
    schoolNumber: 3115,
    schoolName: `Te Wharekura o Te Rau Aroha`,
    eqiNumber: 539,
  },
  {
    schoolNumber: 3117,
    schoolName: `Te Kura Kaupapa Māori o Hokianga`,
    eqiNumber: 521,
  },
  {
    schoolNumber: 3118,
    schoolName: `Te Kura Kaupapa Maori o Taumarunui`,
    eqiNumber: 531,
  },
  {
    schoolNumber: 3119,
    schoolName: `TKKM o Kawakawa mai Tawhiti`,
    eqiNumber: 523,
  },
  { schoolNumber: 3180, schoolName: `Appleby School`, eqiNumber: 430 },
  { schoolNumber: 3181, schoolName: `Auckland Point School`, eqiNumber: 501 },
  { schoolNumber: 3182, schoolName: `Birchwood School`, eqiNumber: 456 },
  { schoolNumber: 3183, schoolName: `Brightwater School`, eqiNumber: 439 },
  { schoolNumber: 3184, schoolName: `Broadgreen Intermediate`, eqiNumber: 471 },
  {
    schoolNumber: 3185,
    schoolName: `Brooklyn School (Motueka)`,
    eqiNumber: 450,
  },
  { schoolNumber: 3186, schoolName: `Canvastown School`, eqiNumber: 467 },
  { schoolNumber: 3187, schoolName: `Clifton Terrace School`, eqiNumber: 406 },
  { schoolNumber: 3188, schoolName: `Dovedale School`, eqiNumber: 447 },
  { schoolNumber: 3189, schoolName: `Enner Glynn School`, eqiNumber: 425 },
  { schoolNumber: 3192, schoolName: `Granity School`, eqiNumber: 531 },
  { schoolNumber: 3193, schoolName: `Hampden Street School`, eqiNumber: 424 },
  { schoolNumber: 3194, schoolName: `Henley School (Nelson)`, eqiNumber: 430 },
  { schoolNumber: 3195, schoolName: `Hira School`, eqiNumber: 442 },
  { schoolNumber: 3196, schoolName: `Hope School`, eqiNumber: 429 },
  { schoolNumber: 3199, schoolName: `Lake Rotoiti School`, eqiNumber: 430 },
  { schoolNumber: 3200, schoolName: `Lower Moutere School`, eqiNumber: 474 },
  { schoolNumber: 3201, schoolName: `Mahana School`, eqiNumber: 414 },
  { schoolNumber: 3202, schoolName: `Maitai School`, eqiNumber: 484 },
  { schoolNumber: 3203, schoolName: `Mapua School`, eqiNumber: 398 },
  { schoolNumber: 3204, schoolName: `Maruia School`, eqiNumber: 445 },
  { schoolNumber: 3206, schoolName: `Motueka South School`, eqiNumber: 455 },
  { schoolNumber: 3207, schoolName: `Motupipi School`, eqiNumber: 426 },
  { schoolNumber: 3208, schoolName: `Nayland Primary School`, eqiNumber: 462 },
  { schoolNumber: 3209, schoolName: `Nelson Central School`, eqiNumber: 425 },
  { schoolNumber: 3210, schoolName: `Nelson Intermediate`, eqiNumber: 454 },
  { schoolNumber: 3212, schoolName: `Ngatimoti School`, eqiNumber: 437 },
  {
    schoolNumber: 3213,
    schoolName: `Parklands School (Motueka)`,
    eqiNumber: 503,
  },
  { schoolNumber: 3214, schoolName: `Ranzau School`, eqiNumber: 433 },
  {
    schoolNumber: 3216,
    schoolName: `Richmond School (Nelson)`,
    eqiNumber: 455,
  },
  { schoolNumber: 3217, schoolName: `Riwaka School`, eqiNumber: 450 },
  {
    schoolNumber: 3219,
    schoolName: `Sacred Heart School (Reefton)`,
    eqiNumber: 451,
  },
  {
    schoolNumber: 3220,
    schoolName: `St Canice's School (Westport)`,
    eqiNumber: 436,
  },
  {
    schoolNumber: 3221,
    schoolName: `St Joseph's School (Nelson)`,
    eqiNumber: 401,
  },
  {
    schoolNumber: 3222,
    schoolName: `St Peter Chanel School (Motueka)`,
    eqiNumber: 453,
  },
  { schoolNumber: 3223, schoolName: `Stoke School`, eqiNumber: 484 },
  { schoolNumber: 3224, schoolName: `Tahunanui School`, eqiNumber: 474 },
  { schoolNumber: 3225, schoolName: `Central Takaka School`, eqiNumber: 458 },
  { schoolNumber: 3226, schoolName: `Takaka Primary School`, eqiNumber: 452 },
  { schoolNumber: 3228, schoolName: `Tasman School`, eqiNumber: 414 },
  { schoolNumber: 3229, schoolName: `Upper Moutere School`, eqiNumber: 423 },
  { schoolNumber: 3231, schoolName: `Victory Primary School`, eqiNumber: 469 },
  { schoolNumber: 3233, schoolName: `Waimea Intermediate`, eqiNumber: 451 },
  { schoolNumber: 3234, schoolName: `Wakefield School`, eqiNumber: 440 },
  { schoolNumber: 3235, schoolName: `Westport North School`, eqiNumber: 497 },
  { schoolNumber: 3236, schoolName: `Westport South School`, eqiNumber: 479 },
  {
    schoolNumber: 3270,
    schoolName: `Sacred Heart School (Christchurch)`,
    eqiNumber: 404,
  },
  {
    schoolNumber: 3271,
    schoolName: `Addington Te Kura Taumatua`,
    eqiNumber: 470,
  },
  { schoolNumber: 3273, schoolName: `Albury School`, eqiNumber: 435 },
  { schoolNumber: 3274, schoolName: `Allenton School`, eqiNumber: 440 },
  { schoolNumber: 3275, schoolName: `Pītau-Allenvale School`, eqiNumber: 466 },
  { schoolNumber: 3276, schoolName: `Amberley School`, eqiNumber: 463 },
  { schoolNumber: 3280, schoolName: `Arowhenua Maori School`, eqiNumber: 548 },
  {
    schoolNumber: 3281,
    schoolName: `Ashburton Borough School`,
    eqiNumber: 458,
  },
  { schoolNumber: 3282, schoolName: `Ashburton Intermediate`, eqiNumber: 474 },
  {
    schoolNumber: 3283,
    schoolName: `Ashburton Netherby School`,
    eqiNumber: 501,
  },
  { schoolNumber: 3284, schoolName: `Tūtira Ashgrove School`, eqiNumber: 442 },
  { schoolNumber: 3285, schoolName: `Ashley Rakahuri School`, eqiNumber: 444 },
  {
    schoolNumber: 3287,
    schoolName: `Avonhead School - Rakipaoa`,
    eqiNumber: 406,
  },
  { schoolNumber: 3288, schoolName: `Ngutuawa School`, eqiNumber: 526 },
  {
    schoolNumber: 3289,
    schoolName: `Pareawa Banks Avenue School`,
    eqiNumber: 466,
  },
  { schoolNumber: 3290, schoolName: `Barrytown School`, eqiNumber: 470 },
  {
    schoolNumber: 3291,
    schoolName: `Beckenham Te Kura o Pūroto`,
    eqiNumber: 412,
  },
  { schoolNumber: 3292, schoolName: `Pūtahi Belfast School`, eqiNumber: 458 },
  {
    schoolNumber: 3293,
    schoolName: `Bishopdale School Te Kura o Papakōhatu`,
    eqiNumber: 521,
  },
  { schoolNumber: 3295, schoolName: `Blaketown School`, eqiNumber: 513 },
  { schoolNumber: 3299, schoolName: `Breens Intermediate`, eqiNumber: 443 },
  { schoolNumber: 3301, schoolName: `Broadfield School`, eqiNumber: 397 },
  { schoolNumber: 3302, schoolName: `Bromley School`, eqiNumber: 513 },
  { schoolNumber: 3303, schoolName: `Broomfield School`, eqiNumber: 419 },
  {
    schoolNumber: 3304,
    schoolName: `Burnham School - Te Kura o Tiori`,
    eqiNumber: 474,
  },
  {
    schoolNumber: 3305,
    schoolName: `Tuia Burnside Primary School`,
    eqiNumber: 437,
  },
  { schoolNumber: 3307, schoolName: `Cannington School`, eqiNumber: 461 },
  {
    schoolNumber: 3308,
    schoolName: `Carew Peel Forest School`,
    eqiNumber: 417,
  },
  { schoolNumber: 3309, schoolName: `Casebrook Intermediate`, eqiNumber: 466 },
  {
    schoolNumber: 3310,
    schoolName: `Cashmere Primary Te Pae Kererū`,
    eqiNumber: 368,
  },
  { schoolNumber: 3313, schoolName: `Chertsey School`, eqiNumber: 502 },
  {
    schoolNumber: 3314,
    schoolName: `Chisnallwood Intermediate`,
    eqiNumber: 482,
  },
  {
    schoolNumber: 3316,
    schoolName: `Christ The King School (Burnside)`,
    eqiNumber: 369,
  },
  {
    schoolNumber: 3317,
    schoolName: `Christchurch East School`,
    eqiNumber: 454,
  },
  {
    schoolNumber: 3318,
    schoolName: `Christchurch South Karamata Intermediate School`,
    eqiNumber: 411,
  },
  {
    schoolNumber: 3321,
    schoolName: `Clarkville Te Kura ki Waimātao`,
    eqiNumber: 429,
  },
  { schoolNumber: 3322, schoolName: `Cobden School`, eqiNumber: 523 },
  {
    schoolNumber: 3323,
    schoolName: `Wairarapa Cobham Intermediate`,
    eqiNumber: 405,
  },
  { schoolNumber: 3324, schoolName: `Cotswold Mātāhae School`, eqiNumber: 419 },
  { schoolNumber: 3325, schoolName: `Cust School`, eqiNumber: 412 },
  { schoolNumber: 3326, schoolName: `Darfield School`, eqiNumber: 430 },
  { schoolNumber: 3327, schoolName: `Diamond Harbour School`, eqiNumber: 412 },
  { schoolNumber: 3329, schoolName: `Dorie School`, eqiNumber: 414 },
  { schoolNumber: 3331, schoolName: `Dunsandel School`, eqiNumber: 426 },
  { schoolNumber: 3332, schoolName: `Duvauchelle School`, eqiNumber: 420 },
  { schoolNumber: 3334, schoolName: `Elmwood Normal School`, eqiNumber: 376 },
  { schoolNumber: 3335, schoolName: `Fairlie School`, eqiNumber: 437 },
  { schoolNumber: 3336, schoolName: `Fairton School`, eqiNumber: 460 },
  { schoolNumber: 3338, schoolName: `Tūora Fendalton School`, eqiNumber: 371 },
  { schoolNumber: 3339, schoolName: `Ferndale Te Ahu`, eqiNumber: 521 },
  { schoolNumber: 3340, schoolName: `Fernside School`, eqiNumber: 412 },
  { schoolNumber: 3342, schoolName: `Fox Glacier School`, eqiNumber: 470 },
  {
    schoolNumber: 3343,
    schoolName: `Franz Josef Glacier School`,
    eqiNumber: 422,
  },
  { schoolNumber: 3346, schoolName: `Gilberthorpe School`, eqiNumber: 475 },
  { schoolNumber: 3347, schoolName: `Gleniti School`, eqiNumber: 414 },
  { schoolNumber: 3348, schoolName: `Glenavy School`, eqiNumber: 446 },
  { schoolNumber: 3352, schoolName: `Glentunnel School`, eqiNumber: 428 },
  {
    schoolNumber: 3354,
    schoolName: `Te Kura o Ōhinetahi - Governors Bay`,
    eqiNumber: 386,
  },
  { schoolNumber: 3357, schoolName: `Greendale School`, eqiNumber: 434 },
  { schoolNumber: 3359, schoolName: `Greta Valley School`, eqiNumber: 442 },
  { schoolNumber: 3361, schoolName: `Greymouth Main School`, eqiNumber: 492 },
  { schoolNumber: 3363, schoolName: `Haast School`, eqiNumber: 471 },
  {
    schoolNumber: 3366,
    schoolName: `Te Kura o te Tauawa Halswell School`,
    eqiNumber: 385,
  },
  { schoolNumber: 3367, schoolName: `Hampstead School`, eqiNumber: 489 },
  { schoolNumber: 3368, schoolName: `Hanmer Springs School`, eqiNumber: 426 },
  { schoolNumber: 3369, schoolName: `Hāpuku School`, eqiNumber: 501 },
  { schoolNumber: 3370, schoolName: `Harewood School`, eqiNumber: 410 },
  { schoolNumber: 3371, schoolName: `Heathcote Valley School`, eqiNumber: 424 },
  {
    schoolNumber: 3372,
    schoolName: `He Tīwai Mātauranga Heaton Normal Intermediate`,
    eqiNumber: 407,
  },
  { schoolNumber: 3373, schoolName: `Highfield School`, eqiNumber: 477 },
  { schoolNumber: 3375, schoolName: `Hinds School`, eqiNumber: 434 },
  { schoolNumber: 3376, schoolName: `Hokitika Primary School`, eqiNumber: 479 },
  { schoolNumber: 3379, schoolName: `Hoon Hay Te Kura Kōaka`, eqiNumber: 416 },
  { schoolNumber: 3380, schoolName: `Hornby Primary School`, eqiNumber: 489 },
  { schoolNumber: 3381, schoolName: `Hororata School`, eqiNumber: 432 },
  { schoolNumber: 3384, schoolName: `Ilam School`, eqiNumber: 394 },
  {
    schoolNumber: 3385,
    schoolName: `Te Kura o Te Mātāpuna Isleworth School`,
    eqiNumber: 466,
  },
  {
    schoolNumber: 3387,
    schoolName: `Kaingaroa School (Chatham Islands)`,
    eqiNumber: 501,
  },
  { schoolNumber: 3388, schoolName: `Kaiapoi Borough School`, eqiNumber: 490 },
  { schoolNumber: 3389, schoolName: `Kaiapoi North School`, eqiNumber: 461 },
  { schoolNumber: 3391, schoolName: `Kaikōura Primary School`, eqiNumber: 471 },
  {
    schoolNumber: 3392,
    schoolName: `Kaikōura Suburban School`,
    eqiNumber: 450,
  },
  { schoolNumber: 3393, schoolName: `Kaniere School`, eqiNumber: 443 },
  { schoolNumber: 3394, schoolName: `Karoro School`, eqiNumber: 447 },
  {
    schoolNumber: 3396,
    schoolName: `Kahikatea Kirkwood Intermediate`,
    eqiNumber: 430,
  },
  { schoolNumber: 3397, schoolName: `Kirwee Model School`, eqiNumber: 420 },
  {
    schoolNumber: 3398,
    schoolName: `Kokatahi-Kowhitirangi School`,
    eqiNumber: 477,
  },
  { schoolNumber: 3401, schoolName: `Kumara School`, eqiNumber: 473 },
  { schoolNumber: 3402, schoolName: `Ladbrooks School`, eqiNumber: 403 },
  { schoolNumber: 3406, schoolName: `Lake Tekapo School`, eqiNumber: 415 },
  { schoolNumber: 3407, schoolName: `Lauriston School`, eqiNumber: 399 },
  { schoolNumber: 3410, schoolName: `Leeston School`, eqiNumber: 451 },
  {
    schoolNumber: 3411,
    schoolName: `Leithfield School Te Kura o Kōwai`,
    eqiNumber: 448,
  },
  { schoolNumber: 3412, schoolName: `Lincoln Primary School`, eqiNumber: 407 },
  {
    schoolNumber: 3413,
    schoolName: `Te Huarahi Linwood Avenue School`,
    eqiNumber: 499,
  },
  { schoolNumber: 3415, schoolName: `Whītau School`, eqiNumber: 513 },
  { schoolNumber: 3418, schoolName: `Little River School`, eqiNumber: 423 },
  { schoolNumber: 3419, schoolName: `Loburn School`, eqiNumber: 430 },
  { schoolNumber: 3425, schoolName: `Mairehau Primary School`, eqiNumber: 466 },
  { schoolNumber: 3426, schoolName: `Makikihi School`, eqiNumber: 478 },
  { schoolNumber: 3429, schoolName: `Marshland School`, eqiNumber: 404 },
  {
    schoolNumber: 3432,
    schoolName: `Mayfield School (Mid-Canterbury)`,
    eqiNumber: 442,
  },
  {
    schoolNumber: 3434,
    schoolName: `Merrin School Ngā Whetū Kohara`,
    eqiNumber: 398,
  },
  { schoolNumber: 3436, schoolName: `Methven Primary School`, eqiNumber: 423 },
  {
    schoolNumber: 3441,
    schoolName: `Mt Somers Springburn School`,
    eqiNumber: 439,
  },
  {
    schoolNumber: 3442,
    schoolName: `Aoraki Mount Cook School`,
    eqiNumber: 411,
  },
  { schoolNumber: 3443, schoolName: `Mt Pleasant School`, eqiNumber: 393 },
  {
    schoolNumber: 3445,
    schoolName: `New Brighton Catholic School (Chch)`,
    eqiNumber: 445,
  },
  { schoolNumber: 3447, schoolName: `North Loburn School`, eqiNumber: 420 },
  {
    schoolNumber: 3449,
    schoolName: `Te Kura o Matarangi - Northcote School`,
    eqiNumber: 533,
  },
  {
    schoolNumber: 3450,
    schoolName: `Oaklands Te Kura o Ōwaka`,
    eqiNumber: 410,
  },
  { schoolNumber: 3451, schoolName: `Ōhoka School`, eqiNumber: 406 },
  { schoolNumber: 3452, schoolName: `Okains Bay School`, eqiNumber: 545 },
  { schoolNumber: 3454, schoolName: `Omihi School`, eqiNumber: 435 },
  {
    schoolNumber: 3455,
    schoolName: `Te Kura o Ōpāwaho – Opawa School`,
    eqiNumber: 463,
  },
  {
    schoolNumber: 3461,
    schoolName: `Our Lady of the Assumption School (Chch)`,
    eqiNumber: 401,
  },
  {
    schoolNumber: 3462,
    schoolName: `Our Lady of the Snows School (Methven)`,
    eqiNumber: 403,
  },
  { schoolNumber: 3463, schoolName: `Our Lady of Victories`, eqiNumber: 376 },
  { schoolNumber: 3464, schoolName: `Ōuruhia Model School`, eqiNumber: 445 },
  { schoolNumber: 3466, schoolName: `Papanui Primary School`, eqiNumber: 452 },
  { schoolNumber: 3467, schoolName: `Paparoa Street School`, eqiNumber: 398 },
  { schoolNumber: 3470, schoolName: `Parkview Pārua`, eqiNumber: 477 },
  {
    schoolNumber: 3472,
    schoolName: `Paroa School (Greymouth)`,
    eqiNumber: 453,
  },
  { schoolNumber: 3476, schoolName: `Pitt Island School`, eqiNumber: 471 },
  {
    schoolNumber: 3477,
    schoolName: `Pleasant Point Primary School`,
    eqiNumber: 444,
  },
  { schoolNumber: 3478, schoolName: `Prebbleton School`, eqiNumber: 379 },
  {
    schoolNumber: 3479,
    schoolName: `Queenspark Te Hua Mānuka`,
    eqiNumber: 453,
  },
  { schoolNumber: 3480, schoolName: `Rakaia School`, eqiNumber: 465 },
  { schoolNumber: 3481, schoolName: `Rangiora Borough School`, eqiNumber: 463 },
  {
    schoolNumber: 3483,
    schoolName: `Te Raekura Redcliffs School`,
    eqiNumber: 400,
  },
  {
    schoolNumber: 3484,
    schoolName: `Redwood School (Christchurch)`,
    eqiNumber: 443,
  },
  {
    schoolNumber: 3485,
    schoolName: `Te Kāpehu Riccarton School`,
    eqiNumber: 462,
  },
  { schoolNumber: 3488, schoolName: `Rolleston School`, eqiNumber: 425 },
  { schoolNumber: 3489, schoolName: `Ross School`, eqiNumber: 502 },
  { schoolNumber: 3490, schoolName: `Rotherham School`, eqiNumber: 441 },
  {
    schoolNumber: 3492,
    schoolName: `Te Kōmanawa Rowley School`,
    eqiNumber: 535,
  },
  {
    schoolNumber: 3493,
    schoolName: `Te Ara Maurea Roydvale School`,
    eqiNumber: 395,
  },
  { schoolNumber: 3495, schoolName: `Runanga School`, eqiNumber: 534 },
  {
    schoolNumber: 3496,
    schoolName: `Te Parito Kōwhai Russley School`,
    eqiNumber: 420,
  },
  {
    schoolNumber: 3498,
    schoolName: `Sacred Heart School (Timaru)`,
    eqiNumber: 438,
  },
  { schoolNumber: 3501, schoolName: `Te Waitai Sefton School`, eqiNumber: 434 },
  {
    schoolNumber: 3502,
    schoolName: `Sheffield Contributing School`,
    eqiNumber: 431,
  },
  { schoolNumber: 3503, schoolName: `Te Oraka`, eqiNumber: 505 },
  {
    schoolNumber: 3504,
    schoolName: `Te Hiwa Shirley Primary School`,
    eqiNumber: 494,
  },
  {
    schoolNumber: 3505,
    schoolName: `Wigram Primary School - Te Piki Kāhu`,
    eqiNumber: 392,
  },
  {
    schoolNumber: 3506,
    schoolName: `Somerfield Te Kura Wairepo`,
    eqiNumber: 419,
  },
  {
    schoolNumber: 3507,
    schoolName: `Te Manu Tukutuku South Hornby School`,
    eqiNumber: 464,
  },
  {
    schoolNumber: 3508,
    schoolName: `South New Brighton School`,
    eqiNumber: 454,
  },
  { schoolNumber: 3509, schoolName: `Southbridge School`, eqiNumber: 452 },
  { schoolNumber: 3510, schoolName: `Southbrook School`, eqiNumber: 474 },
  {
    schoolNumber: 3512,
    schoolName: `Te Kura o Mōkihi Spreydon School`,
    eqiNumber: 453,
  },
  { schoolNumber: 3515, schoolName: `Springfield School`, eqiNumber: 439 },
  { schoolNumber: 3516, schoolName: `Springston School`, eqiNumber: 433 },
  {
    schoolNumber: 3517,
    schoolName: `St Albans Catholic School (Christchurch)`,
    eqiNumber: 394,
  },
  { schoolNumber: 3518, schoolName: `St Albans School`, eqiNumber: 414 },
  {
    schoolNumber: 3519,
    schoolName: `St Andrew's School (Timaru)`,
    eqiNumber: 479,
  },
  {
    schoolNumber: 3520,
    schoolName: `St Anne's School (Woolston)`,
    eqiNumber: 447,
  },
  {
    schoolNumber: 3521,
    schoolName: `St Bernadette's School (Hornby)`,
    eqiNumber: 423,
  },
  {
    schoolNumber: 3523,
    schoolName: `St James School (Aranui)`,
    eqiNumber: 501,
  },
  {
    schoolNumber: 3527,
    schoolName: `St Joseph's School (Ashburton)`,
    eqiNumber: 408,
  },
  {
    schoolNumber: 3528,
    schoolName: `St Joseph's School (Pleasant Point)`,
    eqiNumber: 426,
  },
  {
    schoolNumber: 3529,
    schoolName: `St Joseph's School (Fairlie)`,
    eqiNumber: 427,
  },
  {
    schoolNumber: 3530,
    schoolName: `St Joseph’s School (Kaikōura)`,
    eqiNumber: 431,
  },
  {
    schoolNumber: 3531,
    schoolName: `St Joseph's School (Papanui)`,
    eqiNumber: 395,
  },
  {
    schoolNumber: 3532,
    schoolName: `St Joseph's School (Temuka)`,
    eqiNumber: 451,
  },
  {
    schoolNumber: 3533,
    schoolName: `St Joseph's School (Timaru)`,
    eqiNumber: 403,
  },
  { schoolNumber: 3534, schoolName: `St Martins School`, eqiNumber: 402 },
  {
    schoolNumber: 3535,
    schoolName: `St Mary's School (Christchurch)`,
    eqiNumber: 397,
  },
  {
    schoolNumber: 3536,
    schoolName: `St Mary's School (Hokitika)`,
    eqiNumber: 442,
  },
  {
    schoolNumber: 3537,
    schoolName: `St Patrick's School (Bryndwr)`,
    eqiNumber: 376,
  },
  {
    schoolNumber: 3538,
    schoolName: `St Patrick's School (Greymouth)`,
    eqiNumber: 442,
  },
  {
    schoolNumber: 3539,
    schoolName: `St Patrick's School (Waimate)`,
    eqiNumber: 408,
  },
  {
    schoolNumber: 3540,
    schoolName: `St Patrick's School (Kaiapoi)`,
    eqiNumber: 440,
  },
  {
    schoolNumber: 3542,
    schoolName: `St Peter’s School Te Kura Haoika`,
    eqiNumber: 397,
  },
  {
    schoolNumber: 3543,
    schoolName: `St Teresa's School (Riccarton)`,
    eqiNumber: 398,
  },
  {
    schoolNumber: 3544,
    schoolName: `Our Lady Star of the Sea School (Christchurch)`,
    eqiNumber: 401,
  },
  { schoolNumber: 3546, schoolName: `Sumner School`, eqiNumber: 382 },
  { schoolNumber: 3547, schoolName: `Swannanoa School`, eqiNumber: 419 },
  { schoolNumber: 3549, schoolName: `Tai Tapu School`, eqiNumber: 400 },
  { schoolNumber: 3553, schoolName: `Te One School`, eqiNumber: 483 },
  { schoolNumber: 3554, schoolName: `Waitaha School`, eqiNumber: 462 },
  { schoolNumber: 3555, schoolName: `Templeton School`, eqiNumber: 449 },
  {
    schoolNumber: 3557,
    schoolName: `Te Kura o Huriawa Thorrington`,
    eqiNumber: 377,
  },
  { schoolNumber: 3561, schoolName: `Tinwald School`, eqiNumber: 465 },
  { schoolNumber: 3563, schoolName: `Te Kura o Tuahiwi`, eqiNumber: 498 },
  { schoolNumber: 3565, schoolName: `View Hill School`, eqiNumber: 439 },
  { schoolNumber: 3566, schoolName: `Waiau School`, eqiNumber: 442 },
  { schoolNumber: 3567, schoolName: `Waihao Downs School`, eqiNumber: 442 },
  { schoolNumber: 3569, schoolName: `Waikari School`, eqiNumber: 455 },
  { schoolNumber: 3570, schoolName: `Pegasus Bay School`, eqiNumber: 422 },
  { schoolNumber: 3571, schoolName: `Waimairi School`, eqiNumber: 418 },
  { schoolNumber: 3572, schoolName: `Waimataitai School`, eqiNumber: 464 },
  {
    schoolNumber: 3573,
    schoolName: `Waimate Centennial School`,
    eqiNumber: 473,
  },
  { schoolNumber: 3574, schoolName: `Waimate Main School`, eqiNumber: 483 },
  { schoolNumber: 3576, schoolName: `Waipara School`, eqiNumber: 478 },
  {
    schoolNumber: 3577,
    schoolName: `Wairakei School (Christchurch)`,
    eqiNumber: 478,
  },
  { schoolNumber: 3579, schoolName: `Waituna Creek School`, eqiNumber: 448 },
  { schoolNumber: 3580, schoolName: `Wakanui School`, eqiNumber: 415 },
  { schoolNumber: 3581, schoolName: `Waltham School`, eqiNumber: 489 },
  { schoolNumber: 3585, schoolName: `Weedons School`, eqiNumber: 420 },
  { schoolNumber: 3586, schoolName: `West Eyreton School`, eqiNumber: 438 },
  { schoolNumber: 3587, schoolName: `West Melton School`, eqiNumber: 391 },
  {
    schoolNumber: 3588,
    schoolName: `Te Ara Koropiko West Spreydon School`,
    eqiNumber: 445,
  },
  {
    schoolNumber: 3589,
    schoolName: `Westburn Te Kura O Hereora`,
    eqiNumber: 383,
  },
  { schoolNumber: 3591, schoolName: `Wharenui School`, eqiNumber: 457 },
  { schoolNumber: 3592, schoolName: `Whataroa School`, eqiNumber: 482 },
  { schoolNumber: 3594, schoolName: `Longbeach School`, eqiNumber: 420 },
  { schoolNumber: 3597, schoolName: `Windwhistle School`, eqiNumber: 389 },
  { schoolNumber: 3599, schoolName: `Woodbury School`, eqiNumber: 412 },
  { schoolNumber: 3600, schoolName: `Woodend School`, eqiNumber: 453 },
  {
    schoolNumber: 3602,
    schoolName: `Yaldhurst School – Tōtara Tūkaha`,
    eqiNumber: 432,
  },
  { schoolNumber: 3612, schoolName: `Mangakōtukutuku College`, eqiNumber: 529 },
  {
    schoolNumber: 3618,
    schoolName: `Te Kura aa Iwi o Ngaati Kauwhata`,
    eqiNumber: 540,
  },
  { schoolNumber: 3619, schoolName: `Te Kāpehu Whetū`, eqiNumber: 529 },
  { schoolNumber: 3625, schoolName: `Māruawai College`, eqiNumber: 494 },
  {
    schoolNumber: 3628,
    schoolName: `Elim Christian College Henderson`,
    eqiNumber: 378,
  },
  {
    schoolNumber: 3630,
    schoolName: `Elim Christian College Mt Albert`,
    eqiNumber: 394,
  },
  {
    schoolNumber: 3659,
    schoolName: `Te Kura ā Iwi o Te Waimate`,
    eqiNumber: 495,
  },
  {
    schoolNumber: 3679,
    schoolName: `Te Kura Kaupapa Māori o Ngā Papaonekura`,
    eqiNumber: 485,
  },
  {
    schoolNumber: 3680,
    schoolName: `Mastery Schools New Zealand - Arapaki`,
    eqiNumber: 434,
  },
  { schoolNumber: 3681, schoolName: `The BUSY School NZ`, eqiNumber: 445 },
  {
    schoolNumber: 3682,
    schoolName: `Ecole Francaise Internationale Auckland`,
    eqiNumber: 368,
  },
  { schoolNumber: 3683, schoolName: `Te Rito - Te Kura Taiao`, eqiNumber: 523 },
  {
    schoolNumber: 3684,
    schoolName: `Christchurch North College`,
    eqiNumber: 446,
  },
  { schoolNumber: 3686, schoolName: `North West College`, eqiNumber: 394 },
  { schoolNumber: 3687, schoolName: `TIPENE`, eqiNumber: 542 },
  { schoolNumber: 3689, schoolName: `Te Hīkoi`, eqiNumber: 569 },
  {
    schoolNumber: 3690,
    schoolName: `Te Pā Wānanga o Ōmaka Marae`,
    eqiNumber: 526,
  },
  {
    schoolNumber: 3698,
    schoolName: `Twin Oaks Classical School`,
    eqiNumber: 384,
  },
  { schoolNumber: 3699, schoolName: `Totara Point School`, eqiNumber: 395 },
  { schoolNumber: 3700, schoolName: `Abbotsford School`, eqiNumber: 438 },
  {
    schoolNumber: 3701,
    schoolName: `Alexandra Primary School`,
    eqiNumber: 447,
  },
  { schoolNumber: 3703, schoolName: `Andersons Bay School`, eqiNumber: 409 },
  { schoolNumber: 3704, schoolName: `Ardgowan School`, eqiNumber: 453 },
  { schoolNumber: 3706, schoolName: `Arthur Street School`, eqiNumber: 424 },
  { schoolNumber: 3707, schoolName: `Fenwick School`, eqiNumber: 465 },
  { schoolNumber: 3709, schoolName: `Balaclava School`, eqiNumber: 428 },
  { schoolNumber: 3710, schoolName: `Balclutha School`, eqiNumber: 481 },
  { schoolNumber: 3711, schoolName: `Balmacewen Intermediate`, eqiNumber: 425 },
  { schoolNumber: 3716, schoolName: `Bradford School`, eqiNumber: 475 },
  { schoolNumber: 3718, schoolName: `Broad Bay School`, eqiNumber: 432 },
  { schoolNumber: 3719, schoolName: `Brockville School`, eqiNumber: 528 },
  { schoolNumber: 3723, schoolName: `Clinton School`, eqiNumber: 447 },
  { schoolNumber: 3724, schoolName: `Clutha Valley School`, eqiNumber: 445 },
  { schoolNumber: 3725, schoolName: `Clyde School`, eqiNumber: 420 },
  { schoolNumber: 3727, schoolName: `Concord School`, eqiNumber: 498 },
  { schoolNumber: 3729, schoolName: `Cromwell Primary School`, eqiNumber: 426 },
  {
    schoolNumber: 3731,
    schoolName: `Dunedin North Intermediate`,
    eqiNumber: 435,
  },
  { schoolNumber: 3732, schoolName: `Duntroon School`, eqiNumber: 423 },
  { schoolNumber: 3733, schoolName: `East Taieri School`, eqiNumber: 401 },
  {
    schoolNumber: 3736,
    schoolName: `Fairfield School (Dunedin)`,
    eqiNumber: 420,
  },
  {
    schoolNumber: 3737,
    schoolName: `Pembroke School (Oamaru)`,
    eqiNumber: 496,
  },
  { schoolNumber: 3738, schoolName: `Five Forks School`, eqiNumber: 449 },
  {
    schoolNumber: 3740,
    schoolName: `George Street Normal School`,
    eqiNumber: 403,
  },
  {
    schoolNumber: 3741,
    schoolName: `Goldfields School (Cromwell)`,
    eqiNumber: 431,
  },
  { schoolNumber: 3742, schoolName: `Grants Braes School`, eqiNumber: 395 },
  { schoolNumber: 3743, schoolName: `Green Island School`, eqiNumber: 490 },
  { schoolNumber: 3745, schoolName: `Halfway Bush School`, eqiNumber: 498 },
  { schoolNumber: 3746, schoolName: `Hampden School`, eqiNumber: 489 },
  { schoolNumber: 3747, schoolName: `Hāwea Flat School`, eqiNumber: 412 },
  { schoolNumber: 3749, schoolName: `Heriot School`, eqiNumber: 441 },
  { schoolNumber: 3753, schoolName: `Kaikorai School`, eqiNumber: 397 },
  { schoolNumber: 3754, schoolName: `Kaitangata School`, eqiNumber: 496 },
  { schoolNumber: 3755, schoolName: `Kakanui School`, eqiNumber: 450 },
  { schoolNumber: 3756, schoolName: `Karitane School`, eqiNumber: 463 },
  { schoolNumber: 3761, schoolName: `Lee Stream School`, eqiNumber: 414 },
  { schoolNumber: 3762, schoolName: `Macandrew Bay School`, eqiNumber: 387 },
  {
    schoolNumber: 3764,
    schoolName: `Macraes Moonlight School`,
    eqiNumber: 461,
  },
  { schoolNumber: 3765, schoolName: `Maheno School`, eqiNumber: 430 },
  { schoolNumber: 3767, schoolName: `Makarora Primary School`, eqiNumber: 395 },
  { schoolNumber: 3768, schoolName: `Maori Hill School`, eqiNumber: 373 },
  { schoolNumber: 3771, schoolName: `Millers Flat School`, eqiNumber: 456 },
  { schoolNumber: 3772, schoolName: `Milton School`, eqiNumber: 492 },
  { schoolNumber: 3776, schoolName: `Mornington School`, eqiNumber: 439 },
  { schoolNumber: 3778, schoolName: `Elmgrove School`, eqiNumber: 460 },
  { schoolNumber: 3779, schoolName: `Musselburgh School`, eqiNumber: 500 },
  {
    schoolNumber: 3783,
    schoolName: `North East Valley Normal School`,
    eqiNumber: 450,
  },
  { schoolNumber: 3784, schoolName: `Oamaru Intermediate`, eqiNumber: 477 },
  { schoolNumber: 3785, schoolName: `Te Pākihi o Maru`, eqiNumber: 502 },
  { schoolNumber: 3788, schoolName: `Omakau School`, eqiNumber: 449 },
  { schoolNumber: 3789, schoolName: `Omarama School`, eqiNumber: 434 },
  { schoolNumber: 3790, schoolName: `Ōpoho School`, eqiNumber: 410 },
  { schoolNumber: 3795, schoolName: `Outram School`, eqiNumber: 440 },
  { schoolNumber: 3797, schoolName: `Palmerston School`, eqiNumber: 461 },
  { schoolNumber: 3798, schoolName: `Papakaio School`, eqiNumber: 449 },
  {
    schoolNumber: 3801,
    schoolName: `Pine Hill School (Dunedin)`,
    eqiNumber: 509,
  },
  { schoolNumber: 3802, schoolName: `Poolburn School`, eqiNumber: 431 },
  { schoolNumber: 3803, schoolName: `Port Chalmers School`, eqiNumber: 448 },
  { schoolNumber: 3805, schoolName: `Portobello School`, eqiNumber: 450 },
  { schoolNumber: 3807, schoolName: `Pūrākaunui School`, eqiNumber: 443 },
  { schoolNumber: 3808, schoolName: `Ravensbourne School`, eqiNumber: 479 },
  { schoolNumber: 3811, schoolName: `Romahapa School`, eqiNumber: 438 },
  {
    schoolNumber: 3812,
    schoolName: `Rosebank School (Balclutha)`,
    eqiNumber: 465,
  },
  {
    schoolNumber: 3815,
    schoolName: `Sacred Heart School (Dunedin)`,
    eqiNumber: 427,
  },
  { schoolNumber: 3816, schoolName: `Sara Cohen School`, eqiNumber: 498 },
  { schoolNumber: 3817, schoolName: `Sawyers Bay School`, eqiNumber: 432 },
  {
    schoolNumber: 3819,
    schoolName: `St Bernadette's School (Forbury)`,
    eqiNumber: 425,
  },
  {
    schoolNumber: 3820,
    schoolName: `St Brigids School (Tainui)`,
    eqiNumber: 399,
  },
  {
    schoolNumber: 3822,
    schoolName: `St Francis Xavier School (Mornington)`,
    eqiNumber: 387,
  },
  {
    schoolNumber: 3823,
    schoolName: `St Gerard's School (Alexandra)`,
    eqiNumber: 415,
  },
  {
    schoolNumber: 3824,
    schoolName: `St John's School (Ranfurly)`,
    eqiNumber: 395,
  },
  {
    schoolNumber: 3825,
    schoolName: `St Joseph's School (Oamaru)`,
    eqiNumber: 437,
  },
  {
    schoolNumber: 3826,
    schoolName: `St Joseph's School (Balclutha)`,
    eqiNumber: 410,
  },
  {
    schoolNumber: 3827,
    schoolName: `St Joseph's Cathedral School`,
    eqiNumber: 401,
  },
  {
    schoolNumber: 3829,
    schoolName: `St Leonard's School (Dunedin)`,
    eqiNumber: 414,
  },
  {
    schoolNumber: 3830,
    schoolName: `St Mary's School (Dunedin)`,
    eqiNumber: 403,
  },
  {
    schoolNumber: 3831,
    schoolName: `St Mary's School (Milton)`,
    eqiNumber: 465,
  },
  {
    schoolNumber: 3832,
    schoolName: `St Mary's School (Mosgiel)`,
    eqiNumber: 408,
  },
  {
    schoolNumber: 3834,
    schoolName: `St Peter Chanel School (Green Island)`,
    eqiNumber: 427,
  },
  { schoolNumber: 3835, schoolName: `St Clair School`, eqiNumber: 422 },
  { schoolNumber: 3836, schoolName: `Stirling School`, eqiNumber: 469 },
  { schoolNumber: 3837, schoolName: `Strath Taieri School`, eqiNumber: 432 },
  { schoolNumber: 3838, schoolName: `Tahakopa School` },
  {
    schoolNumber: 3839,
    schoolName: `Tahuna Normal Intermediate`,
    eqiNumber: 442,
  },
  { schoolNumber: 3840, schoolName: `Taieri Beach School`, eqiNumber: 538 },
  { schoolNumber: 3841, schoolName: `Tainui School`, eqiNumber: 441 },
  { schoolNumber: 3842, schoolName: `Tapanui School`, eqiNumber: 445 },
  { schoolNumber: 3843, schoolName: `Tarras School`, eqiNumber: 443 },
  {
    schoolNumber: 3844,
    schoolName: `The Terrace School (Alexandra)`,
    eqiNumber: 445,
  },
  { schoolNumber: 3845, schoolName: `Tokoiti School`, eqiNumber: 525 },
  { schoolNumber: 3847, schoolName: `Totara School`, eqiNumber: 450 },
  { schoolNumber: 3850, schoolName: `Waihola District School`, eqiNumber: 461 },
  { schoolNumber: 3851, schoolName: `Waikoikoi School`, eqiNumber: 490 },
  { schoolNumber: 3852, schoolName: `Waikouaiti School`, eqiNumber: 440 },
  { schoolNumber: 3855, schoolName: `Waitahuna School`, eqiNumber: 490 },
  { schoolNumber: 3857, schoolName: `Waitati School`, eqiNumber: 421 },
  { schoolNumber: 3858, schoolName: `Waiwera South School`, eqiNumber: 439 },
  { schoolNumber: 3859, schoolName: `Wakari School`, eqiNumber: 440 },
  { schoolNumber: 3861, schoolName: `Warepa School`, eqiNumber: 433 },
  { schoolNumber: 3862, schoolName: `Warrington School`, eqiNumber: 397 },
  { schoolNumber: 3864, schoolName: `Weston School`, eqiNumber: 434 },
  { schoolNumber: 3930, schoolName: `Arrowtown School`, eqiNumber: 395 },
  { schoolNumber: 3932, schoolName: `Balfour School`, eqiNumber: 421 },
  { schoolNumber: 3935, schoolName: `Hillside Primary School`, eqiNumber: 454 },
  {
    schoolNumber: 3938,
    schoolName: `Hauroko Valley Primary School`,
    eqiNumber: 428,
  },
  { schoolNumber: 3943, schoolName: `Dipton School`, eqiNumber: 421 },
  { schoolNumber: 3946, schoolName: `East Gore School`, eqiNumber: 518 },
  {
    schoolNumber: 3947,
    schoolName: `Edendale School (Southland)`,
    eqiNumber: 431,
  },
  { schoolNumber: 3953, schoolName: `Garston School`, eqiNumber: 429 },
  { schoolNumber: 3954, schoolName: `Glenham School` },
  { schoolNumber: 3955, schoolName: `Glenorchy School`, eqiNumber: 406 },
  { schoolNumber: 3956, schoolName: `Gore Main School`, eqiNumber: 455 },
  { schoolNumber: 3957, schoolName: `Gorge Road School`, eqiNumber: 460 },
  { schoolNumber: 3961, schoolName: `Halfmoon Bay School`, eqiNumber: 453 },
  { schoolNumber: 3963, schoolName: `Heddon Bush School`, eqiNumber: 439 },
  { schoolNumber: 3964, schoolName: `Hedgehope School`, eqiNumber: 440 },
  {
    schoolNumber: 3966,
    schoolName: `Invercargill Middle School`,
    eqiNumber: 484,
  },
  { schoolNumber: 3967, schoolName: `Windsor North School`, eqiNumber: 422 },
  { schoolNumber: 3973, schoolName: `Knapdale School`, eqiNumber: 455 },
  { schoolNumber: 3975, schoolName: `Limehills School`, eqiNumber: 429 },
  { schoolNumber: 3977, schoolName: `Lochiel School`, eqiNumber: 432 },
  { schoolNumber: 3979, schoolName: `Longford Intermediate` },
  { schoolNumber: 3980, schoolName: `Lumsden School`, eqiNumber: 458 },
  { schoolNumber: 3982, schoolName: `Makarewa School`, eqiNumber: 440 },
  { schoolNumber: 3984, schoolName: `Mararoa School`, eqiNumber: 425 },
  { schoolNumber: 3986, schoolName: `Mataura School`, eqiNumber: 514 },
  { schoolNumber: 3990, schoolName: `Mossburn School`, eqiNumber: 427 },
  { schoolNumber: 3991, schoolName: `Myross Bush School`, eqiNumber: 414 },
  { schoolNumber: 3997, schoolName: `Otama School`, eqiNumber: 442 },
  { schoolNumber: 4000, schoolName: `Otatara School`, eqiNumber: 412 },
  { schoolNumber: 4001, schoolName: `Otautau School`, eqiNumber: 461 },
  { schoolNumber: 4003, schoolName: `Pukerau School`, eqiNumber: 439 },
  {
    schoolNumber: 4005,
    schoolName: `Queenstown Primary School`,
    eqiNumber: 402,
  },
  { schoolNumber: 4006, schoolName: `Rimu School`, eqiNumber: 446 },
  { schoolNumber: 4007, schoolName: `Riversdale School`, eqiNumber: 441 },
  { schoolNumber: 4008, schoolName: `Riverton School`, eqiNumber: 469 },
  { schoolNumber: 4011, schoolName: `Ruru Special School`, eqiNumber: 519 },
  {
    schoolNumber: 4013,
    schoolName: `Sacred Heart School (Waikiwi)`,
    eqiNumber: 430,
  },
  { schoolNumber: 4014, schoolName: `Salford School`, eqiNumber: 422 },
  {
    schoolNumber: 4016,
    schoolName: `St Joseph's School (Queenstown)`,
    eqiNumber: 393,
  },
  {
    schoolNumber: 4017,
    schoolName: `St Joseph's School (Invercargill)`,
    eqiNumber: 465,
  },
  { schoolNumber: 4018, schoolName: `St Mary's School (Gore)`, eqiNumber: 429 },
  {
    schoolNumber: 4019,
    schoolName: `St Patrick's School (Nightcaps)`,
    eqiNumber: 544,
  },
  {
    schoolNumber: 4020,
    schoolName: `St Patrick's School (Invercargill)`,
    eqiNumber: 468,
  },
  {
    schoolNumber: 4021,
    schoolName: `St Teresa's School (Bluff)`,
    eqiNumber: 501,
  },
  {
    schoolNumber: 4022,
    schoolName: `St Theresa's School (Invercargill)`,
    eqiNumber: 405,
  },
  {
    schoolNumber: 4023,
    schoolName: `St Thomas School (Winton)`,
    eqiNumber: 407,
  },
  { schoolNumber: 4026, schoolName: `Te Anau School`, eqiNumber: 429 },
  { schoolNumber: 4027, schoolName: `Te Tipua School`, eqiNumber: 507 },
  { schoolNumber: 4028, schoolName: `Thornbury School`, eqiNumber: 438 },
  { schoolNumber: 4029, schoolName: `Tisbury School`, eqiNumber: 467 },
  { schoolNumber: 4030, schoolName: `Tokanui School`, eqiNumber: 462 },
  { schoolNumber: 4032, schoolName: `Tuturau Primary School`, eqiNumber: 487 },
  { schoolNumber: 4034, schoolName: `Waianiwa School`, eqiNumber: 438 },
  { schoolNumber: 4035, schoolName: `Waihopai School`, eqiNumber: 428 },
  { schoolNumber: 4036, schoolName: `Waikaia School`, eqiNumber: 407 },
  { schoolNumber: 4037, schoolName: `Waikaka School`, eqiNumber: 430 },
  { schoolNumber: 4046, schoolName: `Wallacetown School`, eqiNumber: 461 },
  { schoolNumber: 4047, schoolName: `Waverley Park School`, eqiNumber: 495 },
  { schoolNumber: 4050, schoolName: `West Gore School`, eqiNumber: 482 },
  { schoolNumber: 4052, schoolName: `Winton School`, eqiNumber: 471 },
  {
    schoolNumber: 4053,
    schoolName: `Woodlands Full Primary School`,
    eqiNumber: 440,
  },
  { schoolNumber: 4054, schoolName: `Wyndham School`, eqiNumber: 455 },
  { schoolNumber: 4100, schoolName: `Balmoral S D A School`, eqiNumber: 441 },
  {
    schoolNumber: 4104,
    schoolName: `Hadlow Preparatory School`,
    eqiNumber: 386,
  },
  {
    schoolNumber: 4105,
    schoolName: `Hamilton Seventh-Day Adventist School`,
    eqiNumber: 425,
  },
  {
    schoolNumber: 4107,
    schoolName: `Parkside Christian S D A School`,
    eqiNumber: 471,
  },
  {
    schoolNumber: 4112,
    schoolName: `Southland Adventist Christian School`,
    eqiNumber: 439,
  },
  {
    schoolNumber: 4117,
    schoolName: `Liberton Christian School`,
    eqiNumber: 379,
  },
  {
    schoolNumber: 4119,
    schoolName: `Wellington Hills Christian College`,
    eqiNumber: 414,
  },
  {
    schoolNumber: 4123,
    schoolName: `New Plymouth Adventist Christian School`,
    eqiNumber: 443,
  },
  {
    schoolNumber: 4125,
    schoolName: `Southcity Christian School`,
    eqiNumber: 380,
  },
  {
    schoolNumber: 4126,
    schoolName: `Palmerston North Adventist Christian School`,
    eqiNumber: 433,
  },
  { schoolNumber: 4129, schoolName: `Rotorua S D A School`, eqiNumber: 508 },
  {
    schoolNumber: 4131,
    schoolName: `St John's Girls' School (Invercargill)`,
    eqiNumber: 417,
  },
  {
    schoolNumber: 4132,
    schoolName: `St Joseph's School (Rangiora)`,
    eqiNumber: 420,
  },
  {
    schoolNumber: 4135,
    schoolName: `St Mark's School (Christchurch)`,
    eqiNumber: 398,
  },
  {
    schoolNumber: 4140,
    schoolName: `South Auckland S D A School`,
    eqiNumber: 474,
  },
  { schoolNumber: 4143, schoolName: `Tamariki School`, eqiNumber: 464 },
  {
    schoolNumber: 4144,
    schoolName: `Tauranga Adventist School`,
    eqiNumber: 429,
  },
  {
    schoolNumber: 4145,
    schoolName: `Te Pi'ipi'inga Kakano Mai I Rangiatea`,
    eqiNumber: 514,
  },
  {
    schoolNumber: 4146,
    schoolName: `Timatanga Community School`,
    eqiNumber: 413,
  },
  { schoolNumber: 4150, schoolName: `Wellington S D A School`, eqiNumber: 453 },
  { schoolNumber: 4151, schoolName: `Waitakere S D A School`, eqiNumber: 471 },
  {
    schoolNumber: 4154,
    schoolName: `Whangarei Adventist Christian School`,
    eqiNumber: 474,
  },
  {
    schoolNumber: 4156,
    schoolName: `Blind and Low Vision Education Network NZ`,
    eqiNumber: 480,
  },
  {
    schoolNumber: 4157,
    schoolName: `Westbridge Residential School`,
    eqiNumber: 553,
  },
  {
    schoolNumber: 4158,
    schoolName: `Hutt International Boys' School`,
    eqiNumber: 366,
  },
  {
    schoolNumber: 4160,
    schoolName: `TKKM o Te Atihaunui-A-Paparangi`,
    eqiNumber: 507,
  },
  { schoolNumber: 4204, schoolName: `Hare Krishna School`, eqiNumber: 371 },
  {
    schoolNumber: 4205,
    schoolName: `TKKM o Piripono Te Kura Whakahou ki Ōtara`,
    eqiNumber: 542,
  },
  { schoolNumber: 4207, schoolName: `TKKM o Nga Maungarongo`, eqiNumber: 527 },
  { schoolNumber: 4208, schoolName: `TKKM o Mangere`, eqiNumber: 544 },
  { schoolNumber: 4209, schoolName: `TKKM o Manawatu`, eqiNumber: 506 },
  { schoolNumber: 4211, schoolName: `TKKM o Te Rito`, eqiNumber: 486 },
  { schoolNumber: 4212, schoolName: `TKKM o Waitaha`, eqiNumber: 519 },
  {
    schoolNumber: 4217,
    schoolName: `Te Wharekura o Arowhenua`,
    eqiNumber: 536,
  },
  { schoolNumber: 4218, schoolName: `TKKM o Tokomaru`, eqiNumber: 531 },
  { schoolNumber: 4223, schoolName: `TKKM o Tamarongo`, eqiNumber: 562 },
  { schoolNumber: 4226, schoolName: `TKKM o Tamaki Nui A Rua`, eqiNumber: 535 },
  { schoolNumber: 4227, schoolName: `TKKM o Kaikohe`, eqiNumber: 521 },
  {
    schoolNumber: 4228,
    schoolName: `TKKM o Puau Te Moananui-a-Kiwa`,
    eqiNumber: 550,
  },
  { schoolNumber: 4229, schoolName: `TKKM o Manurewa`, eqiNumber: 544 },
  {
    schoolNumber: 4230,
    schoolName: `TKKM o Whakarewa I Te Reo Ki Tuwharetoa`,
    eqiNumber: 516,
  },
  {
    schoolNumber: 4535,
    schoolName: `Te Kura Kaupapa Māori o Hawaiki Hou`,
    eqiNumber: 555,
  },
  { schoolNumber: 4541, schoolName: `The Forest School`, eqiNumber: 462 },
  {
    schoolNumber: 4543,
    schoolName: `Te Kapehu Whetu - Tamaki`,
    eqiNumber: 507,
  },
  { schoolNumber: 4545, schoolName: `Altum Academy`, eqiNumber: 375 },
  {
    schoolNumber: 4546,
    schoolName: `Aotearoa Infinite Academy`,
    eqiNumber: 473,
  },
  { schoolNumber: 4547, schoolName: `Te Aratika High School`, eqiNumber: 561 },
  { schoolNumber: 4548, schoolName: `Sisters United Academy`, eqiNumber: 532 },
  {
    schoolNumber: 4549,
    schoolName: `New Zealand Performance Academy Aotearoa`,
    eqiNumber: 459,
  },
  {
    schoolNumber: 4929,
    schoolName: `Te Au rere a te Tonga Education Programme`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 4934,
    schoolName: `Epuni Education Programme`,
    eqiNumber: 569,
  },
  { schoolNumber: 6070, schoolName: `Golden Sands School`, eqiNumber: 426 },
  {
    schoolNumber: 6109,
    schoolName: `Auckland Secondary Schools' Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6110,
    schoolName: `Awhina School/ Activity Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6111,
    schoolName: `Invercargill Activity Centre`,
    eqiNumber: 569,
  },
  { schoolNumber: 6112, schoolName: `Te Kura o Waipuna` },
  {
    schoolNumber: 6113,
    schoolName: `Papakura Activity Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6116,
    schoolName: `London House Learning Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6117,
    schoolName: `Hutt Valley Activity Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6118,
    schoolName: `Manawatu Community High School - Manawatu Kura a Iwi`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6119,
    schoolName: `Akina School/ Activity Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6124,
    schoolName: `Napier Community High School`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6125,
    schoolName: `Turanganui-A-Kiwa Activity Centre`,
    eqiNumber: 569,
  },
  {
    schoolNumber: 6126,
    schoolName: `Taranaki Activity Centre`,
    eqiNumber: 569,
  },
  { schoolNumber: 6127, schoolName: `Porirua Activity Centre`, eqiNumber: 569 },
  { schoolNumber: 6128, schoolName: `Te Ara`, eqiNumber: 569 },
  { schoolNumber: 6741, schoolName: `Te Matauranga`, eqiNumber: 503 },
  { schoolNumber: 6742, schoolName: `Tahatai Coast School`, eqiNumber: 428 },
  {
    schoolNumber: 6759,
    schoolName: `Snells Beach Primary School`,
    eqiNumber: 437,
  },
  {
    schoolNumber: 6760,
    schoolName: `Somerville Intermediate School`,
    eqiNumber: 387,
  },
  { schoolNumber: 6763, schoolName: `Whangaparaoa College`, eqiNumber: 447 },
  {
    schoolNumber: 6783,
    schoolName: `Remarkables Primary School`,
    eqiNumber: 397,
  },
  {
    schoolNumber: 6788,
    schoolName: `Hobsonville Point Primary School`,
    eqiNumber: 370,
  },
  { schoolNumber: 6920, schoolName: `Gulf Harbour School`, eqiNumber: 414 },
  { schoolNumber: 6921, schoolName: `Point View School`, eqiNumber: 344 },
  { schoolNumber: 6922, schoolName: `Waiheke Primary School`, eqiNumber: 411 },
  { schoolNumber: 6929, schoolName: `Alfriston College`, eqiNumber: 496 },
  {
    schoolNumber: 6930,
    schoolName: `Botany Downs Secondary College`,
    eqiNumber: 403,
  },
  {
    schoolNumber: 6932,
    schoolName: `Pinehill School (Browns Bay)`,
    eqiNumber: 359,
  },
  { schoolNumber: 6937, schoolName: `Summerland Primary`, eqiNumber: 394 },
  { schoolNumber: 6939, schoolName: `Kohia Terrace School`, eqiNumber: 344 },
  {
    schoolNumber: 6940,
    schoolName: `Te Akau ki Papamoa Primary School`,
    eqiNumber: 448,
  },
  { schoolNumber: 6941, schoolName: `Endeavour School`, eqiNumber: 411 },
  { schoolNumber: 6944, schoolName: `Randwick Park School`, eqiNumber: 496 },
  { schoolNumber: 6945, schoolName: `Selwyn Ridge School`, eqiNumber: 449 },
  { schoolNumber: 6946, schoolName: `Oteha Valley School`, eqiNumber: 357 },
  { schoolNumber: 6947, schoolName: `The Gardens School`, eqiNumber: 400 },
  {
    schoolNumber: 6948,
    schoolName: `Albany Junior High School`,
    eqiNumber: 408,
  },
  {
    schoolNumber: 6955,
    schoolName: `Upper Harbour Primary School`,
    eqiNumber: 351,
  },
  {
    schoolNumber: 6959,
    schoolName: `Willowbank School (Howick)`,
    eqiNumber: 374,
  },
  { schoolNumber: 6960, schoolName: `Baverstock Oaks School`, eqiNumber: 388 },
  { schoolNumber: 6962, schoolName: `Te Wharekura o Mauao`, eqiNumber: 522 },
  { schoolNumber: 6963, schoolName: `Papamoa College`, eqiNumber: 458 },
  { schoolNumber: 6967, schoolName: `Lemonwood Grove School`, eqiNumber: 419 },
  { schoolNumber: 6975, schoolName: `Garin College`, eqiNumber: 429 },
  { schoolNumber: 6976, schoolName: `Rototuna Primary School`, eqiNumber: 400 },
  {
    schoolNumber: 6977,
    schoolName: `Hobsonville Point Secondary School`,
    eqiNumber: 430,
  },
  { schoolNumber: 6978, schoolName: `Reremoana School`, eqiNumber: 408 },
  { schoolNumber: 6980, schoolName: `Clearview Primary`, eqiNumber: 414 },
];
